function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _extendStatics = function extendStatics(t, n) {
  return _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, i) {
    e.__proto__ = i;
  } || function (e, i) {
    for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
  }, _extendStatics(t, n);
};
function __extends(t, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  _extendStatics(t, n);
  function e() {
    this.constructor = t;
  }
  t.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
}
var _assign = function __assign() {
  return _assign = Object.assign || function (n) {
    for (var e, i = 1, r = arguments.length; i < r; i++) {
      e = arguments[i];
      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
    }
    return n;
  }, _assign.apply(this, arguments);
};
function __rest(t, n) {
  var e = {};
  for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && n.indexOf(i) < 0 && (e[i] = t[i]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, i = Object.getOwnPropertySymbols(t); r < i.length; r++) n.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (e[i[r]] = t[i[r]]);
  return e;
}
function __awaiter(t, n, e, i) {
  function r(o) {
    return o instanceof e ? o : new e(function (a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function (o, a) {
    function s(d) {
      try {
        u(i.next(d));
      } catch (h) {
        a(h);
      }
    }
    function l(d) {
      try {
        u(i["throw"](d));
      } catch (h) {
        a(h);
      }
    }
    function u(d) {
      d.done ? o(d.value) : r(d.value).then(s, l);
    }
    u((i = i.apply(t, n || [])).next());
  });
}
function __generator(t, n) {
  var e = {
      label: 0,
      sent: function sent() {
        if (o[0] & 1) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    },
    i,
    r,
    o,
    a;
  return a = {
    next: s(0),
    "throw": s(1),
    "return": s(2)
  }, typeof Symbol == "function" && (a[Symbol.iterator] = function () {
    return this;
  }), a;
  function s(u) {
    return function (d) {
      return l([u, d]);
    };
  }
  function l(u) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, u[0] && (e = 0)), e;) try {
      if (i = 1, r && (o = u[0] & 2 ? r["return"] : u[0] ? r["throw"] || ((o = r["return"]) && o.call(r), 0) : r.next) && !(o = o.call(r, u[1])).done) return o;
      switch (r = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return e.label++, {
            value: u[1],
            done: !1
          };
        case 5:
          e.label++, r = u[1], u = [0];
          continue;
        case 7:
          u = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            e = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            e.label = u[1];
            break;
          }
          if (u[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = u;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(u);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      u = n.call(t, e);
    } catch (d) {
      u = [6, d], r = 0;
    } finally {
      i = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return {
      value: u[0] ? u[1] : void 0,
      done: !0
    };
  }
}
function __spreadArray(t, n, e) {
  if (e || arguments.length === 2) for (var i = 0, r = n.length, o; i < r; i++) (o || !(i in n)) && (o || (o = Array.prototype.slice.call(n, 0, i)), o[i] = n[i]);
  return t.concat(o || Array.prototype.slice.call(n));
}
typeof SuppressedError == "function" && SuppressedError;
var Singleton = /** @class */
  function () {
    function t() {
      var n = this.constructor.class_name || this.constructor.name;
      if (t.instances.has(n)) throw new Error("Singleton classes cannot be instantiated more than once.");
      t.instances.set(n, this);
    }
    return t.getInstance = function () {
      for (var n = [], e = 0; e < arguments.length; e++) n[e] = arguments[e];
      var i = this.class_name || this.name;
      if (!t.instances.has(i)) {
        var r = new (this.bind.apply(this, __spreadArray([void 0], n, !1)))();
        t.instances.set(i, r);
      }
      return t.instances.get(i);
    }, t.instances = /* @__PURE__ */new Map(), t;
  }(),
  is_local_dev = function is_local_dev() {
    var t = location.hostname,
      n = t.split(".").every(function (e) {
        return /^[0-9]*$/gi.test(e);
      });
    return n || ["localhost"].some(function (e) {
      return t.includes(e);
    });
  },
  EnvController = /** @class */
  function (t) {
    __extends(n, t);
    function n() {
      return t.call(this) || this;
    }
    return Object.defineProperty(n.prototype, "env", {
      get: function get() {
        return this._env ? this._env : is_local_dev() ? "dev" : location.origin.includes("test") ? "test" : "prod";
      },
      set: function set(e) {
        this._env = e;
      },
      enumerable: !1,
      configurable: !0
    }), n.class_name = "EnvController", n;
  }(Singleton),
  ENV$1 = function ENV$1() {
    return EnvController.getInstance().env;
  },
  isInPrerenderServe = function isInPrerenderServe() {
    return !!window.__IS_CMS_DATA_PREINJECT__;
  },
  Version = "0.2.12",
  DEFAULT_RUM_ID = "ZEn5JcvaJYEW3WbWJP",
  DEFAULT_RUM_HOST = "https://rumt-sg.com",
  WebShareChannel;
(function (t) {
  t.Facebook = "facebook", t.Twitter = "twitter", t.VK = "vk", t.Kakao = "kakao";
})(WebShareChannel || (WebShareChannel = {}));
var ExtraWebShareChannel;
(function (t) {
  t.Reddit = "reddit", t.Line = "line", t.Whatsapp = "whatsapp";
})(ExtraWebShareChannel || (ExtraWebShareChannel = {}));
var _a$2,
  INTL_CDN_URLS = {
    dev: "https://common-web.intlgame.com/sdk-cdn/account-api/v2/index.umd.js",
    test: "https://common-web.intlgame.com/sdk-cdn/account-api/v2/index.umd.js",
    prod: "https://common-web.intlgame.com/sdk-cdn/account-api/v2/index.umd.js"
  },
  CMS_SERVE = {
    na: "https://na-community.playerinfinite.com",
    sg: "https://sg-community.playerinfinite.com"
  },
  GET_CMS_ADMIN_ORIGIN = function GET_CMS_ADMIN_ORIGIN(t) {
    return "https://".concat(t, "-cms.levelinfiniteapps.com");
  },
  EMAIL_SVR_URLS = {
    apply: "/v1/official/apply",
    unsubscribe: "/v1/official/unapply"
  },
  FB_SHARE_LEGACY_URL = "https://www.facebook.com/sharer/sharer.php",
  DeepLinkForShare = (_a$2 = {},
  // {@see https://developers.line.biz/en/docs/line-login/using-line-url-scheme/}
  _a$2[ExtraWebShareChannel.Line] = "https://line.me/R/share", _a$2[ExtraWebShareChannel.Reddit] = "https://www.reddit.com/submit", _a$2[ExtraWebShareChannel.Whatsapp] = "https://wa.me", _a$2),
  ACTIVITY_URLS = {
    register: "/api/gpts.information_feeds_svr.InformationFeedsSvr/RegisterReport",
    get_user_info: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetRegisterInfo",
    smartlink_subscribe: "/api/gpts.information_feeds_svr.InformationFeedsSvr/SmartLinkReport",
    get_smartlink_info: "/api/gpts.information_feeds_svr.InformationFeedsSvr/SmartLinkUserInfo",
    smartlink_sync_user_by_email: "/api/gpts.information_feeds_svr.InformationFeedsSvr/SmartLinkSyncUserByEmail"
  },
  CMS_URLS = {
    get_activity_info: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetCampaignCfg",
    get_label_list_by_group: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetContentLabelsByGroupId",
    get_label_list: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetContentLabelList",
    get_feeds_detail: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetContentInfoById",
    get_feeds_by_search: "/api/gpts.information_feeds_svr.InformationFeedsSvr/SearchInfoFeeds",
    get_group_feeds_detail: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetGroupContentListById",
    get_columns: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetLabelList",
    get_backgrounds: "/api/gpts.information_feeds_svr.InformationFeedsSvr/CommunityMediaGetBackGroundBatch",
    get_reserve_number: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetReserveNumber",
    get_cos_upload_url: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetUploadUrl",
    tlog_report: "/api/gpts_community.report_svr.ReportSvr/ReportStatInfo",
    get_random_code: "/api/gpts.information_feeds_svr.InformationFeedsSvr/PreRegister",
    get_feeds_by_cloumn: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetContentByLabel",
    verify_login: "/api/gpts.information_feeds_svr.InformationFeedsSvr/VerifyIntlLogin",
    pa_tecent_captcha_verify: "/api/gpts.information_feeds_svr.InformationFeedsSvr/CaptchaCheck",
    pa_google_recaptcha: "/api/gpts.information_feeds_svr.InformationFeedsSvr/CaptchaVerify",
    pa_official_apply: "/api/gpts.information_feeds_svr.InformationFeedsSvr/OfficialApply",
    pa_official_unapply: "/api/gpts.information_feeds_svr.InformationFeedsSvr/OfficialUnEmail",
    pa_login_by_intl_encode: "/api/gpts.auth_svr.AuthSvr/LoginByINTLEncode",
    pa_login_by_intl_token: "/api/gpts.auth_svr.AuthSvr/LoginByINTL",
    like_content: "/api/gpts.user_like_svr.Like/LikeOper",
    report_user_action: "/api/gpts.information_feeds_svr.InformationFeedsSvr/ReportUserAction",
    batch_get_like_status: "/api/gpts.user_like_svr.Like/GetLikeInfoByContentIDBatch",
    // 游戏库相关
    get_game_library: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetGameLibraryData",
    get_game_data: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetGameData",
    get_game_shop_list: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetGameShopList",
    get_game_shop_info: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetGameShopInfo",
    //媒体库相关
    get_media_data: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetMediaData",
    get_media_label_list: "/api/gpts.information_feeds_svr.InformationFeedsSvr/GetMediaLabels"
  },
  AIHELP_CDN = "https://aihelp.net/webchat/aihelp.js",
  TENCENT_CAPTCHA_CDN = "https://sg.captcha.qcloud.com/TCaptcha-global.js",
  VCONSOLE_CDN = "https://unpkg.com/vconsole@latest/dist/vconsole.min.js",
  commonjsGlobal = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window : (typeof global === "undefined" ? "undefined" : _typeof(global)) < "u" ? global : (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" ? self : {},
  eventemitter3Exports = {},
  eventemitter3 = {
    get exports() {
      return eventemitter3Exports;
    },
    set exports(t) {
      eventemitter3Exports = t;
    }
  };
(function (t) {
  var n = Object.prototype.hasOwnProperty,
    e = "~";
  function i() {}
  Object.create && (i.prototype = /* @__PURE__ */Object.create(null), new i().__proto__ || (e = !1));
  function r(l, u, d) {
    this.fn = l, this.context = u, this.once = d || !1;
  }
  function o(l, u, d, h, p) {
    if (typeof d != "function") throw new TypeError("The listener must be a function");
    var m = new r(d, h || l, p),
      R = e ? e + u : u;
    return l._events[R] ? l._events[R].fn ? l._events[R] = [l._events[R], m] : l._events[R].push(m) : (l._events[R] = m, l._eventsCount++), l;
  }
  function a(l, u) {
    --l._eventsCount === 0 ? l._events = new i() : delete l._events[u];
  }
  function s() {
    this._events = new i(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function () {
    var u = [],
      d,
      h;
    if (this._eventsCount === 0) return u;
    for (h in d = this._events) n.call(d, h) && u.push(e ? h.slice(1) : h);
    return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(d)) : u;
  }, s.prototype.listeners = function (u) {
    var d = e ? e + u : u,
      h = this._events[d];
    if (!h) return [];
    if (h.fn) return [h.fn];
    for (var p = 0, m = h.length, R = new Array(m); p < m; p++) R[p] = h[p].fn;
    return R;
  }, s.prototype.listenerCount = function (u) {
    var d = e ? e + u : u,
      h = this._events[d];
    return h ? h.fn ? 1 : h.length : 0;
  }, s.prototype.emit = function (u, d, h, p, m, R) {
    var T = e ? e + u : u;
    if (!this._events[T]) return !1;
    var O = this._events[T],
      N = arguments.length,
      y,
      f;
    if (O.fn) {
      switch (O.once && this.removeListener(u, O.fn, void 0, !0), N) {
        case 1:
          return O.fn.call(O.context), !0;
        case 2:
          return O.fn.call(O.context, d), !0;
        case 3:
          return O.fn.call(O.context, d, h), !0;
        case 4:
          return O.fn.call(O.context, d, h, p), !0;
        case 5:
          return O.fn.call(O.context, d, h, p, m), !0;
        case 6:
          return O.fn.call(O.context, d, h, p, m, R), !0;
      }
      for (f = 1, y = new Array(N - 1); f < N; f++) y[f - 1] = arguments[f];
      O.fn.apply(O.context, y);
    } else {
      var g = O.length,
        E;
      for (f = 0; f < g; f++) switch (O[f].once && this.removeListener(u, O[f].fn, void 0, !0), N) {
        case 1:
          O[f].fn.call(O[f].context);
          break;
        case 2:
          O[f].fn.call(O[f].context, d);
          break;
        case 3:
          O[f].fn.call(O[f].context, d, h);
          break;
        case 4:
          O[f].fn.call(O[f].context, d, h, p);
          break;
        default:
          if (!y) for (E = 1, y = new Array(N - 1); E < N; E++) y[E - 1] = arguments[E];
          O[f].fn.apply(O[f].context, y);
      }
    }
    return !0;
  }, s.prototype.on = function (u, d, h) {
    return o(this, u, d, h, !1);
  }, s.prototype.once = function (u, d, h) {
    return o(this, u, d, h, !0);
  }, s.prototype.removeListener = function (u, d, h, p) {
    var m = e ? e + u : u;
    if (!this._events[m]) return this;
    if (!d) return a(this, m), this;
    var R = this._events[m];
    if (R.fn) R.fn === d && (!p || R.once) && (!h || R.context === h) && a(this, m);else {
      for (var T = 0, O = [], N = R.length; T < N; T++) (R[T].fn !== d || p && !R[T].once || h && R[T].context !== h) && O.push(R[T]);
      O.length ? this._events[m] = O.length === 1 ? O[0] : O : a(this, m);
    }
    return this;
  }, s.prototype.removeAllListeners = function (u) {
    var d;
    return u ? (d = e ? e + u : u, this._events[d] && a(this, d)) : (this._events = new i(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = e, s.EventEmitter = s, t.exports = s;
})(eventemitter3);
var EventEmitter = eventemitter3Exports;
var IntlCMD;
(function (t) {
  t.SET_FULLSCREEN = "setFullScreen", t.CLOSE_WEBVIEW = "closeWebView", t.SET_ORIENTATION = "setScreenOrientation", t.OPEN_BROWSER = "OpenUrlInINTLBrowser", t.OPEN_SAFARI = "openURLInSafari", t.CLEAR_WEBVIEW_FOCUS = "clearWebViewFocus", t.DETECT_APP_INSTALLED = "isAppInstalled", t.SHARE = "shareWebView", t.SEND_MSG = "sendMsgWebView";
})(IntlCMD || (IntlCMD = {}));
var ShareContentType;
(function (t) {
  t[t.REQ_TEXT = 1e4] = "REQ_TEXT", t[t.REQ_LINK = 10001] = "REQ_LINK", t[t.REQ_IMAGE = 10002] = "REQ_IMAGE", t[t.REQ_INVITE = 10003] = "REQ_INVITE", t[t.REQ_VIDEO = 10004] = "REQ_VIDEO";
})(ShareContentType || (ShareContentType = {}));
var InGameChannel;
(function (t) {
  t.Facebook = "Facebook", t.VK = "VK", t.Discord = "Discord", t.QQ = "QQ", t.Line = "Line", t.Twitter = "Twitter", t.Garena = "Garena", t.Instagram = "Instagram", t.Whatsapp = "Whatsapp", t.FacebookGaming = "Facebook-Gaming";
})(InGameChannel || (InGameChannel = {}));
var LIBVERSION = "2.0.0-alpha.2",
  EMPTY = "",
  UNKNOWN = "?",
  FUNC_TYPE = "function",
  UNDEF_TYPE = "undefined",
  OBJ_TYPE = "object",
  STR_TYPE = "string",
  MAJOR = "major",
  MODEL = "model",
  NAME = "name",
  TYPE = "type",
  VENDOR = "vendor",
  VERSION = "version",
  ARCHITECTURE = "architecture",
  CONSOLE = "console",
  MOBILE = "mobile",
  TABLET = "tablet",
  SMARTTV = "smarttv",
  WEARABLE = "wearable",
  EMBEDDED = "embedded",
  USER_AGENT = "user-agent",
  UA_MAX_LENGTH = 350,
  BRANDS = "brands",
  FULLVERLIST = "fullVersionList",
  PLATFORM = "platform",
  PLATFORMVER = "platformVersion",
  BITNESS = "bitness",
  CH_HEADER = "sec-ch-ua",
  CH_HEADER_FULL_VER_LIST = CH_HEADER + "-full-version-list",
  CH_HEADER_ARCH = CH_HEADER + "-arch",
  CH_HEADER_BITNESS = CH_HEADER + "-bitness",
  CH_HEADER_MOBILE = CH_HEADER + "-mobile",
  CH_HEADER_MODEL = CH_HEADER + "-model",
  CH_HEADER_PLATFORM = CH_HEADER + "-platform",
  CH_HEADER_PLATFORM_VER = CH_HEADER_PLATFORM + "-version",
  CH_ALL_VALUES = ["brands", "fullVersionList", MOBILE, MODEL, "platform", "platformVersion", ARCHITECTURE, "bitness"],
  UA_BROWSER = "browser",
  UA_CPU = "cpu",
  UA_DEVICE = "device",
  UA_ENGINE = "engine",
  UA_OS = "os",
  UA_RESULT = "result",
  AMAZON = "Amazon",
  APPLE = "Apple",
  ASUS = "ASUS",
  BLACKBERRY = "BlackBerry",
  GOOGLE = "Google",
  HUAWEI = "Huawei",
  LG = "LG",
  MICROSOFT = "Microsoft",
  MOTOROLA = "Motorola",
  SAMSUNG = "Samsung",
  SHARP = "Sharp",
  SONY = "Sony",
  XIAOMI = "Xiaomi",
  ZEBRA = "Zebra",
  PREFIX_MOBILE = "Mobile ",
  SUFFIX_BROWSER = " Browser",
  CHROME = "Chrome",
  EDGE = "Edge",
  FIREFOX = "Firefox",
  OPERA = "Opera",
  FACEBOOK = "Facebook",
  WINDOWS = "Windows",
  assignFromEntries = function assignFromEntries(t) {
    for (var n in t) {
      var e = t[n];
      _typeof(e) == OBJ_TYPE && e.length == 2 ? this[e[0]] = e[1] : this[e] = void 0;
    }
    return this;
  },
  extend = function extend(t, n) {
    var e = {};
    for (var i in t) e[i] = n[i] && n[i].length % 2 === 0 ? n[i].concat(t[i]) : t[i];
    return e;
  },
  enumerize = function enumerize(t) {
    for (var n = {}, e = 0; e < t.length; e++) n[t[e].toUpperCase()] = t[e];
    return n;
  },
  has = function has(t, n) {
    if (_typeof(t) === OBJ_TYPE && t.length > 0) {
      for (var e in t) if (lowerize(t[e]) == lowerize(n)) return !0;
      return !1;
    }
    return _typeof(t) === STR_TYPE ? lowerize(n).indexOf(lowerize(t)) !== -1 : !1;
  },
  isExtensions = function isExtensions(t) {
    for (var n in t) return /^(browser|cpu|device|engine|os)$/.test(n);
  },
  itemListToArray = function itemListToArray(t) {
    if (t) {
      for (var n = [], e = strip(/\\?\"/g, t).split(", "), i = 0; i < e.length; i++) {
        var r = e[i].split(";v=");
        n[i] = {
          brand: r[0],
          version: r[1]
        };
      }
      return n;
    }
  },
  lowerize = function lowerize(t) {
    return _typeof(t) === STR_TYPE ? t.toLowerCase() : t;
  },
  majorize = function majorize(t) {
    return _typeof(t) === STR_TYPE ? strip(/[^\d\.]/g, t).split(".")[0] : void 0;
  },
  strip = function strip(t, n) {
    return n.replace(t, EMPTY);
  },
  stripQuotes = function stripQuotes(t) {
    return _typeof(t) === STR_TYPE ? strip(/\"/g, t) : t;
  },
  trim = function trim(t, n) {
    if (_typeof(t) === STR_TYPE) return t = strip(/^\s\s*/, t), _typeof(n) === UNDEF_TYPE ? t : t.substring(0, UA_MAX_LENGTH);
  },
  rgxMapper = function rgxMapper(t, n) {
    if (!(!t || !n)) for (var e = 0, i, r, o, a, s, l; e < n.length && !s;) {
      var u = n[e],
        d = n[e + 1];
      for (i = r = 0; i < u.length && !s && u[i];) if (s = u[i++].exec(t), s) for (o = 0; o < d.length; o++) l = s[++r], a = d[o], _typeof(a) === OBJ_TYPE && a.length > 0 ? a.length === 2 ? _typeof(a[1]) == FUNC_TYPE ? this[a[0]] = a[1].call(this, l) : this[a[0]] = a[1] : a.length === 3 ? _typeof(a[1]) === FUNC_TYPE && !(a[1].exec && a[1].test) ? this[a[0]] = l ? a[1].call(this, l, a[2]) : void 0 : this[a[0]] = l ? l.replace(a[1], a[2]) : void 0 : a.length === 4 && (this[a[0]] = l ? a[3].call(this, l.replace(a[1], a[2])) : void 0) : this[a] = l || void 0;
      e += 2;
    }
  },
  strMapper = function strMapper(t, n) {
    for (var e in n) if (_typeof(n[e]) === OBJ_TYPE && n[e].length > 0) {
      for (var i = 0; i < n[e].length; i++) if (has(n[e][i], t)) return e === UNKNOWN ? void 0 : e;
    } else if (has(n[e], t)) return e === UNKNOWN ? void 0 : e;
    return t;
  },
  oldSafariMap = {
    "1.0": "/8",
    "1.2": "/1",
    "1.3": "/3",
    "2.0": "/412",
    "2.0.2": "/416",
    "2.0.3": "/417",
    "2.0.4": "/419",
    "?": "/"
  },
  windowsVersionMap = {
    ME: "4.90",
    "NT 3.11": "NT3.51",
    "NT 4.0": "NT4.0",
    2e3: "NT 5.0",
    XP: ["NT 5.1", "NT 5.2"],
    Vista: "NT 6.0",
    7: "NT 6.1",
    8: "NT 6.2",
    "8.1": "NT 6.3",
    10: ["NT 6.4", "NT 10.0"],
    RT: "ARM"
  },
  defaultRegexes = {
    browser: [[
    // Most common regardless engine
    /\b(?:crmo|crios)\/([\w\.]+)/i
    // Chrome for Android/iOS
    ], [VERSION, [NAME, PREFIX_MOBILE + "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i
    // Microsoft Edge
    ], [VERSION, [NAME, "Edge"]], [
    // Presto based
    /(opera mini)\/([-\w\.]+)/i,
    // Opera Mini
    /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
    // Opera Mobi/Tablet
    /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
    // Opera
    ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i
    // Opera mini on iphone >= 8.0
    ], [VERSION, [NAME, OPERA + " Mini"]], [/\bopr\/([\w\.]+)/i
    // Opera Webkit
    ], [VERSION, [NAME, OPERA]], [
    // Mixed
    /(kindle)\/([\w\.]+)/i,
    // Kindle
    /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
    // Lunascape/Maxthon/Netfront/Jasmine/Blazer
    // Trident based
    /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
    // Avant/IEMobile/SlimBrowser
    /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
    // Baidu Browser
    /(?:ms|\()(ie) ([\w\.]+)/i,
    // Internet Explorer
    // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
    /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
    // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo
    /(heytap|ovi)browser\/([\d\.]+)/i,
    // HeyTap/Ovi
    /(weibo)__([\d\.]+)/i
    // Weibo
    ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
    // UCBrowser
    ], [VERSION, [NAME, "UCBrowser"]], [/microm.+\bqbcore\/([\w\.]+)/i,
    // WeChat Desktop for Windows Built-in Browser
    /\bqbcore\/([\w\.]+).+microm/i], [VERSION, [NAME, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i
    // WeChat
    ], [VERSION, [NAME, "WeChat"]], [/konqueror\/([\w\.]+)/i
    // Konqueror
    ], [VERSION, [NAME, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
    // IE11
    ], [VERSION, [NAME, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i
    // Yandex
    ], [VERSION, [NAME, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i
    // Avast/AVG Secure Browser
    ], [[NAME, /(.+)/, "$1 Secure" + SUFFIX_BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i
    // Firefox Focus
    ], [VERSION, [NAME, FIREFOX + " Focus"]], [/\bopt\/([\w\.]+)/i
    // Opera Touch
    ], [VERSION, [NAME, OPERA + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i
    // Coc Coc Browser
    ], [VERSION, [NAME, "Coc Coc"]], [/dolfin\/([\w\.]+)/i
    // Dolphin
    ], [VERSION, [NAME, "Dolphin"]], [/coast\/([\w\.]+)/i
    // Opera Coast
    ], [VERSION, [NAME, OPERA + " Coast"]], [/miuibrowser\/([\w\.]+)/i
    // MIUI Browser
    ], [VERSION, [NAME, "MIUI" + SUFFIX_BROWSER]], [/fxios\/([\w\.-]+)/i
    // Firefox for iOS
    ], [VERSION, [NAME, PREFIX_MOBILE + FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i
    // 360
    ], [[NAME, "360" + SUFFIX_BROWSER]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[NAME, /(.+)/, "$1" + SUFFIX_BROWSER], VERSION], [
    // Oculus/Samsung/Sailfish/Huawei Browser
    /(comodo_dragon)\/([\w\.]+)/i
    // Comodo Dragon
    ], [[NAME, /_/g, " "], VERSION], [/(electron)\/([\w\.]+) safari/i,
    // Electron-based App
    /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
    // Tesla
    /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
    // QQBrowser/Baidu App/2345 Browser
    ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i,
    // SouGouBrowser
    /(lbbrowser)/i,
    // LieBao Browser
    /\[(linkedin)app\]/i
    // LinkedIn App for iOS & Android
    ], [NAME], [
    // WebView
    /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
    // Facebook App for iOS & Android
    ], [[NAME, FACEBOOK], VERSION], [/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
    // Kakao App
    /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
    // Naver InApp
    /safari (line)\/([\w\.]+)/i,
    // Line App for iOS
    /\b(line)\/([\w\.]+)\/iab/i,
    // Line App for Android
    /(chromium|instagram)[\/ ]([-\w\.]+)/i
    // Chromium/Instagram
    ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i
    // Google Search Appliance on iOS
    ], [VERSION, [NAME, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
    // TikTok
    ], [VERSION, [NAME, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i
    // Chrome Headless
    ], [VERSION, [NAME, CHROME + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i
    // Chrome WebView
    ], [[NAME, CHROME + " WebView"], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
    // Android Browser
    ], [VERSION, [NAME, "Android" + SUFFIX_BROWSER]], [/chrome\/([\w\.]+) mobile/i
    // Chrome Mobile
    ], [VERSION, [NAME, PREFIX_MOBILE + "Chrome"]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
    // Chrome/OmniWeb/Arora/Tizen/Nokia
    ], [NAME, VERSION], [/version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
    // Safari Mobile
    ], [VERSION, [NAME, PREFIX_MOBILE + "Safari"]], [/iphone .*mobile(?:\/\w+ | ?)safari/i], [[NAME, PREFIX_MOBILE + "Safari"]], [/version\/([\w\.\,]+) .*(safari)/i
    // Safari
    ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
    // Safari < 3.0
    ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [
    // Gecko based
    /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
    // Firefox Mobile
    ], [[NAME, PREFIX_MOBILE + FIREFOX], VERSION], [/(navigator|netscape\d?)\/([-\w\.]+)/i
    // Netscape
    ], [[NAME, "Netscape"], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i
    // Firefox Reality
    ], [VERSION, [NAME, FIREFOX + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i,
    // Flow
    /(swiftfox)/i,
    // Swiftfox
    /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
    // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
    /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
    // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
    /(firefox)\/([\w\.]+)/i,
    // Other Firefox-based
    /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
    // Mozilla
    // Other
    /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
    // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
    /(links) \(([\w\.]+)/i,
    // Links
    /panasonic;(viera)/i
    // Panasonic Viera
    ], [NAME, VERSION], [/(cobalt)\/([\w\.]+)/i
    // Cobalt
    ], [NAME, [VERSION, /[^\d\.]+./, EMPTY]]],
    cpu: [[/\b(?:(amd|x|x86[-_]?|wow|win)64)\b/i
    // AMD64 (x64)
    ], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i,
    // IA32 (quicktime)
    /((?:i[346]|x)86)[;\)]/i
    // IA32 (x86)
    ], [[ARCHITECTURE, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i
    // ARM64
    ], [[ARCHITECTURE, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
    // ARMHF
    ], [[ARCHITECTURE, "armhf"]], [
    // PocketPC mistakenly identified as PowerPC
    /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
    // PowerPC
    ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i
    // SPARC
    ], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
    // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    ], [[ARCHITECTURE, lowerize]]],
    device: [[
    //////////////////////////
    // MOBILES & TABLETS
    /////////////////////////
    // Samsung
    /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [
    // Apple
    /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
    // iPod/iPhone
    ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i,
    // iPad
    /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/(macintosh);/i], [MODEL, [VENDOR, APPLE]], [
    // Sharp
    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [
    // Huawei
    /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [
    // Xiaomi
    /\b(poco[\w ]+)(?: bui|\))/i,
    // Xiaomi POCO
    /\b; (\w+) build\/hm\1/i,
    // Xiaomi Hongmi 'numeric' models
    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
    // Xiaomi Hongmi
    /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
    // Xiaomi Redmi
    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
    // Xiaomi Mi
    ], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
    // Mi Pad tablets
    ], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]], [
    // OPPO
    /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]], [
    // Vivo
    /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]], [
    // Realme
    /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]], [
    // Motorola
    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [
    // LG
    /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [
    // Lenovo
    /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [
    // Nokia
    /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]], [
    // Google
    /(pixel c)\b/i
    // Google Pixel C
    ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
    // Google Pixel
    ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [
    // Sony
    /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]], [
    // OnePlus
    / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [
    // Amazon
    /(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
    // Kindle Fire without Silk / Echo Show
    /(kf[a-z]+)( bui|\)).+silk\//i
    // Kindle Fire HD
    ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
    // Fire Phone
    ], [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]], [
    // BlackBerry
    /(playbook);[-\w\),; ]+(rim)/i
    // BlackBerry PlayBook
    ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i
    // BlackBerry 10
    ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [
    // Asus
    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [
    // HTC
    /(nexus 9)/i
    // HTC Nexus 9
    ], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
    // HTC
    // ZTE
    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
    // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [
    // Acer
    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [
    // Meizu
    /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]], [
    // MIXED
    /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
    // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
    /(hp) ([\w ]+\w)/i,
    // HP iPAQ
    /(asus)-?(\w+)/i,
    // Asus
    /(microsoft); (lumia[\w ]+)/i,
    // Microsoft Lumia
    /(lenovo)[-_ ]?([-\w]+)/i,
    // Lenovo
    /(jolla)/i,
    // Jolla
    /(oppo) ?([\w ]+) bui/i
    // OPPO
    ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kobo)\s(ereader|touch)/i,
    // Kobo
    /(archos) (gamepad2?)/i,
    // Archos
    /(hp).+(touchpad(?!.+tablet)|tablet)/i,
    // HP TouchPad
    /(kindle)\/([\w\.]+)/i
    // Kindle
    ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i
    // Surface Duo
    ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i
    // Fairphone
    ], [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]], [/(shield[\w ]+) b/i
    // Nvidia Shield Tablets
    ], [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]], [/(sprint) (\w+)/i
    // Sprint Phones
    ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i
    // Microsoft Kin
    ], [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
    // Zebra
    ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [
    ///////////////////
    // SMARTTVS
    ///////////////////
    /smart-tv.+(samsung)/i
    // Samsung
    ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
    // LG SmartTV
    ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i
    // Apple TV
    ], [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]], [/crkey/i
    // Google Chromecast
    ], [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i
    // Fire TV
    ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i
    // Sharp
    ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]], [/(bravia[\w ]+)( bui|\))/i
    // Sony
    ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [/(mitv-\w{5}) bui/i
    // Xiaomi
    ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [/Hbbtv.*(technisat) (.*);/i
    // TechniSAT
    ], [VENDOR, MODEL, [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
    // Roku
    /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
    // HbbTV devices
    ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
    // SmartTV from Unidentified Vendors
    ], [[TYPE, SMARTTV]], [
    ///////////////////
    // CONSOLES
    ///////////////////
    /(ouya)/i,
    // Ouya
    /(nintendo) (\w+)/i
    // Nintendo
    ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i
    // Nvidia
    ], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation \w+)/i
    // Playstation
    ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i
    // Microsoft Xbox
    ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [
    ///////////////////
    // WEARABLES
    ///////////////////
    /((pebble))app/i
    // Pebble
    ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
    // Apple Watch
    ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [/droid.+; (glass) \d/i
    // Google Glass
    ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( 2| pro)?)/i
    // Oculus Quest
    ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [
    ///////////////////
    // EMBEDDED
    ///////////////////
    /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
    // Tesla
    ], [VENDOR, [TYPE, EMBEDDED]], [/(aeobc)\b/i
    // Echo Dot
    ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [
    ////////////////////
    // MIXED (GENERIC)
    ///////////////////
    /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
    // Android Phones from Unidentified Vendors
    ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
    // Android Tablets from Unidentified Vendors
    ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
    // Unidentifiable Tablet
    ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
    // Unidentifiable Mobile
    ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i
    // Generic Android Device
    ], [MODEL, [VENDOR, "Generic"]]],
    engine: [[/windows.+ edge\/([\w\.]+)/i
    // EdgeHTML
    ], [VERSION, [NAME, EDGE + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
    // Blink
    ], [VERSION, [NAME, "Blink"]], [/(presto)\/([\w\.]+)/i,
    // Presto
    /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
    // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
    /ekioh(flow)\/([\w\.]+)/i,
    // Flow
    /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
    // KHTML/Tasman/Links
    /(icab)[\/ ]([23]\.[\d\.]+)/i,
    // iCab
    /\b(libweb)/i], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i
    // Gecko
    ], [VERSION, NAME]],
    os: [[
    // Windows
    /microsoft (windows) (vista|xp)/i
    // Windows (iTunes)
    ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i,
    // Windows RT
    /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
    // Windows Phone
    /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, WINDOWS], [VERSION, strMapper, windowsVersionMap]], [
    // iOS/macOS
    /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
    // iOS
    /ios;fbsv\/([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i
    // Mac OS
    ], [[NAME, "macOS"], [VERSION, /_/g, "."]], [
    // Mobile OSes
    /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
    // Android-x86/HarmonyOS
    ], [VERSION, NAME], [
    // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
    /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i,
    // Blackberry
    /(tizen|kaios)[\/ ]([\w\.]+)/i,
    // Tizen/KaiOS
    /\((series40);/i
    // Series 40
    ], [NAME, VERSION], [/\(bb(10);/i
    // BlackBerry 10
    ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
    // Symbian
    ], [VERSION, [NAME, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
    // Firefox OS
    ], [VERSION, [NAME, FIREFOX + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
    // WebOS
    ], [VERSION, [NAME, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
    // watchOS
    ], [VERSION, [NAME, "watchOS"]], [
    // Google Chromecast
    /crkey\/([\d\.]+)/i
    // Google Chromecast
    ], [VERSION, [NAME, CHROME + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
    // Chromium OS
    ], [[NAME, "Chrome OS"], VERSION], [
    // Smart TVs
    /panasonic;(viera)/i,
    // Panasonic Viera
    /(netrange)mmh/i,
    // Netrange
    /(nettv)\/(\d+\.[\w\.]+)/i,
    // NetTV
    // Console
    /(nintendo|playstation) (\w+)/i,
    // Nintendo/Playstation
    /(xbox); +xbox ([^\);]+)/i,
    // Microsoft Xbox (360, One, X, S, Series X, Series S)
    // Other
    /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
    // Joli/Palm
    /(mint)[\/\(\) ]?(\w*)/i,
    // Mint
    /(mageia|vectorlinux)[; ]/i,
    // Mageia/VectorLinux
    /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
    // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
    /(hurd|linux) ?([\w\.]*)/i,
    // Hurd/Linux
    /(gnu) ?([\w\.]*)/i,
    // GNU
    /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
    // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
    /(haiku) (\w+)/i
    // Haiku
    ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i
    // Solaris
    ], [[NAME, "Solaris"], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
    // Solaris
    /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
    // AIX
    /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
    // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
    /(unix) ?([\w\.]*)/i
    // UNIX
    ], [NAME, VERSION]]
  },
  defaultProps = function () {
    var t = {
      init: {},
      isIgnore: {},
      isIgnoreRgx: {},
      toString: {}
    };
    return assignFromEntries.call(t.init, [[UA_BROWSER, [NAME, VERSION, MAJOR]], [UA_CPU, [ARCHITECTURE]], [UA_DEVICE, [TYPE, MODEL, VENDOR]], [UA_ENGINE, [NAME, VERSION]], [UA_OS, [NAME, VERSION]]]), assignFromEntries.call(t.isIgnore, [[UA_BROWSER, [VERSION, MAJOR]], [UA_ENGINE, [VERSION]], [UA_OS, [VERSION]]]), assignFromEntries.call(t.isIgnoreRgx, [[UA_BROWSER, / ?browser$/i], [UA_OS, / ?os$/i]]), assignFromEntries.call(t.toString, [[UA_BROWSER, [NAME, VERSION]], [UA_CPU, [ARCHITECTURE]], [UA_DEVICE, [VENDOR, MODEL]], [UA_ENGINE, [NAME, VERSION]], [UA_OS, [NAME, VERSION]]]), t;
  }(),
  createUAParserData = function createUAParserData(t, n, e, i) {
    var r = defaultProps.init[t],
      o = defaultProps.isIgnore[t] || 0,
      a = defaultProps.isIgnoreRgx[t] || 0,
      s = defaultProps.toString[t] || 0;
    function l() {
      assignFromEntries.call(this, r);
    }
    return l.prototype.withClientHints = function () {
      return new UAParserItem(t, n, e, i).parseCH().get();
    }, t != UA_RESULT && (l.prototype.is = function (u) {
      var d = !1;
      for (var h in this) if (this.hasOwnProperty(h) && !has(o, h) && lowerize(a ? strip(a, this[h]) : this[h]) == lowerize(a ? strip(a, u) : u)) {
        if (d = !0, u != UNDEF_TYPE) break;
      } else if (u == UNDEF_TYPE && d) {
        d = !d;
        break;
      }
      return d;
    }, l.prototype.toString = function () {
      var u = EMPTY;
      for (var d in s) _typeof(this[s[d]]) !== UNDEF_TYPE && (u += (u ? " " : EMPTY) + this[s[d]]);
      return u || UNDEF_TYPE;
    }), l.prototype.then = function (u) {
      var d = this,
        h = function h() {
          for (var m in d) d.hasOwnProperty(m) && (this[m] = d[m]);
        };
      h.prototype = {
        is: l.prototype.is,
        toString: l.prototype.toString
      };
      var p = new h();
      return u(p), p;
    }, new l();
  };
function UAParserDataCH(t, n) {
  if (t = t || {}, assignFromEntries.call(this, CH_ALL_VALUES), n) assignFromEntries.call(this, [[BRANDS, itemListToArray(t[CH_HEADER])], [FULLVERLIST, itemListToArray(t[CH_HEADER_FULL_VER_LIST])], [BRANDS, itemListToArray(t[CH_HEADER])], [MOBILE, /\?1/.test(t[CH_HEADER_MOBILE])], [MODEL, stripQuotes(t[CH_HEADER_MODEL])], [PLATFORM, stripQuotes(t[CH_HEADER_PLATFORM])], [PLATFORMVER, stripQuotes(t[CH_HEADER_PLATFORM_VER])], [ARCHITECTURE, stripQuotes(t[CH_HEADER_ARCH])], [BITNESS, stripQuotes(t[CH_HEADER_BITNESS])]]);else for (var e in t) this.hasOwnProperty(e) && _typeof(t[e]) !== UNDEF_TYPE && (this[e] = t[e]);
  return this;
}
function UAParserItem(t, n, e, i) {
  switch (assignFromEntries.call(this, [["itemType", t], ["ua", n], ["uaCH", i], ["rgxMap", e], ["data", createUAParserData(t, n, e, i)]]), this.parse(), this.itemType) {
    case UA_BROWSER:
      this.set(MAJOR, majorize(this.get(VERSION)));
      break;
    case UA_DEVICE:
      break;
    case UA_OS:
      break;
    case UA_RESULT:
      var r = function r(o) {
        return new UAParserItem(o, n, e[o], i).get();
      };
      this.set("ua", n).set(UA_BROWSER, r(UA_BROWSER)).set(UA_CPU, r(UA_CPU)).set(UA_DEVICE, r(UA_DEVICE)).set(UA_ENGINE, r(UA_ENGINE)).set(UA_OS, r(UA_OS)).get();
  }
  return this;
}
UAParserItem.prototype.get = function (t) {
  return t ? this.data.hasOwnProperty(t) ? this.data[t] : void 0 : this.data;
};
UAParserItem.prototype.parse = function () {
  return this.itemType != UA_RESULT && rgxMapper.call(this.data, this.ua, this.rgxMap), this;
};
UAParserItem.prototype.parseCH = function () {
  var t = this.ua,
    n = this.uaCH,
    e = this.rgxMap;
  switch (this.itemType) {
    case UA_BROWSER:
      var i = n[FULLVERLIST] || n[BRANDS];
      if (i) for (var r in i) {
        var o = i[r].brand,
          a = i[r].version;
        !/not.a.brand/i.test(o) && (r < 1 || /chromi/i.test(this.get(NAME))) && this.set(NAME, strip(GOOGLE + " ", o)).set(VERSION, a).set(MAJOR, majorize(a));
      }
      break;
    case UA_CPU:
      var s = n[ARCHITECTURE];
      s && (s && n[BITNESS] == "64" && (s += "64"), rgxMapper.call(this.data, s + ";", e));
      break;
    case UA_DEVICE:
      n[MOBILE] && this.set(TYPE, MOBILE), n[MODEL] && this.set(MODEL, n[MODEL]);
      break;
    case UA_OS:
      var l = n[PLATFORM];
      if (l) {
        var u = n[PLATFORMVER];
        l == WINDOWS && (u = parseInt(majorize(u), 10) >= 13 ? "11" : "10"), this.set(NAME, l).set(VERSION, u);
      }
      break;
    case UA_RESULT:
      var d = function d(h) {
        return new UAParserItem(h, t, e[h], n).parseCH().get();
      };
      this.set("ua", t).set(UA_BROWSER, d(UA_BROWSER)).set(UA_CPU, d(UA_CPU)).set(UA_DEVICE, d(UA_DEVICE)).set(UA_ENGINE, d(UA_ENGINE)).set(UA_OS, d(UA_OS));
  }
  return this;
};
UAParserItem.prototype.set = function (t, n) {
  return this.data[t] = n, this;
};
function UAParser(t, n, e) {
  if (_typeof(t) === OBJ_TYPE ? (isExtensions(t) ? (_typeof(n) === OBJ_TYPE && (e = n), n = t) : (e = t, n = void 0), t = void 0) : _typeof(t) === STR_TYPE && !isExtensions(n) && (e = n, n = void 0), !(this instanceof UAParser)) return new UAParser(t, n, e).getResult();
  var i = t || (e && e[USER_AGENT] ? e[USER_AGENT] : EMPTY),
    r = new UAParserDataCH(e, !0),
    o = n ? extend(defaultRegexes, n) : defaultRegexes,
    a = function a(s) {
      return function () {
        return new UAParserItem(s, i, s == UA_RESULT ? o : o[s], r).get();
      };
    };
  return assignFromEntries.call(this, [["getBrowser", a(UA_BROWSER)], ["getCPU", a(UA_CPU)], ["getDevice", a(UA_DEVICE)], ["getEngine", a(UA_ENGINE)], ["getOS", a(UA_OS)], ["getResult", a(UA_RESULT)], ["getUA", function () {
    return i;
  }], ["setUA", function (s) {
    return i = _typeof(s) === STR_TYPE && s.length > UA_MAX_LENGTH ? trim(s, UA_MAX_LENGTH) : s, this;
  }]]).setUA(i), this;
}
UAParser.VERSION = LIBVERSION;
UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
UAParser.CPU = enumerize([ARCHITECTURE]);
UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
var CmsResCode;
(function (t) {
  t[t.CMS_RES_SUCCESS = 0] = "CMS_RES_SUCCESS", t[t.CMS_FILE_ALREDY_EXIST = 21014] = "CMS_FILE_ALREDY_EXIST";
})(CmsResCode || (CmsResCode = {}));
var Err_Text = "inject failed",
  ScriptForbiddenError = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = t.call(this) || this;
      return i.message = "".concat(e, " ").concat(Err_Text), i.name = "ScriptForbiddenError", i;
    }
    return n;
  }(Error);
function appendScript(t, n) {
  return new Promise(function (e, i) {
    var r = document.getElementsByTagName("head")[0],
      o = document.createElement("script");
    o.type = "text/javascript", o.src = t, n && Object.keys(n).forEach(function (l) {
      o.setAttribute(l, n[l]);
    }), r.appendChild(o);
    var a = function a(l) {
        o.removeEventListener("load", a), e(l);
      },
      s = function s(l) {
        o.removeEventListener("error", s), i(l !== null && l !== void 0 ? l : "script blocked");
      };
    o.addEventListener("load", a), o.addEventListener("error", s), o.addEventListener("abort", s), o.type === "text/plain" && i(new ScriptForbiddenError(t));
  });
}
function injectElement(t) {
  if (t instanceof HTMLElement) return t;
  if (typeof t == "string") {
    var n = document.querySelector(t);
    if (n instanceof HTMLElement) return n;
    throw new Error("Not found element: ".concat(t));
  }
  var e = document.createElement("div");
  return document.body.appendChild(e), e;
}
function removeElement(t) {
  var n, e;
  if (t instanceof HTMLElement) return (n = t.parentElement) === null || n === void 0 ? void 0 : n.removeChild(t);
  if (t instanceof ShadowRoot) return t.innerHTML = "", t;
  if (typeof t == "string") {
    var i = document.querySelector(t);
    if (i instanceof HTMLElement) return (e = i.parentElement) === null || e === void 0 ? void 0 : e.removeChild(i);
    throw new Error("Not found element: ".concat(t));
  }
  return "";
}
function throttlePromise(t) {
  return function () {
    for (var n = [], e = 0; e < arguments.length; e++) n[e] = arguments[e];
    return t._promise_ || (t._promise_ = t.apply(void 0, n), t._promise_["catch"](function () {}).then(function () {
      t._promise_ = null;
    })), t._promise_;
  };
}
function getQuery(t, n) {
  return (n !== null && n !== void 0 ? n : new URLSearchParams(location.search)).get(t);
}
function injectStyle(t, n) {
  var e = document.createElement("style");
  if (e.textContent = t, n instanceof HTMLElement && n.appendChild(e), typeof n == "string") {
    var i = document.querySelector(n);
    if (i instanceof HTMLElement) i.appendChild(e);else throw new Error("Not found element: ".concat(n));
  }
  n || document.body.appendChild(e);
}
function isEmail(t) {
  return t === void 0 && (t = ""), /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t);
}
function isDom(t) {
  return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) == "object" ? t instanceof HTMLElement : _typeof(t) == "object" &&
  // @ts-expect-error
  (t == null ? void 0 : t.nodeType) === 1 &&
  // @ts-expect-error
  typeof (t == null ? void 0 : t.nodeName) == "string";
}
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
}
function getBrowserName() {
  var t;
  return (t = UAParser(navigator.userAgent).browser.name) !== null && t !== void 0 ? t : "unknown";
}
function getSpecialBrowserType() {
  var t = function t(n) {
    return !!n.find(function (e) {
      return e.test(navigator.userAgent);
    });
  };
  return t([/fbav/i, /fban/i]) ? "facebook" : t([/naver/i, /fban/i]) ? "naver" : t([/bytelo/i, /bytedance/i]) ? "tictok" : t([/microm/i, /wechat/i]) ? "wechat" : t([/vivobrowser/i, /vivo/i]) ? "vivo" : t([/mibrowser/i, /xiaomi/i, /miui/i]) ? "mi" : t([/discord/i]) ? "discord" : t([/kakao/i, /kakaotalk/i]) ? "kakao" : t([/line/i]) ? "line" : t([/instagram/i]) ? "ins" : "";
}
function getSys() {
  return UAParser(navigator.userAgent).os;
}
function useTXCaptcha(t) {
  return __awaiter(this, void 0, void 0, function () {
    var n,
      e,
      i,
      r,
      o,
      a = this;
    return __generator(this, function (s) {
      switch (s.label) {
        case 0:
          return n = t.appid, e = t.lang, i = e === void 0 ? "en" : e, r = t.extra_options, o = r === void 0 ? {} : r, window.TencentCaptcha ? [3, 2] : [4, appendScript(TENCENT_CAPTCHA_CDN)];
        case 1:
          s.sent(), s.label = 2;
        case 2:
          return [2, new Promise(function (l, u) {
            var d = function d(p) {
                return __awaiter(a, void 0, void 0, function () {
                  return __generator(this, function (m) {
                    return p.ret === 0 && !p.errorCode ? l(p) : u(p), [2
                    /*return*/];
                  });
                });
              },
              h = new window.TencentCaptcha(n, d, Object.assign({}, {
                userLanguage: i
              }, o));
            h.show();
          })];
      }
    });
  });
}
var _a$1,
  _b,
  isiOS = function isiOS() {
    return getSys().name === "iOS";
  },
  isAndroid = function isAndroid() {
    var t;
    return !!(!((t = getSys().name) === null || t === void 0) && t.toLowerCase().includes("android"));
  },
  isIntlWindows = function isIntlWindows() {
    return navigator.userAgent.toLowerCase().includes("intl") && window.tbs_external;
  },
  isInIntlBrowser$1 = function () {
    return /intlbrowser/i.test(navigator.userAgent);
  }(),
  AppURLSchemeMap = (_a$1 = {
    Wechat: "weixin://"
  }, _a$1[InGameChannel.Twitter] = "twitter://", _a$1[InGameChannel.Whatsapp] = "whatsapp://", _a$1[InGameChannel.QQ] = "mqq://", _a$1[InGameChannel.Line] = "line://", _a$1[InGameChannel.VK] = "vk://", _a$1[InGameChannel.Instagram] = "instagram://", _a$1[InGameChannel.Facebook] = isAndroid() ? "fb://facewebmodal/f?href=" : "fbshareextension://", _a$1[InGameChannel.FacebookGaming] = isAndroid() ? "fb://facewebmodal/f?href=" : "fbshareextension://", _a$1[InGameChannel.Discord] = isAndroid() ? "discord://app/" : "com.hammerandchisel.discord://", _a$1[InGameChannel.Garena] = isAndroid() ? "garena://deeplink" : "garenagc://", _a$1.Kakao = isAndroid() ? "kakaotalk://main" : "kakaolink://", _a$1.Google = isAndroid() ? "intent://chrome/#Intent;scheme=googlechrome;package=com.android.chrome;end" : "googlechrome://", _a$1),
  AppSchemeAndPkgName = (_b = {
    Wechat: ["weixin://", "com.tencent.mm"],
    Kakao: ["kakaolink://", "com.kakao.talk"],
    Google: ["googlechrome://", "com.google.android.gms"]
  }, _b[InGameChannel.QQ] = ["mqq://", "com.tencent.mobileqq"], _b[InGameChannel.Whatsapp] = ["whatsapp://", "com.whatsapp"], _b[InGameChannel.Facebook] = ["fb://", "com.facebook.katana"], _b[InGameChannel.FacebookGaming] = ["fb://", "com.facebook.katana"], _b[InGameChannel.VK] = ["vk://", "com.vkontakte.android"], _b[InGameChannel.Line] = ["line://", "jp.naver.line.android"], _b[InGameChannel.Garena] = ["garenagc://", "com.garena.gaslite"], _b[InGameChannel.Instagram] = ["instagram://app", "com.instagram.android"], _b[InGameChannel.Discord] = ["discord://", "com.discord"], _b[InGameChannel.Twitter] = ["twitter://", "com.twitter.android"], _b);
var constants = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  AppSchemeAndPkgName: AppSchemeAndPkgName,
  AppURLSchemeMap: AppURLSchemeMap,
  isAndroid: isAndroid,
  isInIntlBrowser: isInIntlBrowser$1,
  isIntlWindows: isIntlWindows,
  isiOS: isiOS
}, Symbol.toStringTag, {
  value: "Module"
}));
function setupWebViewJavascriptBridge(t) {
  if (window.WebViewJavascriptBridge) return t(window.WebViewJavascriptBridge);
  if (window.WVJBCallbacks) return window.WVJBCallbacks.push(t);
  window.WVJBCallbacks = [t];
  var n = document.createElement("iframe");
  n.style.display = "none", n.src = "https://__bridge_loaded__", document.documentElement.appendChild(n), setTimeout(function () {
    document.documentElement.removeChild(n);
  }, 0);
}
var IntlBridge = /** @class */
  function (t) {
    __extends(n, t);
    function n() {
      var e = t.call(this) || this;
      return e.emitter = new EventEmitter(), isMobile() && isInIntlBrowser$1 && e.initMobileClientBridge(), e.emitter = new EventEmitter(), e;
    }
    return Object.defineProperty(n.prototype, "on", {
      get: function get() {
        return this.emitter.on.bind(this.emitter);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "off", {
      get: function get() {
        return this.emitter.off.bind(this.emitter);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "emit", {
      get: function get() {
        return this.emitter.emit.bind(this.emitter);
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.callNative = function (e, i) {
      i === void 0 && (i = function i(l) {
        console.log("[intl-bridge-".concat(e.cmd, "]: defalt callback -> ").concat(l));
      });
      var r = e.cmd,
        o = e.req_data,
        a = [JSON.stringify(o)],
        s = JSON.stringify(Object.assign({}, {
          INTLMethod: r
        }, o));
      isiOS() ? this.iosBridgeCall(s, i) : isAndroid() ? this.androidBridgeCall(s, i) : isIntlWindows() ? this.windowsBridgeCall({
        cmd: r,
        pc_req_data: a
      }, i) : console.warn("not ingame");
    }, n.prototype.windowsBridgeCall = function (e, i) {
      var r,
        o,
        a = e.cmd,
        s = e.pc_req_data;
      if (![IntlCMD.DETECT_APP_INSTALLED, IntlCMD.SHARE].includes(a)) {
        var l = (o = (r = window.tbs_external) === null || r === void 0 ? void 0 : r.nativeCall) === null || o === void 0 ? void 0 : o.call(r, a, s);
        i == null || i(l);
      }
    }, n.prototype.androidBridgeCall = function (e, i) {
      if (i) {
        i(prompt(e));
        return;
      }
      prompt(e);
    }, n.prototype.iosBridgeCall = function (e, i) {
      var r = this,
        o;
      this.iosHandler ? (o = this.iosHandler) === null || o === void 0 || o.call(this, "INTLCallNative", e, i) : setTimeout(function () {
        var a;
        (a = r.iosHandler) === null || a === void 0 || a.call(r, "INTLCallNative", e, i);
      }, 200);
    }, n.prototype.initMobileClientBridge = function () {
      var e = this;
      setupWebViewJavascriptBridge(function (i) {
        e.iosHandler = i.callHandler, i.registerHandler("INTLJSHandler", function (r, o) {
          e.emit("INTLJSHandler");
        }), i.registerHandler("OnEnterForeground", function (r, o) {
          var a;
          (a = window.OnEnterForeground) === null || a === void 0 || a.call(window), e.emit("OnEnterForeground");
        }), i.registerHandler("OnEnterBackground", function (r, o) {
          var a;
          (a = window.OnEnterBackground) === null || a === void 0 || a.call(window), e.emit("OnEnterBackground");
        }), i.registerHandler("OnGetNetworkType", function (r, o) {
          var a;
          (a = window.OnGetNetworkType) === null || a === void 0 || a.call(window, r), e.emit("OnGetNetworkType");
        }), i.registerHandler("OnOpenPhoto", function (r, o) {
          var a;
          (a = window.OnOpenPhoto) === null || a === void 0 || a.call(window, r), e.emit("OnOpenPhoto");
        });
      });
    }, n.class_name = "IntlBridge", n;
  }(Singleton),
  bridge$2 = IntlBridge.getInstance(),
  isInIntlBrowser = function () {
    return /intlbrowser/i.test(navigator.userAgent);
  }();
function isAppInstalled(t) {
  var n,
    e = t,
    i = e.channel,
    r = e.scheme_or_pkgname;
  if (i) {
    var o = (n = AppSchemeAndPkgName[i]) !== null && n !== void 0 ? n : [],
      a = o[0],
      s = o[1];
    return detectAppInstallation(isiOS() ? a : s);
  }
  return r ? detectAppInstallation(r) : Promise.resolve(!1);
}
function detectAppInstallation(t) {
  return new Promise(function (n, e) {
    if (t) {
      var i = function i(r) {
        try {
          n(!!JSON.parse(r || "false"));
        } catch (o) {
          e(o);
        }
      };
      isiOS() && bridge$2.callNative({
        cmd: IntlCMD.DETECT_APP_INSTALLED,
        req_data: {
          URLScheme: t,
          channel: t,
          Channel: t
        }
      }, i), isAndroid() && bridge$2.callNative({
        cmd: IntlCMD.DETECT_APP_INSTALLED,
        req_data: {
          packageName: t,
          channel: t,
          Channel: t
        }
      }, i);
    } else n(!1);
  });
}
var detect = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  isAppInstalled: isAppInstalled,
  isInIntlBrowser: isInIntlBrowser
}, Symbol.toStringTag, {
  value: "Module"
}));
var IGetCosUrlTokenType;
(function (t) {
  t[t.INGAME = 2] = "INGAME", t[t.WEB = 1] = "WEB";
})(IGetCosUrlTokenType || (IGetCosUrlTokenType = {}));
var SourceType;
(function (t) {
  t.PC_WEB = "pc_web", t.INNER_GAME = "inner_game", t.PC_INNER = "pc_inner_game", t.LANUCH = "pc_launcher", t.APP = "app", t.UGC = "social_media", t.GAME_CLIENT = "game_client";
})(SourceType || (SourceType = {}));
var CMS_ENV;
(function (t) {
  t.NA = "na", t.ASIA = "asia";
})(CMS_ENV || (CMS_ENV = {}));
var ContentClass;
(function (t) {
  t[t.Feeds = 0] = "Feeds", t[t.Banner = 1] = "Banner", t[t.Notice = 2] = "Notice";
})(ContentClass || (ContentClass = {}));
var LinkType;
(function (t) {
  t[t.Self_Build = 0] = "Self_Build", t[t.Inner_Link = 1] = "Inner_Link", t[t.External_Link = 2] = "External_Link", t[t.Inner_Article = 3] = "Inner_Article", t[t.Self_Build_Pic = 4] = "Self_Build_Pic";
})(LinkType || (LinkType = {}));
var OrderType;
(function (t) {
  t[t.ASC = 1] = "ASC", t[t.DESC = 0] = "DESC";
})(OrderType || (OrderType = {}));
var LikeBiz;
(function (t) {
  t[t.Feeds = 1] = "Feeds", t[t.Comment = 2] = "Comment", t[t.Pdp = 3] = "Pdp";
})(LikeBiz || (LikeBiz = {}));
var LikeOp;
(function (t) {
  t[t.Cancel = 0] = "Cancel", t[t.Like = 1] = "Like";
})(LikeOp || (LikeOp = {}));
var RandomCodeAccountType;
(function (t) {
  t[t.EMAIL = 1] = "EMAIL", t[t.PHONE = 2] = "PHONE";
})(RandomCodeAccountType || (RandomCodeAccountType = {}));
var mclient_type = getSys().name === "iOS" ? 902 : 901,
  CMS_API_SIGN_CONFIG = function CMS_API_SIGN_CONFIG() {
    var t = {
      dev: {
        appkey: "common-test",
        appsecret: "8mQsXOBlLGh5Cae7rJz1"
      },
      test: {
        appkey: "common-test",
        appsecret: "8mQsXOBlLGh5Cae7rJz1"
      },
      prod: {
        appkey: "community-common",
        appsecret: "sXOBmQh5ClLGJz8ae7r1"
      }
    };
    return t[ENV$1()];
  },
  DefaultParams = {
    // cms 数据请求相关
    Offset: 0,
    PageNum: 1,
    Perpage: 10,
    ExtInfo: [0, 1, 2],
    AllLabelName: "all",
    SecondLabelId: 0,
    WindowOpenType: "_blank",
    UseDefaultLang: !1,
    DateFormat: "YYYY-MM-DD",
    ContentClass: ContentClass.Feeds,
    // 签名相关
    SignVersion: "v1.0.1",
    // 预览相关
    PreviewVal: "preview",
    InstantPreviewVersion: "2",
    // 2023-07-12 -> 环境类的均改为每次读取
    SignAppKey: function SignAppKey() {
      return CMS_API_SIGN_CONFIG().appkey;
    },
    SignAppSecret: function SignAppSecret() {
      return CMS_API_SIGN_CONFIG().appsecret;
    },
    // 社区登录相关
    // cms & mobile app id config;
    CmsAppId: 10109,
    CmsClientType: isMobile() ? mclient_type : 903,
    // 其他
    SignForEnableDevtoolsInProd: "03ecf6833e2e8893f144ec3405e322174dff591d89aeb15f56b8212a373a83fd"
    // 支持现网调试控制台, 内部后门
  },
  PageRpcRegisteredMethods = {
    ContentUpdate: "content_update"
    // cms 实时预览 v2
  },
  PageRpcExportedMethods = {
    Ready: "ready"
    // 页面初始化
  },
  DefaultQueryKey = {
    // ingame query
    IntlIngameChannel: "channelid",
    IntlIngameEncodeparam: "encodeparam",
    IntlIngameGameid: "gameid",
    IntlIngameOS: "os",
    // cms default query
    CmsContentId: "content_id",
    CmsFatherContentId: "father_content_id",
    CmsPreviewEnv: "env",
    CmsPreviewSign: "sign",
    CmsPreviewTs: "ts",
    CmsPreviewAppKey: "app_key",
    CmsPreviewVersion: "preview_version",
    CmsDisableDebugKey: "debugkey",
    CmsAdminRegion: "deploy_region"
  },
  sha256Exports = {},
  sha256 = {
    get exports() {
      return sha256Exports;
    },
    set exports(t) {
      sha256Exports = t;
    }
  };
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
(function (module) {
  (function () {
    var ERROR = "input is invalid type",
      WINDOW = (typeof window === "undefined" ? "undefined" : _typeof(window)) == "object",
      root = WINDOW ? window : {};
    root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
    var WEB_WORKER = !WINDOW && (typeof self === "undefined" ? "undefined" : _typeof(self)) == "object",
      NODE_JS = !root.JS_SHA256_NO_NODE_JS && (typeof process === "undefined" ? "undefined" : _typeof(process)) == "object" && process.versions && process.versions.node;
    NODE_JS ? root = commonjsGlobal : WEB_WORKER && (root = self);
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && !0 && module.exports,
      ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && (typeof ArrayBuffer === "undefined" ? "undefined" : _typeof(ArrayBuffer)) < "u",
      HEX_CHARS = "0123456789abcdef".split(""),
      EXTRA = [-2147483648, 8388608, 32768, 128],
      SHIFT = [24, 16, 8, 0],
      K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
      OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"],
      blocks = [];
    (root.JS_SHA256_NO_NODE_JS || !Array.isArray) && (Array.isArray = function (t) {
      return Object.prototype.toString.call(t) === "[object Array]";
    }), ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function (t) {
      return _typeof(t) == "object" && t.buffer && t.buffer.constructor === ArrayBuffer;
    });
    var createOutputMethod = function createOutputMethod(t, n) {
        return function (e) {
          return new Sha256(n, !0).update(e)[t]();
        };
      },
      createMethod = function createMethod(t) {
        var n = createOutputMethod("hex", t);
        NODE_JS && (n = nodeWrap(n, t)), n.create = function () {
          return new Sha256(t);
        }, n.update = function (r) {
          return n.create().update(r);
        };
        for (var e = 0; e < OUTPUT_TYPES.length; ++e) {
          var i = OUTPUT_TYPES[e];
          n[i] = createOutputMethod(i, t);
        }
        return n;
      },
      nodeWrap = function nodeWrap(method, is224) {
        var crypto = eval("require('crypto')"),
          Buffer = eval("require('buffer').Buffer"),
          algorithm = is224 ? "sha224" : "sha256",
          nodeMethod = function nodeMethod(t) {
            if (typeof t == "string") return crypto.createHash(algorithm).update(t, "utf8").digest("hex");
            if (t == null) throw new Error(ERROR);
            return t.constructor === ArrayBuffer && (t = new Uint8Array(t)), Array.isArray(t) || ArrayBuffer.isView(t) || t.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(t)).digest("hex") : method(t);
          };
        return nodeMethod;
      },
      createHmacOutputMethod = function createHmacOutputMethod(t, n) {
        return function (e, i) {
          return new HmacSha256(e, n, !0).update(i)[t]();
        };
      },
      createHmacMethod = function createHmacMethod(t) {
        var n = createHmacOutputMethod("hex", t);
        n.create = function (r) {
          return new HmacSha256(r, t);
        }, n.update = function (r, o) {
          return n.create(r).update(o);
        };
        for (var e = 0; e < OUTPUT_TYPES.length; ++e) {
          var i = OUTPUT_TYPES[e];
          n[i] = createHmacOutputMethod(i, t);
        }
        return n;
      };
    function Sha256(t, n) {
      n ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], t ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = t;
    }
    Sha256.prototype.update = function (t) {
      if (!this.finalized) {
        var n,
          e = _typeof(t);
        if (e !== "string") {
          if (e === "object") {
            if (t === null) throw new Error(ERROR);
            if (ARRAY_BUFFER && t.constructor === ArrayBuffer) t = new Uint8Array(t);else if (!Array.isArray(t) && (!ARRAY_BUFFER || !ArrayBuffer.isView(t))) throw new Error(ERROR);
          } else throw new Error(ERROR);
          n = !0;
        }
        for (var i, r = 0, o, a = t.length, s = this.blocks; r < a;) {
          if (this.hashed && (this.hashed = !1, s[0] = this.block, s[16] = s[1] = s[2] = s[3] = s[4] = s[5] = s[6] = s[7] = s[8] = s[9] = s[10] = s[11] = s[12] = s[13] = s[14] = s[15] = 0), n) for (o = this.start; r < a && o < 64; ++r) s[o >> 2] |= t[r] << SHIFT[o++ & 3];else for (o = this.start; r < a && o < 64; ++r) i = t.charCodeAt(r), i < 128 ? s[o >> 2] |= i << SHIFT[o++ & 3] : i < 2048 ? (s[o >> 2] |= (192 | i >> 6) << SHIFT[o++ & 3], s[o >> 2] |= (128 | i & 63) << SHIFT[o++ & 3]) : i < 55296 || i >= 57344 ? (s[o >> 2] |= (224 | i >> 12) << SHIFT[o++ & 3], s[o >> 2] |= (128 | i >> 6 & 63) << SHIFT[o++ & 3], s[o >> 2] |= (128 | i & 63) << SHIFT[o++ & 3]) : (i = 65536 + ((i & 1023) << 10 | t.charCodeAt(++r) & 1023), s[o >> 2] |= (240 | i >> 18) << SHIFT[o++ & 3], s[o >> 2] |= (128 | i >> 12 & 63) << SHIFT[o++ & 3], s[o >> 2] |= (128 | i >> 6 & 63) << SHIFT[o++ & 3], s[o >> 2] |= (128 | i & 63) << SHIFT[o++ & 3]);
          this.lastByteIndex = o, this.bytes += o - this.start, o >= 64 ? (this.block = s[16], this.start = o - 64, this.hash(), this.hashed = !0) : this.start = o;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, Sha256.prototype.finalize = function () {
      if (!this.finalized) {
        this.finalized = !0;
        var t = this.blocks,
          n = this.lastByteIndex;
        t[16] = this.block, t[n >> 2] |= EXTRA[n & 3], this.block = t[16], n >= 56 && (this.hashed || this.hash(), t[0] = this.block, t[16] = t[1] = t[2] = t[3] = t[4] = t[5] = t[6] = t[7] = t[8] = t[9] = t[10] = t[11] = t[12] = t[13] = t[14] = t[15] = 0), t[14] = this.hBytes << 3 | this.bytes >>> 29, t[15] = this.bytes << 3, this.hash();
      }
    }, Sha256.prototype.hash = function () {
      var t = this.h0,
        n = this.h1,
        e = this.h2,
        i = this.h3,
        r = this.h4,
        o = this.h5,
        a = this.h6,
        s = this.h7,
        l = this.blocks,
        u,
        d,
        h,
        p,
        m,
        R,
        T,
        O,
        N,
        y,
        f;
      for (u = 16; u < 64; ++u) m = l[u - 15], d = (m >>> 7 | m << 25) ^ (m >>> 18 | m << 14) ^ m >>> 3, m = l[u - 2], h = (m >>> 17 | m << 15) ^ (m >>> 19 | m << 13) ^ m >>> 10, l[u] = l[u - 16] + d + l[u - 7] + h << 0;
      for (f = n & e, u = 0; u < 64; u += 4) this.first ? (this.is224 ? (O = 300032, m = l[0] - 1413257819, s = m - 150054599 << 0, i = m + 24177077 << 0) : (O = 704751109, m = l[0] - 210244248, s = m - 1521486534 << 0, i = m + 143694565 << 0), this.first = !1) : (d = (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10), h = (r >>> 6 | r << 26) ^ (r >>> 11 | r << 21) ^ (r >>> 25 | r << 7), O = t & n, p = O ^ t & e ^ f, T = r & o ^ ~r & a, m = s + h + T + K[u] + l[u], R = d + p, s = i + m << 0, i = m + R << 0), d = (i >>> 2 | i << 30) ^ (i >>> 13 | i << 19) ^ (i >>> 22 | i << 10), h = (s >>> 6 | s << 26) ^ (s >>> 11 | s << 21) ^ (s >>> 25 | s << 7), N = i & t, p = N ^ i & n ^ O, T = s & r ^ ~s & o, m = a + h + T + K[u + 1] + l[u + 1], R = d + p, a = e + m << 0, e = m + R << 0, d = (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10), h = (a >>> 6 | a << 26) ^ (a >>> 11 | a << 21) ^ (a >>> 25 | a << 7), y = e & i, p = y ^ e & t ^ N, T = a & s ^ ~a & r, m = o + h + T + K[u + 2] + l[u + 2], R = d + p, o = n + m << 0, n = m + R << 0, d = (n >>> 2 | n << 30) ^ (n >>> 13 | n << 19) ^ (n >>> 22 | n << 10), h = (o >>> 6 | o << 26) ^ (o >>> 11 | o << 21) ^ (o >>> 25 | o << 7), f = n & e, p = f ^ n & i ^ y, T = o & a ^ ~o & s, m = r + h + T + K[u + 3] + l[u + 3], R = d + p, r = t + m << 0, t = m + R << 0;
      this.h0 = this.h0 + t << 0, this.h1 = this.h1 + n << 0, this.h2 = this.h2 + e << 0, this.h3 = this.h3 + i << 0, this.h4 = this.h4 + r << 0, this.h5 = this.h5 + o << 0, this.h6 = this.h6 + a << 0, this.h7 = this.h7 + s << 0;
    }, Sha256.prototype.hex = function () {
      this.finalize();
      var t = this.h0,
        n = this.h1,
        e = this.h2,
        i = this.h3,
        r = this.h4,
        o = this.h5,
        a = this.h6,
        s = this.h7,
        l = HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[t & 15] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[n & 15] + HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[e & 15] + HEX_CHARS[i >> 28 & 15] + HEX_CHARS[i >> 24 & 15] + HEX_CHARS[i >> 20 & 15] + HEX_CHARS[i >> 16 & 15] + HEX_CHARS[i >> 12 & 15] + HEX_CHARS[i >> 8 & 15] + HEX_CHARS[i >> 4 & 15] + HEX_CHARS[i & 15] + HEX_CHARS[r >> 28 & 15] + HEX_CHARS[r >> 24 & 15] + HEX_CHARS[r >> 20 & 15] + HEX_CHARS[r >> 16 & 15] + HEX_CHARS[r >> 12 & 15] + HEX_CHARS[r >> 8 & 15] + HEX_CHARS[r >> 4 & 15] + HEX_CHARS[r & 15] + HEX_CHARS[o >> 28 & 15] + HEX_CHARS[o >> 24 & 15] + HEX_CHARS[o >> 20 & 15] + HEX_CHARS[o >> 16 & 15] + HEX_CHARS[o >> 12 & 15] + HEX_CHARS[o >> 8 & 15] + HEX_CHARS[o >> 4 & 15] + HEX_CHARS[o & 15] + HEX_CHARS[a >> 28 & 15] + HEX_CHARS[a >> 24 & 15] + HEX_CHARS[a >> 20 & 15] + HEX_CHARS[a >> 16 & 15] + HEX_CHARS[a >> 12 & 15] + HEX_CHARS[a >> 8 & 15] + HEX_CHARS[a >> 4 & 15] + HEX_CHARS[a & 15];
      return this.is224 || (l += HEX_CHARS[s >> 28 & 15] + HEX_CHARS[s >> 24 & 15] + HEX_CHARS[s >> 20 & 15] + HEX_CHARS[s >> 16 & 15] + HEX_CHARS[s >> 12 & 15] + HEX_CHARS[s >> 8 & 15] + HEX_CHARS[s >> 4 & 15] + HEX_CHARS[s & 15]), l;
    }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function () {
      this.finalize();
      var t = this.h0,
        n = this.h1,
        e = this.h2,
        i = this.h3,
        r = this.h4,
        o = this.h5,
        a = this.h6,
        s = this.h7,
        l = [t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, t & 255, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, n & 255, e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, e & 255, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, i & 255, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, o & 255, a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, a & 255];
      return this.is224 || l.push(s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, s & 255), l;
    }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function () {
      this.finalize();
      var t = new ArrayBuffer(this.is224 ? 28 : 32),
        n = new DataView(t);
      return n.setUint32(0, this.h0), n.setUint32(4, this.h1), n.setUint32(8, this.h2), n.setUint32(12, this.h3), n.setUint32(16, this.h4), n.setUint32(20, this.h5), n.setUint32(24, this.h6), this.is224 || n.setUint32(28, this.h7), t;
    };
    function HmacSha256(t, n, e) {
      var i,
        r = _typeof(t);
      if (r === "string") {
        var o = [],
          a = t.length,
          s = 0,
          l;
        for (i = 0; i < a; ++i) l = t.charCodeAt(i), l < 128 ? o[s++] = l : l < 2048 ? (o[s++] = 192 | l >> 6, o[s++] = 128 | l & 63) : l < 55296 || l >= 57344 ? (o[s++] = 224 | l >> 12, o[s++] = 128 | l >> 6 & 63, o[s++] = 128 | l & 63) : (l = 65536 + ((l & 1023) << 10 | t.charCodeAt(++i) & 1023), o[s++] = 240 | l >> 18, o[s++] = 128 | l >> 12 & 63, o[s++] = 128 | l >> 6 & 63, o[s++] = 128 | l & 63);
        t = o;
      } else if (r === "object") {
        if (t === null) throw new Error(ERROR);
        if (ARRAY_BUFFER && t.constructor === ArrayBuffer) t = new Uint8Array(t);else if (!Array.isArray(t) && (!ARRAY_BUFFER || !ArrayBuffer.isView(t))) throw new Error(ERROR);
      } else throw new Error(ERROR);
      t.length > 64 && (t = new Sha256(n, !0).update(t).array());
      var u = [],
        d = [];
      for (i = 0; i < 64; ++i) {
        var h = t[i] || 0;
        u[i] = 92 ^ h, d[i] = 54 ^ h;
      }
      Sha256.call(this, n, e), this.update(d), this.oKeyPad = u, this.inner = !0, this.sharedMemory = e;
    }
    HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function () {
      if (Sha256.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var t = this.array();
        Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(t), Sha256.prototype.finalize.call(this);
      }
    };
    var exports = createMethod();
    exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224);
  })();
})(sha256);
var _a,
  backdoor = sha256Exports.sha256((_a = getQuery(DefaultQueryKey.CmsDisableDebugKey)) !== null && _a !== void 0 ? _a : "") === DefaultParams.SignForEnableDevtoolsInProd,
  default_config = {
    debug_interval: 100,
    debug: ENV$1() === "prod" && !backdoor && !1
  },
  DevtoolsDefender = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = t.call(this) || this;
      return i.setConfig(e), i;
    }
    return n.prototype.setConfig = function (e) {
      var i = Object.assign({}, default_config, e),
        r = i.debug_interval,
        o = i.callback,
        a = i.redirect,
        s = i.debug;
      this._debug = s, this._debug_time = r, this._redirect = a, this._callback = o;
    }, n.prototype.start = function () {
      this.useDebugger();
    }, n.prototype.disable = function () {
      clearInterval(this._interval);
    }, n.prototype.useDebugger = function () {
      var e = this;
      if (this._debug) {
        var i = new Function("debugger");
        this._interval = window.setInterval(function () {
          var r,
            o = /* @__PURE__ */new Date().getTime();
          i();
          var a = /* @__PURE__ */new Date().getTime();
          a - o >= 100 && ((r = e._callback) === null || r === void 0 || r.call(e), e._redirect && location.replace(e._redirect));
        }, this._debug_time);
      } else this.disable();
    }, n.class_name = "DevtoolsDefender", n;
  }(Singleton);
function disableDevtools(t) {
  var n = DevtoolsDefender.getInstance(t);
  return n.start(), n;
}
var DEVELOPMENT_MODE = ENV$1() !== "prod" && getQuery("mode") === "debug";
function initVConsole() {
  DEVELOPMENT_MODE && (isMobile() || isInIntlBrowser) && appendScript(VCONSOLE_CDN).then(function () {
    new window.VConsole();
  })["catch"](function () {
    console.warn("vconsole init failed");
  });
}
function debug() {
  initVConsole(), disableDevtools({
    redirect: location.origin
  });
}
var aegis_minExports = {},
  aegis_min = {
    get exports() {
      return aegis_minExports;
    },
    set exports(t) {
      aegis_minExports = t;
    }
  };
(function (t, n) {
  (function (e, i) {
    t.exports = i();
  })(commonjsGlobal, function () {
    Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
      configurable: !0,
      writable: !0,
      value: function value(c) {
        if (this === null) throw new TypeError('"this" is null or not defined');
        var _ = Object(this),
          v = _.length >>> 0;
        if (typeof c != "function") throw new TypeError("predicate must be a function");
        for (var b = arguments[1], S = 0; S < v;) {
          var I = _[S];
          if (c.call(b, I, S, _)) return I;
          S += 1;
        }
      }
    }), Object.assign || Object.defineProperty(Object, "assign", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function value(c) {
        if (c == null) throw new TypeError("Cannot convert first argument to object");
        for (var _ = Object(c), v = 1; v < arguments.length; v++) if ((b = arguments[v]) != null) for (var b = Object(b), S = Object.keys(Object(b)), I = 0, x = S.length; I < x; I++) {
          var C = S[I],
            D = Object.getOwnPropertyDescriptor(b, C);
          D != null && D.enumerable && (_[C] = b[C]);
        }
        return _;
      }
    });
    var _e = function e(c, _) {
        return (_e = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (v, b) {
          v.__proto__ = b;
        } || function (v, b) {
          for (var S in b) Object.prototype.hasOwnProperty.call(b, S) && (v[S] = b[S]);
        })(c, _);
      },
      _i = function i() {
        return (_i = Object.assign || function (c) {
          for (var _, v = 1, b = arguments.length; v < b; v++) for (var S in _ = arguments[v]) Object.prototype.hasOwnProperty.call(_, S) && (c[S] = _[S]);
          return c;
        }).apply(this, arguments);
      },
      r = (a.prototype.indexOf = function (c, _) {
        for (var v = 0; v < c.length; v++) if (c[v].callback === _) return v;
        return -1;
      }, a.prototype.on = function (c, _, v) {
        if (v === void 0 && (v = 0), this) {
          var b = this.eventsList[c];
          return b || (this.eventsList[c] = [], b = this.eventsList[c]), this.indexOf(b, _) !== -1 ? this : (b.push({
            name: c,
            type: v || 0,
            callback: _
          }), this);
        }
      }, a.prototype.one = function (c, _) {
        this.on(c, _, 1);
      }, a.prototype.remove = function (c, _) {
        if (this) {
          var v = this.eventsList[c];
          if (!v) return null;
          if (_) return v.length && (_ = this.indexOf(v, _), v.splice(_, 1)), this;
          try {
            delete this.eventsList[c];
          } catch (_unused) {}
          return null;
        }
      }, a.prototype.clear = function () {
        this.eventsList = {};
      }, a),
      o = function o(c) {
        if (!c || c.length === 0) return "{}";
        c = Array.isArray(c) ? c : [c];
        var _ = Object.keys(c[0]),
          v = {};
        return _.forEach(function (b) {
          v[b] = c.map(function (S) {
            return S[b];
          });
        }), v.count = c.length, function (b) {
          if (typeof b == "string") return b;
          try {
            return JSON.stringify(b, s()) || "undefined";
          } catch (S) {
            return "error happen when aegis stringify: \n " + S.message + " \n " + S.stack;
          }
        }(v);
      };
    function a() {
      var c = this;
      this.emit = function (_, v) {
        if (c) {
          var b;
          if ((S = c.eventsList[_]) != null && S.length) for (var S = S.slice(), I = 0; I < S.length; I++) {
            b = S[I];
            try {
              var x = b.callback.apply(c, [v]);
              if (b.type === 1 && c.remove(_, b.callback), x === !1) break;
            } catch (C) {
              throw C;
            }
          }
          return c;
        }
      }, this.eventsList = {};
    }
    (y = M = M || {})[y.number = -1] = "number", y.string = "";
    function s() {
      var c = [],
        _ = [];
      return function (v, b) {
        if (b instanceof Error) return "Error.message: " + b.message + " \n  Error.stack: " + b.stack;
        if (_typeof(b) == "object" && b !== null) {
          var S = c.indexOf(b);
          if (S !== -1) return "[Circular " + _[S] + "]";
          c.push(b), _.push(v || "root");
        }
        return b;
      };
    }
    var l,
      u,
      d,
      h = function h(c) {
        if (typeof c == "string") return c;
        try {
          return (JSON.stringify(c, s(), 4) || "undefined").replace(/"/gim, "");
        } catch (_) {
          return "error happen when aegis stringify: \n " + _.message + " \n " + _.stack;
        }
      };
    (M = l = l || {}).INFO_ALL = "2", M.API_RESPONSE = "1", M.INFO = "2", M.ERROR = "4", M.PROMISE_ERROR = "8", M.AJAX_ERROR = "16", M.SCRIPT_ERROR = "32", M.IMAGE_ERROR = "64", M.CSS_ERROR = "128", M.CONSOLE_ERROR = "256", M.MEDIA_ERROR = "512", M.RET_ERROR = "1024", M.REPORT = "2048", M.PV = "4096", M.EVENT = "8192", (y = E = E || {})[y.android = 1] = "android", y[y.ios = 2] = "ios", y[y.windows = 3] = "windows", y[y.macos = 4] = "macos", y[y.linux = 5] = "linux", y[y.devtools = 6] = "devtools", y[y.other = 100] = "other", (M = H = H || {})[M.unknown = 100] = "unknown", M[M.wifi = 1] = "wifi", M[M.net2g = 2] = "net2g", M[M.net3g = 3] = "net3g", M[M.net4g = 4] = "net4g", M[M.net5g = 5] = "net5g", M[M.net6g = 6] = "net6g", (E = u = u || {}).LOG = "log", E.SPEED = "speed", E.PV = "pv", E.CUSTOM_PV = "customPV", E.EVENT = "event", E.CUSTOM = "custom", E.SDK_ERROR = "sdkError", (y = d = d || {}).production = "production", y.development = "development", y.gray = "gray", y.pre = "pre", y.daily = "daily", y.local = "local", y.test = "test", y.others = "others";
    function p(c, _) {
      var v,
        b = [],
        S = c.config;
      return c.lifeCycle.on("destroy", function () {
        b.length = 0;
      }), function (I, x) {
        if (b.push(I), _ && b.length >= _) return x(b.splice(0, b.length)), void (v && clearTimeout(v));
        v && clearTimeout(v), v = setTimeout(function () {
          v = null, 0 < b.length && x(b.splice(0, b.length));
        }, S.delay);
      };
    }
    function m(c, _) {
      return Array.isArray(c) ? _(c.map(function (v) {
        return _i(_i({}, v), {
          msg: typeof v.msg == "string" ? v.msg : [].concat(v.msg).map(h).join(" ")
        });
      })) : _(_i(_i({}, c), {
        msg: typeof c.msg == "string" ? c.msg : h(c.msg)
      }));
    }
    function R(c) {
      if (!c || !c.reduce || !c.length) throw new TypeError("createPipeline need at least one function param");
      return c.length === 1 ? function (_, v) {
        c[0](_, v || g);
      } : c.reduce(function (_, v) {
        return function (b, S) {
          return S === void 0 && (S = g), _(b, function (I) {
            return v == null ? void 0 : v(I, S);
          });
        };
      });
    }
    function T(c, _) {
      Object.getOwnPropertyNames(c).forEach(function (v) {
        typeof c[v] == "function" && v !== "constructor" && (_ ? _[v] = function () {} : c[v] = function () {});
      });
    }
    var O,
      N,
      y,
      f = function f(c) {
        return (Array.isArray(c) ? c : [c]).map(function (_) {
          return Object.getOwnPropertyNames(_).reduce(function (v, b) {
            return b !== "ctx" && (v[b] = _[b]), v;
          }, {
            level: l.INFO,
            msg: ""
          });
        });
      },
      g = function g() {},
      H = (w.prototype.init = function (c) {
        this.setConfig(c);
        for (var _ = 0; _ < w.installedPlugins.length; _++) try {
          w.installedPlugins[_].patch(this);
        } catch (v) {
          console.warn("aegis mini sdk error", v);
        }
        this.lifeCycle.emit("onInited");
      }, w.prototype.setConfig = function (D) {
        Object.assign(this.config, D);
        var L = this.config,
          _ = L.id,
          v = L.uin,
          b = L.version,
          S = L.ext1,
          I = L.ext2,
          x = L.ext3,
          C = L.aid,
          D = L.env,
          F = D === void 0 ? "production" : D,
          L = L.pageUrl;
        return this.bean.id = _ || "", this.bean.uin = v || "", this.bean.version = b || "0.0.4", this.bean.aid = C || "", this.bean.env = function () {
          switch (F) {
            case d.production:
            case d.development:
            case d.gray:
            case d.pre:
            case d.daily:
            case d.local:
            case d.test:
            case d.others:
              return 1;
            default:
              return;
          }
        }() ? F : d.others, L && this.extendBean("from", encodeURIComponent(L)), S && this.extendBean("ext1", encodeURIComponent(S)), I && this.extendBean("ext2", encodeURIComponent(I)), x && this.extendBean("ext3", encodeURIComponent(x)), this.lifeCycle.emit("onConfigChange", this.config), this.config;
      }, w.use = function (c) {
        w.installedPlugins.indexOf(c) === -1 && c.aegisPlugin && w.installedPlugins.push(c);
      }, w.unuse = function (c) {
        c = w.installedPlugins.indexOf(c), c !== -1 && w.installedPlugins.splice(c, 1);
      }, w.prototype.info = function () {
        for (var c = [], _ = 0; _ < arguments.length; _++) c[_] = arguments[_];
        var v = {
          level: l.INFO_ALL,
          msg: c
        };
        c.length === 1 && c[0].msg && Object.assign(v, _i({}, c[0]), {
          level: l.INFO_ALL
        }), this.normalLogPipeline(v);
      }, w.prototype.infoAll = function () {
        for (var c = [], _ = 0; _ < arguments.length; _++) c[_] = arguments[_];
        var v = {
          level: l.INFO_ALL,
          msg: c
        };
        c.length === 1 && c[0].msg && Object.assign(v, _i({}, c[0]), {
          level: l.INFO_ALL
        }), this.normalLogPipeline(v);
      }, w.prototype.report = function () {
        for (var c = [], _ = 0; _ < arguments.length; _++) c[_] = arguments[_];
        var v = {
          level: l.REPORT,
          msg: c
        };
        c.length === 1 && c[0].msg && Object.assign(v, _i({}, c[0])), this.normalLogPipeline(v);
      }, w.prototype.error = function () {
        for (var c = [], _ = 0; _ < arguments.length; _++) c[_] = arguments[_];
        var v = {
          level: l.ERROR,
          msg: c
        };
        c.length === 1 && c[0].msg && Object.assign(v, _i({}, c[0]), {
          level: l.ERROR
        }), this.normalLogPipeline(v);
      }, w.prototype.speedLogPipeline = function (c) {
        throw new Error('You need to override "speedLogPipeline" method');
      }, w.prototype.reportEvent = function (c) {
        c && ((c = typeof c == "string" ? {
          name: c,
          ext1: this.config.ext1 || "",
          ext2: this.config.ext2 || "",
          ext3: this.config.ext3 || ""
        } : c).name ? this.eventPipeline(c) : console.warn("reportEvent params error"));
      }, w.prototype.reportTime = function (c, _) {
        if (_typeof(c) == "object") return this.reportT(c);
        typeof c == "string" ? typeof _ == "number" ? _ < 0 || 6e4 < _ ? console.warn("reportTime: duration must between 0 and 60000") : this.submitCustomTime(c, _) : console.warn("reportTime: second param must be number") : console.warn("reportTime: first param must be a string");
      }, w.prototype.reportT = function (x) {
        var _ = x.name,
          v = x.duration,
          S = x.ext1,
          b = S === void 0 ? "" : S,
          I = x.ext2,
          S = I === void 0 ? "" : I,
          I = x.ext3,
          I = I === void 0 ? "" : I,
          x = x.from;
        if (typeof _ == "string" && typeof v == "number" && typeof b == "string" && typeof S == "string" && typeof I == "string") {
          if (!(v < 0 || 6e4 < v)) return this.submitCustomTime(_, v, b, S, I, x === void 0 ? "" : x);
          console.warn("reportTime: duration must between 0 and 60000");
        } else console.warn("reportTime: params error");
      }, w.prototype.time = function (c) {
        typeof c == "string" ? this.timeMap[c] ? console.warn("Timer " + c + " already exists") : this.timeMap[c] = Date.now() : console.warn("time: first param must be a string");
      }, w.prototype.timeEnd = function (c) {
        typeof c == "string" ? this.timeMap[c] ? (this.submitCustomTime(c, Date.now() - this.timeMap[c]), delete this.timeMap[c]) : console.warn("Timer " + c + " does not exist") : console.warn("timeEnd: first param must be a string");
      }, w.prototype.submitCustomTime = function (c, _, v, b, S, I) {
        this.customTimePipeline({
          name: c,
          duration: _,
          ext1: v || this.config.ext1,
          ext2: b || this.config.ext2,
          ext3: S || this.config.ext3,
          from: I || void 0
        });
      }, w.prototype.extendBean = function (c, _) {
        this.bean[c] = _;
      }, w.prototype.send = function (c, _, v) {
        var b,
          S,
          I,
          x = this;
        R([(S = c.type, function (C, D) {
          if (!C) return D(C);
          C = Array.isArray(C) ? C : [C], b.lifeCycle.emit("beforeRequest", C);
          var F = b.config.beforeRequest;
          (C = typeof F == "function" ? C.filter(function (L) {
            return F({
              logs: L,
              logType: S
            }) !== !1;
          }) : C).length && D(C);
        }), function (C, D) {
          x.request(c, function () {
            for (var F = [], L = 0; L < arguments.length; L++) F[L] = arguments[L];
            D({
              isErr: !1,
              result: F,
              logType: c.type,
              logs: C
            }), _ == null || _.apply(void 0, F);
          }, function () {
            for (var F = [], L = 0; L < arguments.length; L++) F[L] = arguments[L];
            D({
              isErr: !0,
              result: F,
              logType: c.type,
              logs: C
            }), v == null || v(F);
          });
        }, (I = b = this, function (C, D) {
          I.lifeCycle.emit("afterRequest", C);
          var F = I.config.afterRequest;
          typeof F == "function" && F(C) === !1 || D(C);
        })])(c.log);
      }, w.prototype.request = function (c, _, v) {
        throw new Error('You need to override "request" method');
      }, w.prototype.destroy = function (c) {
        c === void 0 && (c = !1);
        var _,
          v,
          b = w.instances.indexOf(this);
        b !== -1 && w.instances.splice(b, 1);
        for (var S = w.installedPlugins.length - 1; 0 <= S; S--) try {
          var I = w.installedPlugins[S];
          I.unpatch(this), I.countInstance() === 0 && (I.uninstall(), w.unuse(I), I = null);
        } catch (C) {
          console.warn("aegis mini sdk error", C);
        }
        if (this.lifeCycle.emit("destroy"), this.lifeCycle.clear(), c) _ = this, v = Object.getOwnPropertyDescriptors(_), Object.keys(v).forEach(function (C) {
          v[C].writable && (_[C] = null);
        }), Object.setPrototypeOf(this, null);else {
          for (var x = this; x.constructor !== Object && T(x, this), x = Object.getPrototypeOf(x););
          w.instances.length === 0 && (c = Object.getPrototypeOf(this).constructor, T(c), T(w));
        }
      }, w.instances = [], w.LogType = l, w.installedPlugins = [], w),
      M = (A.prototype.patch = function (c) {
        this.canUse(c) && this.exist(c) && (this.instances.push(c), this.triggerInit(c), this.triggerOnNewAegis(c));
      }, A.prototype.unpatch = function (c) {
        c = this.instances.indexOf(c), c !== -1 && this.instances.splice(c, 1);
      }, A.prototype.countInstance = function () {
        return this.instances.length;
      }, A.prototype.uninstall = function () {
        var c;
        (c = (c = this.option) === null || c === void 0 ? void 0 : c.destroy) === null || c === void 0 || c.apply(this);
      }, A.prototype.walk = function (c) {
        var _ = this;
        this.instances.forEach(function (v) {
          var b = _.canUse(v);
          b && c(v, b);
        });
      }, A.prototype.canUse = function (c) {
        return c = this.getConfig(c), !(!c || _typeof(c) != "object") || !!c;
      }, A.prototype.getConfig = function (c) {
        return (c = c.config) === null || c === void 0 ? void 0 : c[this.name];
      }, A.prototype.exist = function (c) {
        return this.instances.indexOf(c) === -1;
      }, A.prototype.triggerInit = function (c) {
        var _;
        this.inited || (this.inited = !0, (_ = (_ = this.option) === null || _ === void 0 ? void 0 : _.init) === null || _ === void 0 || _.call(this.option, this.getConfig(c)));
      }, A.prototype.triggerOnNewAegis = function (c) {
        var _;
        (_ = (_ = this.option) === null || _ === void 0 ? void 0 : _.onNewAegis) === null || _ === void 0 || _.call(this.option, c, this.getConfig(c));
      }, A),
      E = new M({
        name: "aid",
        aid: "",
        init: function init(c) {
          try {
            var _ = c !== !0 && c || window.localStorage.getItem("AEGIS_ID");
            _ || (_ = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (v) {
              var b = 16 * Math.random() | 0;
              return (v === "x" ? b : 3 & b | 8).toString(16);
            }), window.localStorage.setItem("AEGIS_ID", _)), this.aid = _;
          } catch (_unused2) {}
        },
        onNewAegis: function onNewAegis(c) {
          c.bean.aid = this.aid, c.config.aid = this.aid;
        }
      });
    function A(c) {
      this.aegisPlugin = !0, this.name = "", this.instances = [], this.inited = !1, c.$walk = this.walk.bind(this), c.$getConfig = this.getConfig.bind(this), this.option = c, this.name = c.name;
    }
    function w(c) {
      var _,
        v,
        b,
        S = this;
      this.config = {
        version: 0,
        delay: 1e3,
        repeat: 5,
        random: 1,
        aid: !0,
        env: "production",
        device: !0,
        speedSample: !0,
        hostUrl: "https://aegis.qq.com",
        url: "",
        pvUrl: "",
        speedUrl: "",
        customTimeUrl: "",
        eventUrl: ""
      }, this.lifeCycle = new r(), this.bean = {}, this.normalLogPipeline = R([p(this, 5), m, function (I, x) {
        if (typeof _.config.random != "number" && (console.warn("random must in [0, 1], default is 1."), _.config.random = 1), Math.random() < _.config.random) return x(I);
      }, (b = _ = this, function (I, x) {
        return b.send({
          url: b.config.url || "",
          data: o(f(I)),
          method: "post",
          contentType: "application/json",
          type: u.LOG,
          log: I
        }, function () {
          var C = b.config.onReport;
          typeof C == "function" && I.forEach(function (D) {
            C(D);
          }), typeof x == "function" && x([]);
        }, function (C) {
          C === "403 forbidden" && b.destroy();
        });
      })]), this.eventPipeline = R([p(this, 5), function (I) {
        var x = I.map(function (C) {
          return {
            name: C.name,
            ext1: C.ext1 || S.config.ext1 || "",
            ext2: C.ext2 || S.config.ext2 || "",
            ext3: C.ext3 || S.config.ext3 || ""
          };
        });
        return S.send({
          url: S.config.eventUrl + "?payload=" + encodeURIComponent(JSON.stringify(x)),
          type: u.EVENT,
          log: I
        }, function () {}, function (C) {
          C === "403 forbidden" && S.destroy();
        });
      }]), this.timeMap = {}, this.customTimePipeline = R([p(this, 5), function (I) {
        return S.send({
          url: S.config.customTimeUrl + "?payload=" + encodeURIComponent(JSON.stringify({
            custom: I
          })),
          type: u.CUSTOM,
          log: I
        }, function () {}, function (x) {
          x === "403 forbidden" && S.destroy();
        });
      }]), this.config = (v = this.config, (c = c.hostUrl) === void 0 && (c = "https://aegis.qq.com"), v.url = v.url || c + "/collect", v.pvUrl = v.pvUrl || c + "/collect/pv", v.eventUrl = v.eventUrl || c + "/collect/events", v.speedUrl = v.speedUrl || c + "/speed", v.customTimeUrl = v.customTimeUrl || c + "/speed/custom", v), w.instances.push(this);
    }
    (y = O = O || {})[y.unknown = 100] = "unknown", y[y.wifi = 1] = "wifi", y[y.net2g = 2] = "net2g", y[y.net3g = 3] = "net3g", y[y.net4g = 4] = "net4g", y[y.net5g = 5] = "net5g", y[y.net6g = 6] = "net6g", (y = N = N || {})[y.android = 1] = "android", y[y.ios = 2] = "ios", y[y.windows = 3] = "windows", y[y.macos = 4] = "macos", y[y.linux = 5] = "linux", y[y.other = 100] = "other";
    var k,
      P,
      M = new M({
        name: "device",
        onNewAegis: function onNewAegis(c) {
          c.extendBean("platform", this.getPlatform()), c.extendBean("netType", O.unknown), this.refreshNetworkTypeToBean(c);
        },
        getPlatform: function getPlatform() {
          var c = {
              android: /\bAndroid\s*([^;]+)/,
              ios: /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/,
              windows: /\b(Windows NT)/,
              macos: /\b(Mac OS)/,
              linux: /\b(Linux)/i
            },
            _ = Object.keys(c).find(function (v) {
              return c[v].test(navigator.userAgent);
            });
          return _ ? N[_] : N.other;
        },
        refreshNetworkTypeToBean: function refreshNetworkTypeToBean(c) {
          var _ = this,
            v = c.config;
          v && (typeof v.getNetworkType == "function" ? v.getNetworkType : U)(function (b) {
            O[b] || (b = O.unknown), c.extendBean("netType", b), _.NetworkRefreshTimer = setTimeout(function () {
              _.refreshNetworkTypeToBean(c), clearTimeout(_.NetworkRefreshTimer);
            }, 1e4);
          });
        }
      }),
      U = function U(c) {
        var _ = "",
          v = navigator.userAgent.match(/NetType\/(\w+)/);
        v ? _ = v[1] : navigator.connection && (_ = navigator.connection.effectiveType || navigator.connection.type), c((_ = _ = _ || "unknown", 0 <= (_ = String(_).toLowerCase()).indexOf("4g") ? O.net4g : 0 <= _.indexOf("wifi") ? O.wifi : 0 <= _.indexOf("5g") ? O.net5g : 0 <= _.indexOf("6g") ? O.net6g : 0 <= _.indexOf("3g") ? O.net3g : 0 <= _.indexOf("2g") ? O.net2g : O.unknown));
      },
      B = function B(c) {
        if (c.payload) {
          var _ = {};
          return Object.keys(c).forEach(function (v) {
            v !== "payload" && (_[v] = c[v]);
          }), _;
        }
        return c;
      },
      H = (_e(P = V, H = k = H), P.prototype = H === null ? Object.create(H) : (G.prototype = H.prototype, new G()), V.prototype.getBean = function (c) {
        var _ = this;
        return c === void 0 && (c = []), "" + Object.getOwnPropertyNames(this.bean).filter(function (v) {
          return c.indexOf(v) === -1;
        }).map(function (v) {
          return v + "=" + _.bean[v];
        }).join("&");
      }, V.prototype.request = function (c, _, v) {
        var b = this;
        if (c && typeof c.url == "string" && c.url !== "" && this.bean.id) if (this.requesting) this.requestQueue.push({
          options: c,
          success: _,
          fail: v
        });else {
          this.requesting = !0;
          var I = c.url;
          c.addBean !== !1 && (I = I + (I.indexOf("?") === -1 ? "?" : "&") + this.getBean(c.beanFilter)), c.url = I;
          var S = c.method || "get",
            I = this.config.onBeforeRequest;
          if (!(c = I ? I(c, this) : c)) return console.log("Sending request blocked");
          if (!c.url) return console.warn("Please handle the parameters reasonably, options.url is necessary");
          var x = new XMLHttpRequest();
          x.sendByAegis = !0, x.addEventListener("readystatechange", function () {
            var C;
            x.readyState === 4 && (b.requesting = !1, b.requestQueue && ((C = b.requestQueue.shift()) && b.request(C.options, C.success, C.fail), 400 <= x.status || x.status === 0 ? v == null || v(x.response) : _ == null || _(x.response)));
          }), S.toLocaleLowerCase() === "get" ? (x.open("get", function (C, D) {
            if (typeof C != "string") return "";
            if (_typeof(D) == "object" && D) {
              var F = Object.getOwnPropertyNames(D).map(function (L) {
                var j = D[L];
                return L + "=" + encodeURIComponent(typeof j == "string" ? j : JSON.stringify(j));
              }).join("&").replace(/eval/gi, "evaI");
              return C + (C.indexOf("?") === -1 ? "?" : "&") + F;
            }
            return C;
          }(c.url, c.data)), x.send()) : (x.open("post", c.url), c.contentType && x.setRequestHeader("Content-Type", c.contentType), typeof c.data == "string" && (c.data = c.data.replace(/eval/gi, "evaI")), x.send(c.data));
        }
      }, V.sessionID = "session-" + Date.now(), V);
    function V(c) {
      var _,
        v,
        b,
        S = k.call(this, c) || this;
      S.requestQueue = [], S.requesting = !1, S.speedLogPipeline = R([p(S), (b = S, function (I, x) {
        U(function (C) {
          b.extendBean("netType", C), x(I);
        });
      }), function (I) {
        return S.send({
          type: u.SPEED,
          url: "" + S.config.speedUrl,
          method: "post",
          data: (x = I, C = S.bean, F = {
            fetch: [],
            "static": []
          }, L = new FormData(), Array.isArray(x) ? x.forEach(function (j) {
            var Y = B(j);
            F[j.type].push(Y);
          }) : (D = B(x), F[x.type].push(D)), L.append("payload", JSON.stringify(_i({
            duration: F
          }, C))), L),
          log: I
        });
        var x, C, D, F, L;
      }]);
      try {
        (typeof document === "undefined" ? "undefined" : _typeof(document)) < "u" && (c.uin = c.uin || ((_ = document.cookie.match(/\buin=\D+(\d*)/)) !== null && _ !== void 0 ? _ : [])[1] || ((v = document.cookie.match(/\bilive_uin=\D*(\d+)/)) !== null && v !== void 0 ? v : [])[1] || ""), S.init(c), S.extendBean("sessionId", V.sessionID), S.extendBean("from", encodeURIComponent(c.pageUrl || location.href)), (typeof document === "undefined" ? "undefined" : _typeof(document)) < "u" && S.extendBean("referer", encodeURIComponent(document.referrer || "")), c.ext1 && S.extendBean("ext1", c.ext1), c.ext2 && S.extendBean("ext2", c.ext2), c.ext3 && S.extendBean("ext3", c.ext3);
      } catch (I) {
        console.warn(I), console.log("%cThe above error occurred in the process of initializing Aegis, which will affect your normal use of Aegis.\nIt is recommended that you contact us for feedback and thank you for your support.", "color: red");
      }
      return S;
    }
    function G() {
      this.constructor = P;
    }
    return H.use(E), H.use(M), H;
  });
})(aegis_min);
var Aegis = aegis_minExports;
var LogLevel;
(function (t) {
  t.REQ_LOG = "1", t.COMMON = "2", t.JS_ERR = "4", t.PROMISE_ERR = "8", t.AJAX_ERR = "16", t.JS_LOAD_ERR = "32", t.IMG_LOAD_ERR = "64", t.CSS_LOAD_ERR = "128", t.AUDIO_LOAD_ERR = "512", t.RETCODE_ERR = "1024", t.AEGIS_LOG = "2048";
})(LogLevel || (LogLevel = {}));
var CmsCustomRum = /** @class */
  function () {
    function t(n) {
      this.aegis = new Aegis(n);
    }
    return t.getInstance = function (n) {
      var e = n !== null && n !== void 0 ? n : {},
        i = e.rum_id,
        r = i === void 0 ? DEFAULT_RUM_ID : i,
        o = e.rum_host,
        a = o === void 0 ? DEFAULT_RUM_HOST : o;
      if (!this.instance || n) {
        var s = {
          id: r,
          hostUrl: a
        };
        this.instance = new t(Object.assign({}, n, s));
      }
      return this.instance;
    }, t.prototype.getAegies = function () {
      return this.aegis;
    }, t.prototype.report = function (n) {
      var e = n.msg,
        i = n.level,
        r = n.module,
        o = n.prefix,
        a = o === void 0 ? "cms_custom_aegis" : o,
        s = e;
      a && (s = "[".concat(a, "]-").concat(s)), r && (s = "[".concat(r, "]-").concat(s)), this.aegis.report({
        level: i,
        msg: s
      });
    }, t;
  }(),
  cms_custom_aegis = CmsCustomRum.getInstance(),
  FileSaver_minExports = {},
  FileSaver_min = {
    get exports() {
      return FileSaver_minExports;
    },
    set exports(t) {
      FileSaver_minExports = t;
    }
  };
(function (t, n) {
  (function (e, i) {
    i();
  })(commonjsGlobal, function () {
    function e(u, d) {
      return _typeof(d) > "u" ? d = {
        autoBom: !1
      } : _typeof(d) != "object" && (console.warn("Deprecated: Expected third argument to be a object"), d = {
        autoBom: !d
      }), d.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(u.type) ? new Blob(["\uFEFF", u], {
        type: u.type
      }) : u;
    }
    function i(u, d, h) {
      var p = new XMLHttpRequest();
      p.open("GET", u), p.responseType = "blob", p.onload = function () {
        l(p.response, d, h);
      }, p.onerror = function () {
        console.error("could not download file");
      }, p.send();
    }
    function r(u) {
      var d = new XMLHttpRequest();
      d.open("HEAD", u, !1);
      try {
        d.send();
      } catch (_unused3) {}
      return 200 <= d.status && 299 >= d.status;
    }
    function o(u) {
      try {
        u.dispatchEvent(new MouseEvent("click"));
      } catch (_unused4) {
        var d = document.createEvent("MouseEvents");
        d.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), u.dispatchEvent(d);
      }
    }
    var a = (typeof window === "undefined" ? "undefined" : _typeof(window)) == "object" && window.window === window ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) == "object" && self.self === self ? self : _typeof(commonjsGlobal) == "object" && commonjsGlobal.global === commonjsGlobal ? commonjsGlobal : void 0,
      s = a.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent),
      l = a.saveAs || ((typeof window === "undefined" ? "undefined" : _typeof(window)) != "object" || window !== a ? function () {} : "download" in HTMLAnchorElement.prototype && !s ? function (u, d, h) {
        var p = a.URL || a.webkitURL,
          m = document.createElement("a");
        d = d || u.name || "download", m.download = d, m.rel = "noopener", typeof u == "string" ? (m.href = u, m.origin === location.origin ? o(m) : r(m.href) ? i(u, d, h) : o(m, m.target = "_blank")) : (m.href = p.createObjectURL(u), setTimeout(function () {
          p.revokeObjectURL(m.href);
        }, 4e4), setTimeout(function () {
          o(m);
        }, 0));
      } : "msSaveOrOpenBlob" in navigator ? function (u, d, h) {
        if (d = d || u.name || "download", typeof u != "string") navigator.msSaveOrOpenBlob(e(u, h), d);else if (r(u)) i(u, d, h);else {
          var p = document.createElement("a");
          p.href = u, p.target = "_blank", setTimeout(function () {
            o(p);
          });
        }
      } : function (u, d, h, p) {
        if (p = p || open("", "_blank"), p && (p.document.title = p.document.body.innerText = "downloading..."), typeof u == "string") return i(u, d, h);
        var m = u.type === "application/octet-stream",
          R = /constructor/i.test(a.HTMLElement) || a.safari,
          T = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((T || m && R || s) && (typeof FileReader === "undefined" ? "undefined" : _typeof(FileReader)) < "u") {
          var O = new FileReader();
          O.onloadend = function () {
            var f = O.result;
            f = T ? f : f.replace(/^data:[^;]*;/, "data:attachment/file;"), p ? p.location.href = f : location = f, p = null;
          }, O.readAsDataURL(u);
        } else {
          var N = a.URL || a.webkitURL,
            y = N.createObjectURL(u);
          p ? p.location = y : location.href = y, p = null, setTimeout(function () {
            N.revokeObjectURL(y);
          }, 4e4);
        }
      });
    a.saveAs = l.saveAs = l, t.exports = l;
  });
})(FileSaver_min);
function supportFile() {
  return !!Blob;
}
function dataURLtoFile(t, n) {
  for (var e = t.split(","), i = e[0].match(/:(.*?);/)[1], r = atob(e[1]), o = r.length, a = new Uint8Array(o); o--;) a[o] = r.charCodeAt(o);
  return {
    file: new File([a], n, {
      type: i
    }),
    blob: new Blob([a], {
      type: i
    })
  };
}
var download = function () {
    var t = document.createElement("iframe"),
      n = function n() {
        return /CriOS\/[\d]+/.test(navigator.userAgent);
      };
    return window.addEventListener("DOMContentLoaded", function () {
      var e;
      t.style.display = "none", (e = document.body) === null || e === void 0 || e.appendChild(t);
    }), function (e) {
      var i,
        r = e.base64,
        o = e.filename,
        a = o === void 0 ? "file" : o,
        s = getSys(),
        l = s.name,
        u = s.version;
      if (l === "iOS") {
        var d = dataURLtoFile(r, a),
          h = d.file,
          p = d.blob,
          m = [h];
        if (!t.contentWindow) throw new Error("iframe not ready");
        (Number(u !== null && u !== void 0 ? u : 0) <= 13.7 || n()) && FileSaver_minExports.saveAs(p, a);
        try {
          (i = t.contentWindow) === null || i === void 0 || i.navigator.share({
            files: m
          }).then(function () {
            var T;
            (T = t.contentWindow) === null || T === void 0 || T.location.reload();
          })["catch"](function () {
            var T;
            (T = t.contentWindow) === null || T === void 0 || T.location.reload(), FileSaver_minExports.saveAs(p, a);
          });
        } catch (_unused5) {
          FileSaver_minExports.saveAs(p, a);
        }
      } else {
        var R = document.createElement("a");
        R.download = a, R.href = r, R.click();
      }
    };
  }(),
  MapShim = function () {
    if ((typeof Map === "undefined" ? "undefined" : _typeof(Map)) < "u") return Map;
    function t(n, e) {
      var i = -1;
      return n.some(function (r, o) {
        return r[0] === e ? (i = o, !0) : !1;
      }), i;
    }
    return (/** @class */
      function () {
        function n() {
          this.__entries__ = [];
        }
        return Object.defineProperty(n.prototype, "size", {
          /**
           * @returns {boolean}
           */
          get: function get() {
            return this.__entries__.length;
          },
          enumerable: !0,
          configurable: !0
        }), n.prototype.get = function (e) {
          var i = t(this.__entries__, e),
            r = this.__entries__[i];
          return r && r[1];
        }, n.prototype.set = function (e, i) {
          var r = t(this.__entries__, e);
          ~r ? this.__entries__[r][1] = i : this.__entries__.push([e, i]);
        }, n.prototype["delete"] = function (e) {
          var i = this.__entries__,
            r = t(i, e);
          ~r && i.splice(r, 1);
        }, n.prototype.has = function (e) {
          return !!~t(this.__entries__, e);
        }, n.prototype.clear = function () {
          this.__entries__.splice(0);
        }, n.prototype.forEach = function (e, i) {
          i === void 0 && (i = null);
          for (var r = 0, o = this.__entries__; r < o.length; r++) {
            var a = o[r];
            e.call(i, a[1], a[0]);
          }
        }, n;
      }()
    );
  }(),
  isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && (typeof document === "undefined" ? "undefined" : _typeof(document)) < "u" && window.document === document,
  global$1$1 = function () {
    return (typeof global === "undefined" ? "undefined" : _typeof(global)) < "u" && global.Math === Math ? global : (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" && self.Math === Math ? self : (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window.Math === Math ? window : Function("return this")();
  }(),
  requestAnimationFrame$1 = function () {
    return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1$1) : function (t) {
      return setTimeout(function () {
        return t(Date.now());
      }, 1e3 / 60);
    };
  }(),
  trailingTimeout = 2;
function throttle(t, n) {
  var e = !1,
    i = !1,
    r = 0;
  function o() {
    e && (e = !1, t()), i && s();
  }
  function a() {
    requestAnimationFrame$1(o);
  }
  function s() {
    var l = Date.now();
    if (e) {
      if (l - r < trailingTimeout) return;
      i = !0;
    } else e = !0, i = !1, setTimeout(a, n);
    r = l;
  }
  return s;
}
var REFRESH_DELAY = 20,
  transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
  mutationObserverSupported = (typeof MutationObserver === "undefined" ? "undefined" : _typeof(MutationObserver)) < "u",
  ResizeObserverController = /** @class */
  function () {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    return t.prototype.addObserver = function (n) {
      ~this.observers_.indexOf(n) || this.observers_.push(n), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function (n) {
      var e = this.observers_,
        i = e.indexOf(n);
      ~i && e.splice(i, 1), !e.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function () {
      var n = this.updateObservers_();
      n && this.refresh();
    }, t.prototype.updateObservers_ = function () {
      var n = this.observers_.filter(function (e) {
        return e.gatherActive(), e.hasActive();
      });
      return n.forEach(function (e) {
        return e.broadcastActive();
      }), n.length > 0;
    }, t.prototype.connect_ = function () {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function () {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function (n) {
      var e = n.propertyName,
        i = e === void 0 ? "" : e,
        r = transitionKeys.some(function (o) {
          return !!~i.indexOf(o);
        });
      r && this.refresh();
    }, t.getInstance = function () {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }(),
  defineConfigurable = function defineConfigurable(t, n) {
    for (var e = 0, i = Object.keys(n); e < i.length; e++) {
      var r = i[e];
      Object.defineProperty(t, r, {
        value: n[r],
        enumerable: !1,
        writable: !1,
        configurable: !0
      });
    }
    return t;
  },
  getWindowOf = function getWindowOf(t) {
    var n = t && t.ownerDocument && t.ownerDocument.defaultView;
    return n || global$1$1;
  },
  emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(t) {
  return parseFloat(t) || 0;
}
function getBordersSize(t) {
  for (var n = [], e = 1; e < arguments.length; e++) n[e - 1] = arguments[e];
  return n.reduce(function (i, r) {
    var o = t["border-" + r + "-width"];
    return i + toFloat(o);
  }, 0);
}
function getPaddings(t) {
  for (var n = ["top", "right", "bottom", "left"], e = {}, i = 0, r = n; i < r.length; i++) {
    var o = r[i],
      a = t["padding-" + o];
    e[o] = toFloat(a);
  }
  return e;
}
function getSVGContentRect(t) {
  var n = t.getBBox();
  return createRectInit(0, 0, n.width, n.height);
}
function getHTMLElementContentRect(t) {
  var n = t.clientWidth,
    e = t.clientHeight;
  if (!n && !e) return emptyRect;
  var i = getWindowOf(t).getComputedStyle(t),
    r = getPaddings(i),
    o = r.left + r.right,
    a = r.top + r.bottom,
    s = toFloat(i.width),
    l = toFloat(i.height);
  if (i.boxSizing === "border-box" && (Math.round(s + o) !== n && (s -= getBordersSize(i, "left", "right") + o), Math.round(l + a) !== e && (l -= getBordersSize(i, "top", "bottom") + a)), !isDocumentElement(t)) {
    var u = Math.round(s + o) - n,
      d = Math.round(l + a) - e;
    Math.abs(u) !== 1 && (s -= u), Math.abs(d) !== 1 && (l -= d);
  }
  return createRectInit(r.left, r.top, s, l);
}
var isSVGGraphicsElement = function () {
  return (typeof SVGGraphicsElement === "undefined" ? "undefined" : _typeof(SVGGraphicsElement)) < "u" ? function (t) {
    return t instanceof getWindowOf(t).SVGGraphicsElement;
  } : function (t) {
    return t instanceof getWindowOf(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function isDocumentElement(t) {
  return t === getWindowOf(t).document.documentElement;
}
function getContentRect(t) {
  return isBrowser ? isSVGGraphicsElement(t) ? getSVGContentRect(t) : getHTMLElementContentRect(t) : emptyRect;
}
function createReadOnlyRect(t) {
  var n = t.x,
    e = t.y,
    i = t.width,
    r = t.height,
    o = (typeof DOMRectReadOnly === "undefined" ? "undefined" : _typeof(DOMRectReadOnly)) < "u" ? DOMRectReadOnly : Object,
    a = Object.create(o.prototype);
  return defineConfigurable(a, {
    x: n,
    y: e,
    width: i,
    height: r,
    top: e,
    right: n + i,
    bottom: r + e,
    left: n
  }), a;
}
function createRectInit(t, n, e, i) {
  return {
    x: t,
    y: n,
    width: e,
    height: i
  };
}
var ResizeObservation = /** @class */
  function () {
    function t(n) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = n;
    }
    return t.prototype.isActive = function () {
      var n = getContentRect(this.target);
      return this.contentRect_ = n, n.width !== this.broadcastWidth || n.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function () {
      var n = this.contentRect_;
      return this.broadcastWidth = n.width, this.broadcastHeight = n.height, n;
    }, t;
  }(),
  ResizeObserverEntry = /** @class */
  function () {
    function t(n, e) {
      var i = createReadOnlyRect(e);
      defineConfigurable(this, {
        target: n,
        contentRect: i
      });
    }
    return t;
  }(),
  ResizeObserverSPI = /** @class */
  function () {
    function t(n, e, i) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof n != "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = n, this.controller_ = e, this.callbackCtx_ = i;
    }
    return t.prototype.observe = function (n) {
      if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
      if (!((typeof Element === "undefined" ? "undefined" : _typeof(Element)) > "u" || !(Element instanceof Object))) {
        if (!(n instanceof getWindowOf(n).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var e = this.observations_;
        e.has(n) || (e.set(n, new ResizeObservation(n)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function (n) {
      if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
      if (!((typeof Element === "undefined" ? "undefined" : _typeof(Element)) > "u" || !(Element instanceof Object))) {
        if (!(n instanceof getWindowOf(n).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var e = this.observations_;
        e.has(n) && (e["delete"](n), e.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function () {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function () {
      var n = this;
      this.clearActive(), this.observations_.forEach(function (e) {
        e.isActive() && n.activeObservations_.push(e);
      });
    }, t.prototype.broadcastActive = function () {
      if (this.hasActive()) {
        var n = this.callbackCtx_,
          e = this.activeObservations_.map(function (i) {
            return new ResizeObserverEntry(i.target, i.broadcastRect());
          });
        this.callback_.call(n, e, n), this.clearActive();
      }
    }, t.prototype.clearActive = function () {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function () {
      return this.activeObservations_.length > 0;
    }, t;
  }(),
  observers = (typeof WeakMap === "undefined" ? "undefined" : _typeof(WeakMap)) < "u" ? /* @__PURE__ */new WeakMap() : new MapShim(),
  ResizeObserver$1 = /** @class */
  function () {
    function t(n) {
      if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
      var e = ResizeObserverController.getInstance(),
        i = new ResizeObserverSPI(n, e, this);
      observers.set(this, i);
    }
    return t;
  }();
["observe", "unobserve", "disconnect"].forEach(function (t) {
  ResizeObserver$1.prototype[t] = function () {
    var n;
    return (n = observers.get(this))[t].apply(n, arguments);
  };
});
var index$1 = function () {
  return _typeof(global$1$1.ResizeObserver) < "u" ? global$1$1.ResizeObserver : ResizeObserver$1;
}();
(function () {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) != "object") return;
  if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
    "isIntersecting" in window.IntersectionObserverEntry.prototype || Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
      get: function get() {
        return this.intersectionRatio > 0;
      }
    });
    return;
  }
  function t(f) {
    try {
      return f.defaultView && f.defaultView.frameElement || null;
    } catch (_unused6) {
      return null;
    }
  }
  var n = function (f) {
      for (var g = f, E = t(g); E;) g = E.ownerDocument, E = t(g);
      return g;
    }(window.document),
    e = [],
    i = null,
    r = null;
  function o(f) {
    this.time = f.time, this.target = f.target, this.rootBounds = R(f.rootBounds), this.boundingClientRect = R(f.boundingClientRect), this.intersectionRect = R(f.intersectionRect || m()), this.isIntersecting = !!f.intersectionRect;
    var g = this.boundingClientRect,
      E = g.width * g.height,
      A = this.intersectionRect,
      w = A.width * A.height;
    E ? this.intersectionRatio = Number((w / E).toFixed(4)) : this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
  function a(f, g) {
    var E = g || {};
    if (typeof f != "function") throw new Error("callback must be a function");
    if (E.root && E.root.nodeType != 1 && E.root.nodeType != 9) throw new Error("root must be a Document or Element");
    this._checkForIntersections = l(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT), this._callback = f, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin(E.rootMargin), this.thresholds = this._initThresholds(E.threshold), this.root = E.root || null, this.rootMargin = this._rootMarginValues.map(function (A) {
      return A.value + A.unit;
    }).join(" "), this._monitoringDocuments = [], this._monitoringUnsubscribes = [];
  }
  a.prototype.THROTTLE_TIMEOUT = 100, a.prototype.POLL_INTERVAL = null, a.prototype.USE_MUTATION_OBSERVER = !0, a._setupCrossOriginUpdater = function () {
    return i || (i = function i(f, g) {
      !f || !g ? r = m() : r = T(f, g), e.forEach(function (E) {
        E._checkForIntersections();
      });
    }), i;
  }, a._resetCrossOriginUpdater = function () {
    i = null, r = null;
  }, a.prototype.observe = function (f) {
    var g = this._observationTargets.some(function (E) {
      return E.element == f;
    });
    if (!g) {
      if (!(f && f.nodeType == 1)) throw new Error("target must be an Element");
      this._registerInstance(), this._observationTargets.push({
        element: f,
        entry: null
      }), this._monitorIntersections(f.ownerDocument), this._checkForIntersections();
    }
  }, a.prototype.unobserve = function (f) {
    this._observationTargets = this._observationTargets.filter(function (g) {
      return g.element != f;
    }), this._unmonitorIntersections(f.ownerDocument), this._observationTargets.length == 0 && this._unregisterInstance();
  }, a.prototype.disconnect = function () {
    this._observationTargets = [], this._unmonitorAllIntersections(), this._unregisterInstance();
  }, a.prototype.takeRecords = function () {
    var f = this._queuedEntries.slice();
    return this._queuedEntries = [], f;
  }, a.prototype._initThresholds = function (f) {
    var g = f || [0];
    return Array.isArray(g) || (g = [g]), g.sort().filter(function (E, A, w) {
      if (typeof E != "number" || isNaN(E) || E < 0 || E > 1) throw new Error("threshold must be a number between 0 and 1 inclusively");
      return E !== w[A - 1];
    });
  }, a.prototype._parseRootMargin = function (f) {
    var g = f || "0px",
      E = g.split(/\s+/).map(function (A) {
        var w = /^(-?\d*\.?\d+)(px|%)$/.exec(A);
        if (!w) throw new Error("rootMargin must be specified in pixels or percent");
        return {
          value: parseFloat(w[1]),
          unit: w[2]
        };
      });
    return E[1] = E[1] || E[0], E[2] = E[2] || E[0], E[3] = E[3] || E[1], E;
  }, a.prototype._monitorIntersections = function (f) {
    var g = f.defaultView;
    if (g && this._monitoringDocuments.indexOf(f) == -1) {
      var E = this._checkForIntersections,
        A = null,
        w = null;
      this.POLL_INTERVAL ? A = g.setInterval(E, this.POLL_INTERVAL) : (u(g, "resize", E, !0), u(f, "scroll", E, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in g && (w = new g.MutationObserver(E), w.observe(f, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      }))), this._monitoringDocuments.push(f), this._monitoringUnsubscribes.push(function () {
        var M = f.defaultView;
        M && (A && M.clearInterval(A), d(M, "resize", E, !0)), d(f, "scroll", E, !0), w && w.disconnect();
      });
      var k = this.root && (this.root.ownerDocument || this.root) || n;
      if (f != k) {
        var P = t(f);
        P && this._monitorIntersections(P.ownerDocument);
      }
    }
  }, a.prototype._unmonitorIntersections = function (f) {
    var g = this._monitoringDocuments.indexOf(f);
    if (g != -1) {
      var E = this.root && (this.root.ownerDocument || this.root) || n,
        A = this._observationTargets.some(function (P) {
          var M = P.element.ownerDocument;
          if (M == f) return !0;
          for (; M && M != E;) {
            var U = t(M);
            if (M = U && U.ownerDocument, M == f) return !0;
          }
          return !1;
        });
      if (!A) {
        var w = this._monitoringUnsubscribes[g];
        if (this._monitoringDocuments.splice(g, 1), this._monitoringUnsubscribes.splice(g, 1), w(), f != E) {
          var k = t(f);
          k && this._unmonitorIntersections(k.ownerDocument);
        }
      }
    }
  }, a.prototype._unmonitorAllIntersections = function () {
    var f = this._monitoringUnsubscribes.slice(0);
    this._monitoringDocuments.length = 0, this._monitoringUnsubscribes.length = 0;
    for (var g = 0; g < f.length; g++) f[g]();
  }, a.prototype._checkForIntersections = function () {
    if (!(!this.root && i && !r)) {
      var f = this._rootIsInDom(),
        g = f ? this._getRootRect() : m();
      this._observationTargets.forEach(function (E) {
        var A = E.element,
          w = p(A),
          k = this._rootContainsTarget(A),
          P = E.entry,
          M = f && k && this._computeTargetAndRootIntersection(A, w, g),
          U = null;
        this._rootContainsTarget(A) ? (!i || this.root) && (U = g) : U = m();
        var B = E.entry = new o({
          time: s(),
          target: A,
          boundingClientRect: w,
          rootBounds: U,
          intersectionRect: M
        });
        P ? f && k ? this._hasCrossedThreshold(P, B) && this._queuedEntries.push(B) : P && P.isIntersecting && this._queuedEntries.push(B) : this._queuedEntries.push(B);
      }, this), this._queuedEntries.length && this._callback(this.takeRecords(), this);
    }
  }, a.prototype._computeTargetAndRootIntersection = function (f, g, E) {
    if (window.getComputedStyle(f).display != "none") {
      for (var A = g, w = N(f), k = !1; !k && w;) {
        var P = null,
          M = w.nodeType == 1 ? window.getComputedStyle(w) : {};
        if (M.display == "none") return null;
        if (w == this.root || w.nodeType == /* DOCUMENT */
        9) {
          if (k = !0, w == this.root || w == n) i && !this.root ? !r || r.width == 0 && r.height == 0 ? (w = null, P = null, A = null) : P = r : P = E;else {
            var U = N(w),
              B = U && p(U),
              H = U && this._computeTargetAndRootIntersection(U, B, E);
            B && H ? (w = U, P = T(B, H)) : (w = null, A = null);
          }
        } else {
          var V = w.ownerDocument;
          w != V.body && w != V.documentElement && M.overflow != "visible" && (P = p(w));
        }
        if (P && (A = h(P, A)), !A) break;
        w = w && N(w);
      }
      return A;
    }
  }, a.prototype._getRootRect = function () {
    var f;
    if (this.root && !y(this.root)) f = p(this.root);else {
      var g = y(this.root) ? this.root : n,
        E = g.documentElement,
        A = g.body;
      f = {
        top: 0,
        left: 0,
        right: E.clientWidth || A.clientWidth,
        width: E.clientWidth || A.clientWidth,
        bottom: E.clientHeight || A.clientHeight,
        height: E.clientHeight || A.clientHeight
      };
    }
    return this._expandRectByRootMargin(f);
  }, a.prototype._expandRectByRootMargin = function (f) {
    var g = this._rootMarginValues.map(function (A, w) {
        return A.unit == "px" ? A.value : A.value * (w % 2 ? f.width : f.height) / 100;
      }),
      E = {
        top: f.top - g[0],
        right: f.right + g[1],
        bottom: f.bottom + g[2],
        left: f.left - g[3]
      };
    return E.width = E.right - E.left, E.height = E.bottom - E.top, E;
  }, a.prototype._hasCrossedThreshold = function (f, g) {
    var E = f && f.isIntersecting ? f.intersectionRatio || 0 : -1,
      A = g.isIntersecting ? g.intersectionRatio || 0 : -1;
    if (E !== A) for (var w = 0; w < this.thresholds.length; w++) {
      var k = this.thresholds[w];
      if (k == E || k == A || k < E != k < A) return !0;
    }
  }, a.prototype._rootIsInDom = function () {
    return !this.root || O(n, this.root);
  }, a.prototype._rootContainsTarget = function (f) {
    var g = this.root && (this.root.ownerDocument || this.root) || n;
    return O(g, f) && (!this.root || g == f.ownerDocument);
  }, a.prototype._registerInstance = function () {
    e.indexOf(this) < 0 && e.push(this);
  }, a.prototype._unregisterInstance = function () {
    var f = e.indexOf(this);
    f != -1 && e.splice(f, 1);
  };
  function s() {
    return window.performance && performance.now && performance.now();
  }
  function l(f, g) {
    var E = null;
    return function () {
      E || (E = setTimeout(function () {
        f(), E = null;
      }, g));
    };
  }
  function u(f, g, E, A) {
    typeof f.addEventListener == "function" ? f.addEventListener(g, E, A || !1) : typeof f.attachEvent == "function" && f.attachEvent("on" + g, E);
  }
  function d(f, g, E, A) {
    typeof f.removeEventListener == "function" ? f.removeEventListener(g, E, A || !1) : typeof f.detachEvent == "function" && f.detachEvent("on" + g, E);
  }
  function h(f, g) {
    var E = Math.max(f.top, g.top),
      A = Math.min(f.bottom, g.bottom),
      w = Math.max(f.left, g.left),
      k = Math.min(f.right, g.right),
      P = k - w,
      M = A - E;
    return P >= 0 && M >= 0 && {
      top: E,
      bottom: A,
      left: w,
      right: k,
      width: P,
      height: M
    } || null;
  }
  function p(f) {
    var g;
    try {
      g = f.getBoundingClientRect();
    } catch (_unused7) {}
    return g ? (g.width && g.height || (g = {
      top: g.top,
      right: g.right,
      bottom: g.bottom,
      left: g.left,
      width: g.right - g.left,
      height: g.bottom - g.top
    }), g) : m();
  }
  function m() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  function R(f) {
    return !f || "x" in f ? f : {
      top: f.top,
      y: f.top,
      bottom: f.bottom,
      left: f.left,
      x: f.left,
      right: f.right,
      width: f.width,
      height: f.height
    };
  }
  function T(f, g) {
    var E = g.top - f.top,
      A = g.left - f.left;
    return {
      top: E,
      left: A,
      height: g.height,
      width: g.width,
      bottom: E + g.height,
      right: A + g.width
    };
  }
  function O(f, g) {
    for (var E = g; E;) {
      if (E == f) return !0;
      E = N(E);
    }
    return !1;
  }
  function N(f) {
    var g = f.parentNode;
    return f.nodeType == /* DOCUMENT */
    9 && f != n ? t(f) : (g && g.assignedSlot && (g = g.assignedSlot.parentNode), g && g.nodeType == 11 && g.host ? g.host : g);
  }
  function y(f) {
    return f && f.nodeType === 9;
  }
  window.IntersectionObserver = a, window.IntersectionObserverEntry = o;
})();
window.ResizeObserver = index$1;
var global$1 = function () {
  try {
    return window || {};
  } catch (_unused8) {
    return {};
  }
}();
function parseHeaders(t) {
  if (!t) return {};
  var n = t.trim().split(/[\r\n]+/);
  return n.reduce(function (e, i) {
    var r = i.indexOf(":"),
      o = i.slice(0, r).trim(),
      a = i.slice(r + 1).trim();
    return e[o] = a, e;
  }, {});
}
function fallback(t, n, e) {
  n in t || (t[n] = e);
}
fallback(global$1, "fetch", function (t, n) {
  return new Promise(function (e, i) {
    if (!global$1.XMLHttpRequest) return i({
      name: "NotSupportedError",
      message: "Not support XMLHttpRequest."
    });
    var r = new XMLHttpRequest();
    r.onerror = i, r.onreadystatechange = function () {
      r.readyState === 4 && e({
        ok: r.status >= 200 && r.status <= 299,
        url: r.responseURL || t,
        type: (n == null ? void 0 : n.mode) || "basic",
        status: r.status,
        headers: parseHeaders(r.getAllResponseHeaders()),
        statusText: r.statusText,
        redirected: r.responseURL && r.responseURL !== t,
        json: function json() {
          return JSON.parse(r.responseText);
        }
      });
    }, r.open((n == null ? void 0 : n.method) || "GET", t, !0), r.withCredentials = !!(n != null && n.credentials) && (n == null ? void 0 : n.credentials) !== "omit";
    var o = (n == null ? void 0 : n.headers) || {};
    Object.keys(o).forEach(function (a) {
      r.setRequestHeader(a, o[a]);
    }), r.send(n == null ? void 0 : n.body);
  });
});
function request(t) {
  return __awaiter(this, void 0, void 0, function () {
    var n, e, i, r, o, a;
    return __generator(this, function (s) {
      var _r;
      switch (s.label) {
        case 0:
          n = t.url, e = t.method, i = t.data, r = t.headers, s.label = 1;
        case 1:
          return s.trys.push([1, 3,, 4]), [4, fetch(n, {
            method: e,
            credentials: "same-origin",
            headers: Object.assign({}, {
              "Content-Type": "application/json;charset=utf-8"
            }, (_r = r) !== null && _r !== void 0 ? _r : {}),
            body: JSON.stringify(i)
          })];
        case 2:
          o = s.sent();
          try {
            responseMonitoring(o);
          } catch (_unused9) {
            cms_custom_aegis.report({
              msg: "responseMonitoring err",
              level: LogLevel.JS_ERR,
              module: "responseMonitoring"
            });
          }
          return [2, o.json()];
        case 3:
          throw a = s.sent(), a;
        case 4:
          return [2
          /*return*/];
      }
    });
  });
}

function responseMonitoring(t) {
  var n,
    e = t.clone(),
    i = e.url,
    r = (n = e.headers.get("content-type")) !== null && n !== void 0 ? n : "";
  e.status !== 200 && cms_custom_aegis.report({
    level: LogLevel.AJAX_ERR,
    module: "responseMonitoring",
    msg: "".concat(i, " err: ").concat(e.status)
  }), e.json().then(function (o) {
    var a,
      s,
      l = r.includes("json");
    if (l) {
      var u = getRetErrorMsgByUrl({
        url: i,
        data: o
      });
      u && cms_custom_aegis.report({
        msg: "".concat(i, " ").concat((s = (a = u == null ? void 0 : u.msg) !== null && a !== void 0 ? a : u.code) !== null && s !== void 0 ? s : "retcode error"),
        level: LogLevel.RETCODE_ERR
      });
    }
  })["catch"](function (o) {
    cms_custom_aegis.report({
      msg: "res.json error: ".concat(String(o)),
      level: LogLevel.JS_ERR,
      module: "responseMonitoring"
    });
  });
}
function getRetErrorMsgByUrl(t) {
  var n = t !== null && t !== void 0 ? t : {},
    e = n.url,
    i = e === void 0 ? "" : e,
    r = n.data;
  try {
    var o = /playerinfinite/.test(i),
      a = /intlgame/.test(i);
    return o && (r == null ? void 0 : r.code) !== 0 ? {
      code: r == null ? void 0 : r.code,
      msg: r == null ? void 0 : r.msg
    } : a && (r == null ? void 0 : r.ret) !== 0 ? {
      code: r == null ? void 0 : r.ret,
      msg: r == null ? void 0 : r.msg
    } : null;
  } catch (s) {
    return cms_custom_aegis.report({
      msg: "".concat(i, " ret error ").concat(String(s)),
      level: LogLevel.JS_ERR,
      module: "getRetErrorMsgByUrl"
    }), null;
  }
}
function putRequest(t) {
  return __awaiter(this, void 0, void 0, function () {
    var n, e, i, r;
    return __generator(this, function (o) {
      switch (o.label) {
        case 0:
          n = t.url, e = t.body, o.label = 1;
        case 1:
          return o.trys.push([1, 3,, 4]), [4, fetch(n, {
            body: e,
            method: "PUT",
            mode: "cors"
          })];
        case 2:
          if (i = o.sent(), i.status !== 200) throw new Error("put request failed");
          return [2, i];
        case 3:
          throw r = o.sent(), r;
        case 4:
          return [2
          /*return*/];
      }
    });
  });
}

var aihelpStyle = ".AIHelpSupportBox {\n  z-index: 11;\n  width: 375px;\n  height: 500px;\n  position: fixed;\n  right: calc(47 / 1920 * 100vw);\n  bottom: calc(100 / 1920 * 100vw);\n}";
function getAiHelper(t) {
  return __awaiter(this, void 0, void 0, function () {
    var n, e, i, r, o, a, s, l;
    return __generator(this, function (u) {
      switch (u.label) {
        case 0:
          return u.trys.push([0, 3,, 4]), window.AIHelpSupport ? [3, 2] : [4, appendScript(AIHELP_CDN)];
        case 1:
          u.sent(), u.label = 2;
        case 2:
          return n = t.core, e = t.supportConfig, i = t.userConfig, r = t.custom_style, o = Object.assign({
            domain: "iegg.aihelp.net",
            supportMode: "showAllFAQSections"
          }, n, {
            supportConfig: e,
            userConfig: i
          }), window.AIHelpSupport.init(o), a = function a() {
            var _r2;
            isMobile() ? window.location.href = window.AIHelpSupport.src : (window.AIHelpSupport.show(), window.AIHelpSupport._use_custom_style || (injectStyle((_r2 = r) !== null && _r2 !== void 0 ? _r2 : aihelpStyle, "#AIHelpSupportDiv"), window.AIHelpSupport._use_custom_style = !0));
          }, [2, {
            show: a,
            close: window.AIHelpSupport.close
          }];
        case 3:
          return s = u.sent(), l = function l() {
            console.warn("init aihelp failed: ", s);
          }, l(), [2, {
            show: l,
            close: l
          }];
        case 4:
          return [2
          /*return*/];
      }
    });
  });
}

function createUrlSearchParam(t, n) {
  var e = Object.assign({}, t);
  Object.keys(e).forEach(function (r) {
    e[r] || delete e[r];
  });
  var i = new URLSearchParams(e);
  return n == null || n.forEach(function (r) {
    i["delete"](r);
  }), i;
}
function shouldUseSinglePageLogin(t) {
  var n = t.channel,
    e = t.browser,
    i = e === void 0 ? getSpecialBrowserType() : e;
  return !!(n === "facebook" && i === "facebook" || n === "line" && isMobile());
}
var mobileTableStyle = "table {\n  display: block;\n  overflow-x: auto;\n  white-space: nowrap;\n  border-width: unset;\n  border-spacing: unset;\n  border-style: unset;\n  max-width: none;\n\t-webkit-overflow-scrolling: touch;\n}\n/* \u79FB\u52A8\u7AEFtable\u5DE6\u53F3\u6ED1\u52A8 */",
  basicStyle = "html::-webkit-scrollbar {\n  display: none; /* Chrome Safari */\n}\nhtml {\n  scrollbar-width: none; /* firefox */\n  -ms-overflow-style: none; /* IE 10+ */\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\ntable {\n  border-spacing: 0;\n}\ntable::-webkit-scrollbar {\n  display: none; /* Chrome Safari */\n}\nimg,\nvideo {\n  max-width: 100%;\n  object-fit: contain;\n}\niframe {\n  max-width: 100%;\n}\n.cms-table-container {\n  padding: 1px;\n  max-width: 100%;\n  overflow-x: scroll;\n}\n.cms-table-container::-webkit-scrollbar {\n  height: 8px;\n  background-color: #f0f0f0;\n  background-color: transparent;\n}\n.cms-table-container::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background-color: #a0a0a0;\n}\n.cms-table-container::-webkit-scrollbar-thumb:hover {\n  background-color: #808080;\n}\n";
function imageReplacement(t) {
  var n = new DOMParser().parseFromString(t, "text/html").documentElement,
    e = n.querySelectorAll("img");
  return e.forEach(function (i) {
    var r = i.parentElement,
      o = cmsImg2Pictures(i);
    r == null || r.replaceChild(o, i);
  }), n.innerHTML;
}
function cmsImg2Pictures(t) {
  var n,
    e = function e(o, a) {
      a === void 0 && (a = {});
      var s = document.createElement(o);
      return Object.keys(a).forEach(function (l) {
        var u;
        a[l] && !((u = String(a[l])) === null || u === void 0) && u.length && s.setAttribute(l, a[l]);
      }), copyElementAttrs(s, t, {
        exlude: ["src", "height"]
      }), s;
    },
    i = (n = t == null ? void 0 : t.getAttribute("src")) !== null && n !== void 0 ? n : "",
    r = document.createElement("picture");
  return isCmsOptImage(i) ? (r.appendChild(e("source", {
    type: "image/webp",
    srcset: toWebp(i)
  })), r.appendChild(e("img", {
    loading: "lazy",
    srcset: i,
    onerror: getImageReplacement(i)
  })), r) : t;
}
function getCmsImageOptionsFromString(t, n) {
  var e = t.match(n),
    i = /_\d+/g,
    r = e == null ? void 0 : e[0].match(i);
  return r == null ? void 0 : r.map(function (o) {
    return Number(o.replace(/_/g, ""));
  });
}
function getImageReplacement(t) {
  return "(function () {\n    var source = this.parentNode.querySelectorAll('source');\n    for (var i = 0; i < source.length; i++) {\n      this.parentNode.removeChild(source[i])\n    };\n    this.src='".concat(t !== null && t !== void 0 ? t : "not-found", "';\n    this.onerror='';\n  }).bind(this)();");
}
function copyElementAttrs(t, n, e) {
  var i = n.getAttributeNames().reduce(function (r, o) {
    var a;
    return Object.assign({}, r, (a = {}, a[o] = n.getAttribute(o), a));
  }, {});
  Object.keys(i).forEach(function (r) {
    var o;
    i[r] && !(!((o = e == null ? void 0 : e.exlude) === null || o === void 0) && o.includes(r)) && t.setAttribute(r, i[r]);
  });
}
function isCmsOptImage(t) {
  return t ? !!(getCmsImageOptionsFromString(t, /ori_s(_[0-9]+)+/g) && getCmsImageOptionsFromString(t, /ori_q(_[0-9]+)+/g)) : !1;
}
function toWebp(t) {
  return t.replace(/\.\w{2,5}$/, ".webp");
}
var imageOpt = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  cmsImg2Pictures: cmsImg2Pictures,
  imageReplacement: imageReplacement,
  isCmsOptImage: isCmsOptImage
}, Symbol.toStringTag, {
  value: "Module"
}));
var CmsContentProcessor = /** @class */
  function () {
    function t(n) {
      this._content = "", this._content = n !== null && n !== void 0 ? n : "";
    }
    return t.prototype.replaceTimeStampTag = function (n) {
      return n === void 0 && (n = "-"), this._content = this._content.replace(/(&lt;|<):timestamp( format=\(([^)]+)\))? value=\((\d{10,13})\)(&gt;|>)/g, function () {
        for (var e = [], i = 0; i < arguments.length; i++) e[i] = arguments[i];
        var r = e[2],
          o = e[3],
          a = e[4],
          s = new Date(parseInt(a.length === 13 ? a : "".concat(a, "000"), 10));
        if (!r || !o) return getDateTimeStr(s, n);
        var l = getDateTimeStr(s, "-").split(/-| |:/),
          u = l[0],
          d = l[1],
          h = l[2],
          p = l[3],
          m = l[4],
          R = l[5];
        return o.replace(/YYYY/g, u).replace(/MM/g, d).replace(/DD/g, h).replace(/HH/g, p).replace(/mm/g, m).replace(/ss/g, R);
      }), this;
    }, t.prototype.imageReplacement = function () {
      var n = imageReplacement(this._content);
      return this._content = n, this;
    }, t.prototype.coverTableContent = function () {
      if (isMobile()) return this;
      for (var n = new DOMParser(), e = n.parseFromString(this._content, "text/html"), i = e.getElementsByTagName("table"), r = 0; r < i.length; r++) {
        var o = i[r],
          a = e.createElement("div");
        a.className = "cms-table-container", o.parentNode && (o.parentNode.replaceChild(a, o), a.appendChild(o));
      }
      return this._content = e.documentElement.innerHTML, this;
    }, t.prototype.getContent = function () {
      return this._content;
    }, t;
  }(),
  CmsInteractHanlder = /** @class */
  function () {
    function t(n, e) {
      this._container = n, this._options = e;
    }
    return t.prototype.setElsStyle = function (n, e) {
      try {
        var i = this._container.querySelectorAll(n);
        return i == null || i.forEach(function (r) {
          Object.keys(e).forEach(function (o) {
            r instanceof HTMLElement && (r.style[o] = e[o]);
          });
        }), this;
      } catch (_unused10) {
        return this;
      }
    }, t.prototype.useCmsMenu = function () {
      var n = this,
        e = this._container.querySelectorAll("[data-href]");
      return e == null || e.forEach(function (i) {
        i.addEventListener("click", function () {
          var r = i.getAttribute("data-href"),
            o = n._container.querySelector(r);
          o == null || o.scrollIntoView({
            behavior: "smooth"
          });
        });
      }), this;
    }, t.prototype.clearExtraStyle = function (n) {
      var e = this._container.querySelectorAll(n);
      return e == null || e.forEach(function (i) {
        i.removeAttribute("height"), i instanceof HTMLElement && (i.style.maxWidth = "100%");
      }), this;
    }, t.prototype.useAnchor = function () {
      var n = this;
      try {
        var e = this._container.querySelectorAll("a"),
          i = this._options.is_iframe,
          r = i === void 0 ? !1 : i,
          o = function o(a) {
            return a.startsWith("#");
          };
        return e.forEach(function (a) {
          a.addEventListener("click", function (s) {
            var l,
              u,
              d = s.target,
              h = function h(T, O) {
                return T == null ? void 0 : T.getAttribute(O);
              },
              p = h(d, "href") || h(d == null ? void 0 : d.parentElement, "href"),
              m = (u = (l = h(d, "target")) !== null && l !== void 0 ? l : h(d == null ? void 0 : d.parentElement, "target")) !== null && u !== void 0 ? u : "_self";
            if (p) {
              if (s.stopPropagation(), s.preventDefault(), o(p)) {
                var R = n._container.querySelector(p);
                R == null || R.scrollIntoView({
                  behavior: "smooth"
                });
                return;
              }
              window.open(p, r ? "_blank" : m);
            }
          });
        }), this;
      } catch (_unused11) {
        return this;
      }
    }, t;
  }();
function createElement(t, n) {
  var e = document.createElement(t);
  return n && Object.keys(n).forEach(function (i) {
    e.setAttribute(i, String(n[i]));
  }), e;
}
function getRandomId() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substring(2, 10);
}
function getIframeHeight(t) {
  var n, e, i;
  return (((i = (e = (n = t.contentWindow) === null || n === void 0 ? void 0 : n.document) === null || e === void 0 ? void 0 : e.body) === null || i === void 0 ? void 0 : i.scrollHeight) || 0) + 20;
}
function traverseDom(t, n, e) {
  for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++) {
    var o = i[r];
    e(o);
  }
}
function processWithInteract(t, n) {
  var e = new CmsInteractHanlder(t, n);
  e.useAnchor().useCmsMenu().setElsStyle("iframe", {
    border: "0"
  }), isMobile() && e.clearExtraStyle("table").clearExtraStyle("img").clearExtraStyle("video").clearExtraStyle("iframe").setElsStyle("img", {
    display: "inline"
  }).setElsStyle("table", {
    height: "auto"
  });
}
function createRichTextShadowDom(t, n) {
  var e = n.target,
    i = n.styleText,
    r = document.createElement("div");
  e.appendChild(r);
  var o = r.attachShadow({
      mode: "open"
    }),
    a = document.createElement("style");
  return a.textContent = (i !== null && i !== void 0 ? i : "") + basicStyle + (isMobile() ? mobileTableStyle : ""), o.innerHTML = t, o.appendChild(a), o;
}
function createRichTextElement(t, n) {
  return new Promise(function (e, i) {
    var r,
      o = document.createElement("iframe"),
      a = t;
    n != null && n.script && (a = "<script>".concat(n == null ? void 0 : n.script, "<\/script>").concat(a));
    var s = ((n == null ? void 0 : n.styleText) || "") + basicStyle + (isMobile() ? mobileTableStyle : "");
    a = "<style>".concat(s, "</style>").concat(a);
    var l = function l() {
        o.setAttribute("style", "height:".concat(getIframeHeight(o), "px; width: 100%; border: none; max-width: 100%;"));
      },
      u = function u() {
        o.removeEventListener("resize", l);
      };
    o.srcdoc = a, l();
    var d = setInterval(l, 100);
    o.onload = function () {
      var h;
      clearInterval(d);
      var p = (h = o.contentWindow) === null || h === void 0 ? void 0 : h.document.body;
      if (p != null && p.scrollHeight && l(), !!p) {
        var m = new ResizeObserver(l);
        m.observe(p), document.addEventListener("resize", l), p.addEventListener("resize", l), e({
          iframe: o,
          resize: l,
          destory: u
        });
      }
    }, o.onerror = i, n != null && n.target ? (r = n == null ? void 0 : n.target) === null || r === void 0 || r.appendChild(o) : e({
      iframe: o,
      resize: l,
      destory: u
    });
  });
}
function getDateTimeStr(t, n) {
  t === void 0 && (t = /* @__PURE__ */new Date());
  var e = function e(l) {
      var u = String(l);
      return u.length === 1 && (u = "0".concat(u)), u;
    },
    i = /^\d{10,13}$/.test("".concat(t)) ? new Date("".concat(t).length === 10 ? parseInt("".concat(t), 10) * 1e3 : t) : t,
    r = i.getHours().toString(),
    o = i.getMinutes().toString(),
    a = i.getSeconds().toString(),
    s = "".concat(r.length === 2 ? r : "0".concat(r), ":").concat(o.length === 2 ? o : "0".concat(o), ":").concat(a.length === 2 ? a : "0".concat(a));
  return "".concat([i.getFullYear(), e(i.getMonth() + 1), e(i.getDate())].join(n || "-"), " ").concat(s);
}
function replaceTimeStampTag(t, n) {
  t === void 0 && (t = ""), n === void 0 && (n = "-");
  var e = new CmsContentProcessor(t);
  return e.replaceTimeStampTag(n).getContent();
}
function getFormatDateString(t, n) {
  var e = new Date(t);
  if (Number.isNaN(e.getTime())) return "";
  var i = getDateTimeStr(e, "-").split(/-| |:/),
    r = i[0],
    o = i[1],
    a = i[2],
    s = i[3],
    l = i[4],
    u = i[5];
  return n.replace(/YYYY/g, r).replace(/MM/g, o).replace(/DD/g, a).replace(/HH/g, s).replace(/mm/g, l).replace(/ss/g, u);
}
function getPlainString(t) {
  return new DOMParser().parseFromString(t, "text/html").documentElement.textContent;
}
function parseRichTextContent(t) {
  var n, e;
  try {
    var i = new CmsContentProcessor(t);
    return i.replaceTimeStampTag().imageReplacement().coverTableContent().getContent();
  } catch (r) {
    return cms_custom_aegis.report({
      level: LogLevel.JS_ERR,
      msg: (e = (n = r == null ? void 0 : r.message) !== null && n !== void 0 ? n : r == null ? void 0 : r.msg) !== null && e !== void 0 ? e : "parse richtext error"
    }), replaceTimeStampTag(t);
  }
}
var ChannelIdMap = {
    facebook: 4,
    google: 6,
    twitter: 9,
    line: 14,
    apple: 15
  },
  CHANNEL_STORAGE_KEY = "cms_intl_channel_key";
function initDOM(t) {
  var n = injectElement(t);
  return n.id = n.id || "embed-youtube-".concat(Date.now()), n.classList.add("yt-video"), n.classList.add("embed-video"), n;
}
function debounce(t, n) {
  var e = null;
  return function () {
    for (var i = this, r = [], o = 0; o < arguments.length; o++) r[o] = arguments[o];
    var a = function a() {
      e = null, t.apply(i, r);
    };
    e !== null && clearTimeout(e), e = setTimeout(a, n);
  };
}
var initSDK = throttlePromise(function () {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (t) {
      switch (t.label) {
        case 0:
          return window.YT ? [3, 3] : [4, appendScript("https://www.youtube.com/iframe_api")];
        case 1:
          return t.sent(), [4, new Promise(function (n) {
            window.YT.ready(n);
          })];
        case 2:
          t.sent(), t.label = 3;
        case 3:
          return [2, window.YT];
      }
    });
  });
});
function getOptions(t) {
  return {
    width: t.width,
    height: t.height,
    videoId: t.videoId || "",
    playerVars: {
      rel: 0,
      loop: t.loop ? 1 : 0,
      autoplay: t.autoplay ? 1 : 0,
      playsinline: 1,
      enablejsapi: 1,
      modestbranding: 1
    }
  };
}
var PlayerState;
(function (t) {
  t[t.UNSTARTED = -1] = "UNSTARTED", t[t.ENDED = 0] = "ENDED", t[t.PLAYING = 1] = "PLAYING", t[t.PAUSED = 2] = "PAUSED", t[t.BUFFERING = 3] = "BUFFERING", t[t.CUED = 5] = "CUED";
})(PlayerState || (PlayerState = {}));
var YTEvent;
(function (t) {
  t.INFO_INIT = "initialDelivery", t.INFO_UPDATE = "infoDelivery", t.API_UPDATE = "apiInfoDelivery", t.READY = "onReady";
})(YTEvent || (YTEvent = {}));
var Tasks;
(function (t) {
  t.INIT = "init";
})(Tasks || (Tasks = {}));
function embedConfigToIframeConfig(t) {
  var n, e;
  return {
    player_config: {
      rel: 0,
      playsinline: 1,
      enablejsapi: 1,
      modestbranding: 1,
      loop: t.loop ? 1 : 0,
      autoplay: t.autoplay ? 1 : 0
    },
    // iframe attrs
    iframe_attrs: {
      frameborder: "0",
      allowfullscreen: "true",
      width: (n = t.width) !== null && n !== void 0 ? n : "100%",
      height: (e = t.height) !== null && e !== void 0 ? e : "100%",
      // default
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    }
  };
}
function getYTIframeEl(t) {
  var n = document.createElement("iframe");
  return Object.keys(t).forEach(function (e) {
    n.setAttribute(e, String(t[e]));
  }), n;
}
function getYTEmbedURL(t, n) {
  n === void 0 && (n = {});
  var e = "https://www.youtube.com/embed/".concat(t),
    i = {};
  Object.keys(n).forEach(function (o) {
    var a = n[o];
    _typeof(a) < "u" && (i[o] = String(a));
  });
  var r = new URLSearchParams(i);
  return "".concat(e, "?").concat(r.toString());
}
function initYTIframe(t) {
  return new Promise(function (n, e) {
    var i = t.videoId,
      r = t.element,
      o = initDOM(r),
      a = embedConfigToIframeConfig(t),
      s = a.player_config,
      l = a.iframe_attrs,
      u = getYTEmbedURL(i, s),
      d = getYTIframeEl(l);
    o.appendChild(d), d.src = u, d.onabort = e, d.onerror = e, d.onload = function () {
      n(d);
    };
  });
}
function getIframePlayer(t) {
  return __awaiter(this, void 0, void 0, function () {
    var n, e;
    return __generator(this, function (i) {
      switch (i.label) {
        case 0:
          return n = new YTIframePlayer({
            container: t
          }), [4, n.init()];
        case 1:
          return i.sent(), e = {
            // current use:
            isMuted: function isMuted() {
              return n.get("muted") === 1;
            },
            mute: function mute() {
              n.call("mute");
            },
            playVideo: function playVideo() {
              return n.call("playVideo"), e;
            },
            unMute: function unMute() {
              n.call("unMute");
            },
            getVolume: function getVolume() {
              return n.get("volume") * 100;
            },
            setVolume: function setVolume(r) {
              n.call("setVolume", r / 100);
            },
            getDuration: function getDuration() {
              return n.get("duration");
            },
            getCurrentTime: function getCurrentTime() {
              return n.get("currentTime");
            },
            seekTo: function seekTo(r, o) {
              n.call("seekTo", r);
            },
            pauseVideo: function pauseVideo() {
              n.call("pauseVideo");
            },
            stopVideo: function stopVideo() {
              n.call("stopVideo");
            },
            destroy: function destroy() {
              n.destroy();
            },
            getSize: function getSize() {
              return {
                width: n.get("width"),
                height: n.get("height")
              };
            }
          }, [2, Object.assign(n, e)];
      }
    });
  });
}
var youtube_domain = "https://www.youtube.com",
  YTIframePlayer = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = t.call(this) || this;
      return i.tasks = getTaskMap(), i.player_info = /* @__PURE__ */new Map(), i._id = Math.ceil(Math.random() * 1e4), i._state = -1, i.container = e.container, i.msg_handler = i.messageHanlder.bind(i), i.createListener(), i;
    }
    return n.prototype.get = function (e) {
      return this.player_info.get(e);
    }, n.prototype.init = function () {
      var e, i;
      return (i = (e = this.container) === null || e === void 0 ? void 0 : e.contentWindow) === null || i === void 0 || i.postMessage(JSON.stringify({
        id: this._id,
        channel: "widget",
        event: "listening"
      }), youtube_domain), this.tasks.createTask(Tasks.INIT);
    }, n.prototype.on = function (e, i) {
      return t.prototype.on.call(this, e, i), this;
    }, n.prototype.destroy = function () {
      var e;
      this.container.src = "", (e = this.container.parentNode) === null || e === void 0 || e.removeChild(this.container), window.removeEventListener("message", this.msg_handler);
    }, n.prototype.call = function (e, i) {
      var r, o, a;
      return (o = (r = this.container) === null || r === void 0 ? void 0 : r.contentWindow) === null || o === void 0 || o.postMessage(JSON.stringify({
        args: (a = [i]) !== null && a !== void 0 ? a : [],
        func: e,
        event: "command"
      }), youtube_domain), this.tasks.createTask(e);
    }, n.prototype.messageHanlder = function (e) {
      var i = e.data,
        r = e.origin,
        o = e.source;
      if (!(r !== youtube_domain || o !== this.container.contentWindow)) {
        var a = this.parseMessage(i);
        a ? this.dispatchMessage(a) : console.error(i);
      }
    }, n.prototype.parseMessage = function (e) {
      try {
        return JSON.parse(e);
      } catch (i) {
        return console.error(i), null;
      }
    }, n.prototype.emitUpdateStatus = function () {
      var e = this.player_info.get("playerState");
      if (e !== this._state) switch (this._state = Number(e), this._state) {
        case PlayerState.PLAYING:
          {
            this.emit("playing");
            break;
          }
        case PlayerState.PAUSED:
        case PlayerState.ENDED:
          {
            this.emit("not-playing");
            break;
          }
      }
    }, n.prototype.dispatchMessage = function (e) {
      var i = e.event,
        r = e.info;
      switch (i) {
        case YTEvent.READY:
          {
            this.tasks.fulfillTask(Tasks.INIT);
            break;
          }
        case YTEvent.API_UPDATE:
        case YTEvent.INFO_INIT:
        case YTEvent.INFO_UPDATE:
          {
            this.updatePlayerInfo(r), this.emitUpdateStatus();
            break;
          }
        default:
          {
            this.tasks.fulfillTask(i);
            break;
          }
      }
    }, n.prototype.updatePlayerInfo = function (e) {
      var i = this;
      Object.keys(e).forEach(function (r) {
        i.player_info.set(r, e[r]);
      });
    }, n.prototype.createListener = function () {
      window.addEventListener("message", this.msg_handler, !1);
    }, n;
  }(EventEmitter),
  getTaskMap = function getTaskMap() {
    var t = /* @__PURE__ */new Map();
    return {
      createTask: function createTask(n) {
        return new Promise(function (e, i) {
          t.set(n, {
            resolve: e,
            reject: i
          });
        });
      },
      fulfillTask: function fulfillTask(n, e) {
        var i = t.get(n);
        i == null || i.resolve(e);
      },
      failTask: function failTask(n, e) {
        var i = t.get(n);
        i == null || i.reject(e);
      }
    };
  },
  EmbedPlayer = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = t.call(this) || this;
      return i._platform = e.platform, i._player = e.player, i;
    }
    return n.prototype.on = function (e, i) {
      return t.prototype.on.call(this, e, i), this;
    }, Object.defineProperty(n.prototype, "platform", {
      get: function get() {
        return this._platform;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "player", {
      get: function get() {
        return this._player;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "muted", {
      get: function get() {
        return this._player.isMuted();
      },
      set: function set(e) {
        e ? this._player.mute() : this._player.unMute();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "volume", {
      get: function get() {
        return this._player.getVolume() / 100;
      },
      set: function set(e) {
        this._player.setVolume(e * 100);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "duration", {
      get: function get() {
        return this._player.getDuration();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "size", {
      get: function get() {
        return this._player.getSize();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "currentTime", {
      get: function get() {
        return this._player.getCurrentTime();
      },
      set: function set(e) {
        this._player.seekTo(e);
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.play = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (e) {
          return this._player.playVideo(), [2
          /*return*/];
        });
      });
    }, n.prototype.pause = function () {
      this._player.pauseVideo();
    }, n.prototype.stop = function () {
      this._player.stopVideo();
    }, n;
  }(EventEmitter);
function getInstance(t, n) {
  var e = new EmbedPlayer({
    player: t,
    platform: "youtube"
  });
  if (n === "official" && t.addEventListener("onStateChange", function (o) {
    o.data === PlayerState.PLAYING && e.emit("playing"), [PlayerState.PAUSED, PlayerState.ENDED].includes(o.data) && e.emit("not-playing");
  }), n === "iframe") {
    var i = debounce(function () {
        e.emit("playing");
      }, 10),
      r = debounce(function () {
        e.emit("not-playing");
      }, 10);
    t.on("playing", i), t.on("not-playing", r);
  }
  return e;
}
function init(t) {
  var n;
  return __awaiter(this, void 0, void 0, function () {
    var e, i, r, s, o, a, s;
    return __generator(this, function (l) {
      switch (l.label) {
        case 0:
          return l.trys.push([0, 2,, 6]), [4, initSDK()];
        case 1:
          return e = l.sent(), i = initDOM(t.element), r = getOptions(t), s = new e.Player(i.id, r), [2, getInstance(s, "official")];
        case 2:
          return o = l.sent(), o instanceof Error && !((n = o == null ? void 0 : o.message) === null || n === void 0) && n.includes(Err_Text) || o instanceof ScriptForbiddenError ? [4, initYTIframe(t)] : [3, 5];
        case 3:
          return a = l.sent(), [4, getIframePlayer(a)];
        case 4:
          return s = l.sent(), [2, getInstance(s, "iframe")];
        case 5:
          throw o;
        case 6:
          return [2
          /*return*/];
      }
    });
  });
}

var youtube = {
    init: init
  },
  Embed = {
    youtube: youtube
  };
function getCmsVideoInfo(t) {
  var n, e;
  if (!((n = t == null ? void 0 : t.video_info) === null || n === void 0) && n.video_source) try {
    var i = t == null ? void 0 : t.video_info,
      r = i.video_source,
      o = i.video_cover,
      a = o === void 0 ? "" : o,
      s = new URL(r),
      l = new URLSearchParams(s.search),
      u = !!l.get("platform");
    return {
      is_embed: u,
      video_cover: a,
      has_video: !0,
      platform: u ? l.get("platform") : "url",
      vid: u ? (e = l.get("videoId")) !== null && e !== void 0 ? e : "" : r
    };
  } catch (_unused12) {
    return console.error("wrong url format"), {
      has_video: !1
    };
  }
  return {
    has_video: !1
  };
}
function openDetailLink(t, n) {
  var e, i, r;
  if (!t || !n) throw new Error("no params provided");
  var o = "",
    a = t.content_id,
    s = t.jump_link_info,
    l = n.target,
    u = n.open_type,
    d = u === void 0 ? "_blank" : u,
    h = n.only_get_location_string,
    p = n.extra_query,
    m = p === void 0 ? {} : p,
    R = n.query_key,
    T = R === void 0 ? "content_id" : R,
    O = n.father_query_key,
    N = O === void 0 ? "father_content_id" : O,
    y = new URLSearchParams(location.search);
  if (l == null) throw new Error("no target provided");
  Object.keys(m).forEach(function (E) {
    y.set(E, String(m[E]));
  });
  var f = function f() {
    y.set(T, a), o = "".concat(l, "?").concat(y.toString()), h || window.open(o, d);
  };
  switch (Number(s == null ? void 0 : s.jump_type)) {
    case LinkType.Inner_Article:
      {
        var g = new URLSearchParams((e = s == null ? void 0 : s.jump_url) !== null && e !== void 0 ? e : "");
        g.get("parentId") && y.set(N, (i = g.get("parentId")) !== null && i !== void 0 ? i : ""), g.get("id") && y.set(T, (r = g.get("id")) !== null && r !== void 0 ? r : ""), o = "".concat(l, "?").concat(y.toString()), h || window.open(o, d);
        break;
      }
    case LinkType.External_Link:
      {
        n.ignore_third_link ? f() : (o = s == null ? void 0 : s.jump_url, h || window.open(s == null ? void 0 : s.jump_url, d));
        break;
      }
    case LinkType.Self_Build_Pic:
      break;
    case LinkType.Self_Build:
    case LinkType.Inner_Link:
    default:
      {
        f();
        break;
      }
  }
  return o;
}
function getValueByChainedKey(t, n) {
  try {
    for (var e = t, i = n.split("."), r = 0, o = i; r < o.length; r++) {
      var a = o[r];
      if (e = e[a], _typeof(e) != "object" || e === null) break;
    }
    return e;
  } catch (_unused13) {
    return null;
  }
}
function parseDataJSON(t, n) {
  try {
    var e = Object.assign({}, t),
      i = e;
    return n.forEach(function (r) {
      for (var o = r.split("."), a = 0, s = o; a < s.length; a++) {
        var l = s[a];
        try {
          typeof i[l] == "string" && (i[l] = JSON.parse(i[l]));
        } catch (_unused14) {}
        if (i = i[l], _typeof(i) != "object" || i === null) break;
      }
    }), e;
  } catch (r) {
    return console.error(r), t;
  }
}
var PaBaseHelper = /** @class */
  function () {
    function t(n) {
      var e = n.lang,
        i = n.cms_gameid,
        r = n.area_id,
        o = n.source_type,
        a = o === void 0 ? SourceType.PC_WEB : o;
      this.lang = e, this.area_id = r, this.cms_gameid = i, this.source_type = a, this.private_cms_url = n.custom_cms_url;
    }
    return Object.defineProperty(t.prototype, "open_id", {
      get: function get() {
        return this._intl_open_id;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "expires", {
      get: function get() {
        return this._expires;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "uid", {
      get: function get() {
        return this._uid;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "is_login", {
      get: function get() {
        return this._uid && this._ticket;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "ticket", {
      get: function get() {
        return this._ticket;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "headers", {
      get: function get() {
        return Object.assign({}, {
          "X-GameId": this.cms_gameid,
          "X-AreaId": this.area_id,
          "X-Source": this.source_type,
          "X-Language": this.lang,
          "Content-Type": "application/json;charset=utf-8"
        }, this._custom_headers);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.sign_request = function (n) {
      var e, i, r;
      return __awaiter(this, void 0, void 0, function () {
        var o, a, s, l, u, d, h, p, m, R, T, O;
        return __generator(this, function (N) {
          return o = n.url, a = n.method, s = n.data, l = n.headers, u = l === void 0 ? {} : l, d = new URL(o, location.origin).pathname, h = d.slice().split("/").pop(), p = Math.floor(Date.now() / 1e3), m = (e = n.sign_key) !== null && e !== void 0 ? e : DefaultParams.SignAppKey(), R = (i = n.sign_secret) !== null && i !== void 0 ? i : DefaultParams.SignAppSecret(), T = sha256Exports.sha256.hmac(R, "".concat(h, "\n").concat(m, "\n").concat(p)), O = {
            "X-AUTH-Sign": T,
            "X-AUTH-Appkey": m,
            "X-AUTH-Timestamp": String(p),
            "X-AUTH-Version": (r = n.sign_version) !== null && r !== void 0 ? r : DefaultParams.SignVersion
          }, [2, request({
            url: o,
            data: s,
            method: a,
            // @ts-ignore
            headers: Object.assign({}, O, this.headers, u)
          })];
        });
      });
    }, t.prototype.request = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        var e, i, r, o, a;
        return __generator(this, function (s) {
          return e = n.url, i = n.method, r = n.data, o = n.headers, a = o === void 0 ? {} : o, [2, request({
            url: e,
            data: r,
            method: i,
            // @ts-ignore
            headers: Object.assign({}, this.headers, a)
          })];
        });
      });
    }, t.prototype.loginByIntlToken = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        var e, i, r, o;
        return __generator(this, function (a) {
          switch (a.label) {
            case 0:
              return e = n.login_res, i = n.channel_id, r = n.intl_game_id, [4, this.post({
                url: CMS_URLS.pa_login_by_intl_token,
                data: {
                  mappid: DefaultParams.CmsAppId,
                  clienttype: DefaultParams.CmsClientType,
                  login_info: Object.assign({
                    channel_id: i,
                    token: e.token,
                    open_id: e.openid,
                    channelid: i,
                    expires: e.token_expire_time,
                    game_id: r,
                    channel_info: JSON.stringify(e.channel_info || {})
                  })
                }
              })];
            case 1:
              return o = a.sent(), this.setLoginInfo(o), [2, o];
          }
        });
      });
    }, t.prototype.loginByIntlEncode = function (n) {
      var e;
      return __awaiter(this, void 0, void 0, function () {
        var i;
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return !isInIntlBrowser || !getQuery(DefaultQueryKey.IntlIngameEncodeparam) ? [2
              /*return*/] : [4, this.post({
                url: CMS_URLS.pa_login_by_intl_token,
                data: {
                  mappid: DefaultParams.CmsAppId,
                  clienttype: DefaultParams.CmsClientType,
                  login_info: Object.assign({}, {
                    os: getQuery(DefaultQueryKey.IntlIngameOS),
                    channel_id: getQuery(DefaultQueryKey.IntlIngameChannel),
                    encode_param: getQuery(DefaultQueryKey.IntlIngameEncodeparam),
                    game_id: (e = n == null ? void 0 : n.intl_game_id) !== null && e !== void 0 ? e : getQuery(DefaultQueryKey.IntlIngameGameid)
                  })
                }
              })];
            case 1:
              return i = r.sent(), this.setLoginInfo(i), [2, i];
          }
        });
      });
    }, t.prototype.setHeaders = function (n) {
      this._custom_headers = n;
    }, t.prototype.getCmsUrl = function (n) {
      var e, i;
      if (this.private_cms_url) return i = this.private_cms_url, "".concat(i).concat(n);
      var r = {
        // 开发环境请配置代理.
        dev: "",
        test: "https://t-sg-community.playerinfinite.com",
        // @ts-ignore
        prod: (e = CMS_SERVE[this.area_id]) !== null && e !== void 0 ? e : CMS_SERVE.na
      };
      return console.log(), i = r[ENV$1()], "".concat(i).concat(n);
    }, t.prototype.post = function (n) {
      var e, i;
      return __awaiter(this, void 0, void 0, function () {
        var r, o, a;
        return __generator(this, function (s) {
          return r = n.url, o = this.getCmsUrl(n.url), r === CMS_URLS.tlog_report && (a = this.private_cms_url || CMS_SERVE.sg, o = o.replace(a, CMS_SERVE.na)), n.sign ? [2, this.sign_request({
            method: "POST",
            url: o,
            data: (e = n.data) !== null && e !== void 0 ? e : {}
          })] : [2, this.request({
            method: "POST",
            url: o,
            data: (i = n.data) !== null && i !== void 0 ? i : {}
          })];
        });
      });
    }, t.prototype.officialApply = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (e) {
          return [2, this.post({
            sign: !0,
            url: CMS_URLS.pa_official_apply,
            data: Object.assign({}, n, {
              game_id: this.cms_gameid,
              apply_data: JSON.stringify(n.apply_data) || "",
              login_type: ChannelIdMap[n.login_type]
            })
          })];
        });
      });
    }, t.prototype.setLoginInfo = function (n) {
      try {
        var e = n.data,
          i = e.user_id,
          r = e.wt,
          o = e.third_openid,
          a = e.expires;
        this._uid = i, this._ticket = r, this._intl_open_id = o, this._expires = a * 1e3 + /* @__PURE__ */new Date().getTime();
      } catch (_unused15) {}
    }, t;
  }(),
  get_dom_str = function get_dom_str(t, n) {
    var e = n.get_template,
      i = n.list_dom,
      r = n.href,
      o = n.default_image,
      a = n.default_text,
      s = a === void 0 ? "-" : a,
      l = n.target,
      u = l === void 0 ? DefaultParams.WindowOpenType : l,
      d = n.dateformat,
      h = d === void 0 ? DefaultParams.DateFormat : d,
      p = e ? e(t) : i.slice(),
      m = t.pub_timestamp,
      R = Number(m) * 1e3,
      T = function T(N, y) {
        var f = N.replace("[", "\\[").replace("]", "\\]");
        return p.replace(new RegExp(f, "g"), y);
      },
      O = ["[cover]", "[title]", "[desc]", "[link]", "[date]"];
    return O.forEach(function (N) {
      var y, f, g;
      switch (N) {
        case "[date]":
          p = T(N, getFormatDateString(R, h));
        case "[desc]":
          p = T(N, replaceTimeStampTag(t.content_part || t.content_desc || s));
        case "[cover]":
          p = T(N, (f = (y = t.pic_urls) === null || y === void 0 ? void 0 : y[0]) !== null && f !== void 0 ? f : o);
        case "[title]":
          p = T(N, (g = t.title) !== null && g !== void 0 ? g : t.title);
        case "[link]":
          p = T(N, CmsHelper.goDetailLink(t, {
            target: r,
            open_type: u,
            only_get_location_string: !0
          }));
      }
    }), p;
  },
  BasePageManager = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = this,
        r,
        o;
      i = t.call(this) || this, i.list_query_params = {};
      var a = e.column,
        s = e.instance;
      return i.column = a, i.cms_helper_instance = s, i.isLoading = !1, i.active_label_id = DefaultParams.SecondLabelId, i.perpage = (r = e.perpage) !== null && r !== void 0 ? r : DefaultParams.Perpage, i.second_label_list = ((o = a.secondary_label_list) !== null && o !== void 0 ? o : []).slice(), i.initLabelList(e), i;
    }
    return Object.defineProperty(n.prototype, "primary_col", {
      get: function get() {
        return this.column;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "label_id", {
      get: function get() {
        return this.active_label_id;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "colum_list", {
      get: function get() {
        var e;
        return (e = this.second_label_list) !== null && e !== void 0 ? e : [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "current_column", {
      get: function get() {
        var e = this;
        return this.second_label_list.find(function (i) {
          return Number(i.label_id) === e.label_id;
        });
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.getNewsListHtml = function (e) {
      var i = this.news_list.map(function (o) {
          return get_dom_str(o, e);
        }),
        r = i.map(imageReplacement);
      return {
        // 原html替换
        list_dom_str_arr: i,
        list_dom_str: i.join(""),
        // cms 优化
        opt_list_dom_str_arr: r,
        opt_list_dom_str: r.join("")
      };
    }, n.prototype.initLabelList = function (e) {
      var i = e.use_all,
        r = e.all_label_name;
      i && this.second_label_list.unshift({
        label_id: 0,
        label_name: r
      });
    }, n;
  }(EventEmitter),
  NewsPageManager = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = t.call(this, e) || this;
      i.use_all = !1;
      var r = e.page,
        o = r === void 0 ? 0 : r,
        a = e.use_all;
      return i.page = o, i.use_all = a, i.newsMap = /* @__PURE__ */new Map(), i.initNewsMap(), i;
    }
    return Object.defineProperty(n.prototype, "total_page", {
      get: function get() {
        var e,
          i,
          r = this.newsMap.get(this.active_label_id),
          o = (e = r == null ? void 0 : r.total_num) !== null && e !== void 0 ? e : 0;
        return o ? Math.ceil(((i = r == null ? void 0 : r.total_num) !== null && i !== void 0 ? i : 0) / this.perpage) : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "current_page", {
      get: function get() {
        return Number(this.page);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "news_list", {
      get: function get() {
        var e,
          i = this.newsMap.get(this.active_label_id),
          r = this.page * this.perpage,
          o = (this.page + 1) * this.perpage;
        return (e = i == null ? void 0 : i.news_list.slice(r, o).filter(function (a) {
          return !!a;
        })) !== null && e !== void 0 ? e : [];
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.switchPageParam = function (e) {
      var i, r;
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (o) {
          return this.page = (i = e.page) !== null && i !== void 0 ? i : 0, this.perpage = (r = e.count) !== null && r !== void 0 ? r : this.perpage, [2
          /*return*/];
        });
      });
    }, n.prototype.reset = function () {
      this.newsMap = /* @__PURE__ */new Map(), this.initNewsMap();
    }, n.prototype.setPage = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          switch (i.label) {
            case 0:
              return e > this.total_page ? this.page = this.total_page : e <= 0 ? this.page = 0 : this.page = e, [4, this.checkNews()];
            case 1:
              return i.sent(), [2
              /*return*/];
          }
        });
      });
    }, n.prototype.setLabel = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          switch (i.label) {
            case 0:
              return this.active_label_id = Number(e.label_id), this.page = 0, [4, this.checkNews()];
            case 1:
              return i.sent(), [2
              /*return*/];
          }
        });
      });
    }, n.prototype.checkNews = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return this.news_list.length ? [3, 2] : [4, this.fetchNews()];
            case 1:
              e.sent(), e.label = 2;
            case 2:
              return [2
              /*return*/];
          }
        });
      });
    }, n.prototype.fetchNews = function () {
      return __awaiter(this, void 0, void 0, function () {
        var e, i, r, o, a;
        return __generator(this, function (s) {
          switch (s.label) {
            case 0:
              if (e = this.newsMap.get(this.active_label_id), !e || this.isLoading) return [2, []];
              if (i = this.page * this.perpage, this.page < 0 || i >= e.total_num) return [2, []];
              s.label = 1;
            case 1:
              return s.trys.push([1, 3, 4, 5]), this.isLoading = !0, this.emit("loadstart"), r = Object.assign({}, {
                offset: i,
                get_num: this.perpage,
                primary_label_id: Number(this.column.label_id),
                secondary_label_id: this.active_label_id,
                content_class: DefaultParams.ContentClass,
                ext_info_type_list: DefaultParams.ExtInfo
              }, this.list_query_params), [4, this.cms_helper_instance.getFeedsByColumns(r)];
            case 2:
              return o = s.sent().data, this.appendNews({
                start: i,
                end: i + this.perpage,
                label_id: this.active_label_id,
                news_list: o.info_content,
                total_num: o.total_num
              }), [2, o.info_content];
            case 3:
              return a = s.sent(), this.emit("loaderror", a), [2, []];
            case 4:
              return this.isLoading = !1, this.emit("loadend"), [7
              /*endfinally*/];

            case 5:
              return [2
              /*return*/];
          }
        });
      });
    }, n.prototype.appendNews = function (e) {
      var i = e.label_id,
        r = e.news_list,
        o = e.total_num,
        a = e.start,
        s = e.end,
        l = this.newsMap.get(i);
      if (l) for (var d = a, h = 0; d < s; d++, h++) l.total_num = o, l.news_list[d] = r[h];else {
        for (var u = [], d = a, h = 0; d < s; d++, h++) u[d] = r[h];
        this.newsMap.set(i, {
          total_num: o,
          news_list: u
        });
      }
    }, n.prototype.initNewsMap = function () {
      var e = this;
      this.second_label_list.forEach(function (i) {
        !e.use_all && Number(i.label_id) === Number(e.column.default_secondary_label_id) && (e.active_label_id = Number(i.label_id)), e.newsMap.set(Number(i.label_id), {
          total_num: 1 / 0,
          news_list: []
        });
      });
    }, n;
  }(BasePageManager),
  NewsScrollManager = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = t.call(this, e) || this;
      return i._newsMap = /* @__PURE__ */new Map(), i.initNewsMap({
        use_all: e.use_all
      }), i;
    }
    return Object.defineProperty(n.prototype, "is_finish", {
      get: function get() {
        var e = this._newsMap.get(this.active_label_id);
        return (e == null ? void 0 : e.news_list.length) === (e == null ? void 0 : e.total_num);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "news_list", {
      get: function get() {
        var e,
          i = this._newsMap.get(this.active_label_id);
        return (e = i == null ? void 0 : i.news_list) !== null && e !== void 0 ? e : [];
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.setLabel = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          switch (i.label) {
            case 0:
              return this.active_label_id = Number(e.label_id), this.news_list.length !== 0 ? [3, 2] : [4, this.fetchNews()];
            case 1:
              i.sent(), i.label = 2;
            case 2:
              return [2
              /*return*/];
          }
        });
      });
    }, n.prototype.fetchNews = function () {
      return __awaiter(this, void 0, void 0, function () {
        var e, i, r, o;
        return __generator(this, function (a) {
          switch (a.label) {
            case 0:
              if (e = this._newsMap.get(this.active_label_id), !e || this.isLoading || !(this === null || this === void 0) && this.is_finish) return [2, []];
              a.label = 1;
            case 1:
              return a.trys.push([1, 3, 4, 5]), this.isLoading = !0, this.emit("loadstart"), i = Object.assign({}, {
                get_num: this.perpage,
                offset: e == null ? void 0 : e.offset,
                primary_label_id: this.column.label_id,
                secondary_label_id: this.active_label_id,
                content_class: DefaultParams.ContentClass,
                ext_info_type_list: DefaultParams.ExtInfo
              }, this.list_query_params), [4, this.cms_helper_instance.getFeedsByColumns(i)];
            case 2:
              return r = a.sent().data, this.appendNews({
                label_id: this.active_label_id,
                offset: r.next_offset,
                total_num: r.total_num,
                news_list: r.info_content
              }), [2, r.info_content];
            case 3:
              return o = a.sent(), this.emit("loaderror", o), [2, []];
            case 4:
              return this.isLoading = !1, this.emit("loadend"), [7
              /*endfinally*/];

            case 5:
              return [2
              /*return*/];
          }
        });
      });
    }, n.prototype.appendNews = function (e) {
      var i,
        r = e.label_id,
        o = e.total_num,
        a = e.offset,
        s = e.news_list,
        l = this._newsMap.get(r);
      l ? (l.offset = a, l.total_num = o, (i = l.news_list).push.apply(i, s)) : this._newsMap.set(r, {
        total_num: o,
        news_list: s,
        offset: a
      });
    }, n.prototype.initNewsMap = function (e) {
      var i = this;
      this.second_label_list.forEach(function (r) {
        !e.use_all && Number(r.label_id) === Number(i.column.default_secondary_label_id) && (i.active_label_id = r.label_id), i._newsMap.set(r.label_id, {
          offset: 0,
          news_list: [],
          total_num: 1 / 0
        });
      });
    }, n;
  }(BasePageManager);
function deprecatedLog(t) {
  console.warn("[deprecated]: use ".concat(t, " instead"));
}
function useJumpMethod(t, n) {
  deprecatedLog("getLinkByFeedDetail");
  var e = t.jump_type,
    i = t.jump_url,
    r = t.feed_id,
    o = t.external_open_type;
  switch (e) {
    case LinkType.Self_Build:
    case LinkType.Inner_Link:
      {
        n(r);
        break;
      }
    case LinkType.Inner_Article:
      {
        n(i);
        break;
      }
    case LinkType.External_Link:
      {
        window.open(i, o || DefaultParams.WindowOpenType);
        break;
      }
    case LinkType.Self_Build_Pic:
      break;
    default:
      {
        n(r);
        break;
      }
  }
}
var RES_PREFIX = "request-",
  ERR_PREFIX = "failed-",
  PageRPC = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = this,
        r;
      return i = t.call(this) || this, i.req_id = 0, i.map = /* @__PURE__ */new Map(), i.url = (r = e.url) !== null && r !== void 0 ? r : "*", i.target = e.target, i.bindEvents(), i;
    }
    return Object.defineProperty(n.prototype, "url_obj", {
      get: function get() {
        var e = new URL(this.url);
        return e;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.register = function (e, i) {
      this.map.set(e, i);
    }, n.prototype.unreister = function (e) {
      this.map["delete"](e);
    }, n.prototype.call = function (e, i) {
      var r = this,
        o = {
          args: i,
          type: "call",
          cmd: e,
          id: this.req_id
        };
      return this.send(o), new Promise(function (a, s) {
        r.once("".concat(RES_PREFIX).concat(r.req_id), a), r.once("".concat(ERR_PREFIX).concat(r.req_id), s), r.req_id += 1;
      });
    }, n.prototype.messageHandler = function (e) {
      var i = e.type;
      if (i === "call") return this.handleReq(e);
      if (i === "res") return this.handleRes(e);
    }, n.prototype.handleRes = function (e) {
      var i = e.id,
        r = e.data,
        o = e.err;
      r && !o && this.emit("".concat(RES_PREFIX).concat(i), r), o && this.emit("".concat(ERR_PREFIX).concat(i), o);
    }, n.prototype.handleReq = function (e) {
      var i;
      return __awaiter(this, void 0, void 0, function () {
        var r, o, a, s, l;
        return __generator(this, function (u) {
          switch (u.label) {
            case 0:
              r = e.cmd, o = e.args, a = (i = this.map.get(r)) !== null && i !== void 0 ? i : function () {}, u.label = 1;
            case 1:
              return u.trys.push([1, 3,, 4]), [4, a(o)];
            case 2:
              return s = u.sent(), this.send({
                type: "res",
                id: e.id,
                data: s
              }), [3, 4];
            case 3:
              return l = u.sent(), this.send({
                err: l,
                type: "res",
                id: e.id
              }), [3, 4];
            case 4:
              return [2
              /*return*/];
          }
        });
      });
    }, n.prototype.bindEvents = function () {
      var e = this;
      window.addEventListener("message", function (i) {
        var r = i.data,
          o = i.origin;
        e.url_obj.origin === o && (e.emit("receive", r), e.messageHandler(r), console.log("[MESSAGER]: ", "domain<".concat(location.origin, "> receive from domain<").concat(o, "> -> "), r));
      }, !1);
    }, n.prototype.send = function (e) {
      var i;
      (i = this.target) === null || i === void 0 || i.postMessage(e, this.url_obj.origin);
    }, n;
  }(EventEmitter),
  VideoStateControl = /** @class */
  function () {
    function t(n) {
      this._conifg = {
        max_voice_count: 1
      }, this._players = [], this._playing_player = [], this._conifg = n;
    }
    return t.prototype.stop = function (n) {
      n.pause();
    }, t.prototype.mute = function (n) {
      n.muted = !0;
    }, t.prototype.unmute = function (n) {
      n.muted = !1;
    }, t.prototype.removePlaying = function (n) {
      var e = this._playing_player.indexOf(n);
      e >= 0 && this._playing_player.splice(e, 1);
    }, t.prototype.addPlayer = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        var e,
          i,
          r = this;
        return __generator(this, function (o) {
          return e = n.target, i = n.type, i === "native" && (this._players.push(e), e == null || e.addEventListener("playing", function () {
            r.play(e);
          }), e == null || e.addEventListener("ended", function () {
            r.removePlaying(e);
          }), e == null || e.addEventListener("pause", function () {
            r.removePlaying(e);
          })), i === "embed" && (this._players.push(e), e.on("playing", function () {
            r.play(e);
          }), e.on("not-playing", function () {
            r.removePlaying(e);
          })), [2
          /*return*/];
        });
      });
    }, t.prototype.play = function (n) {
      var e, i;
      this._playing_player.push(n);
      for (var r = (i = (e = this._conifg) === null || e === void 0 ? void 0 : e.max_voice_count) !== null && i !== void 0 ? i : 1; this._playing_player.length > r;) {
        var o = this._playing_player[0];
        o && (this.stop(o), this.removePlaying(o));
      }
    }, t;
  }();
function isYTIframe(t) {
  if (isDom(t)) {
    var n = t.getAttribute("src") || "";
    if (n.includes(youtube_domain) && t.tagName.toLowerCase() === "iframe") return !0;
  }
  return !1;
}
function getEmbedPlayerByIframe(t) {
  var n = this;
  return new Promise(function (e, i) {
    var r;
    try {
      var o = (r = t.getAttribute("src")) !== null && r !== void 0 ? r : "",
        a = new URL(o);
      a.searchParams.append("enablejsapi", "1"), t.setAttribute("src", a.href), t.addEventListener("load", function () {
        return __awaiter(n, void 0, void 0, function () {
          var s, l;
          return __generator(this, function (u) {
            switch (u.label) {
              case 0:
                return [4, getIframePlayer(t)];
              case 1:
                return s = u.sent(), l = getInstance(s, "iframe"), e(l), [2
                /*return*/];
            }
          });
        });
      });
    } catch (s) {
      i(s);
    }
  });
}
var CmsDetail = /** @class */
  function () {
    function t(n) {
      this._video_state_controller = new VideoStateControl(), this._detail_options = Object.assign({
        isolation_type: "iframe",
        video_style: "height: 40vh; width: 100%;"
      }, n), this._container = injectElement(this._detail_options.el);
    }
    return Object.defineProperty(t.prototype, "content_container", {
      get: function get() {
        return this._content_container;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "video_el", {
      get: function get() {
        return this._video_el;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "video_info", {
      get: function get() {
        return getCmsVideoInfo(this._cms_content);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "content", {
      get: function get() {
        var n;
        return parseRichTextContent((n = this._cms_content.content) !== null && n !== void 0 ? n : "");
      },
      set: function set(n) {
        this._cms_content.content = n;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.init = function (n) {
      if (!n) throw cms_custom_aegis.report({
        level: LogLevel.RETCODE_ERR,
        msg: "empty content requested, ".concat(location.href)
      }), new Error("no content");
      return this._cms_content = n, this._container = injectElement(this._detail_options.el), this;
    }, t.prototype.removeVideo = function () {
      removeElement(this._video_el);
    }, t.prototype.removeContent = function () {
      removeElement(this._content_container);
    }, t.prototype.updateEls = function (n) {
      var e = this._detail_options.el_update,
        i = e === void 0 ? {} : e,
        r = n !== null && n !== void 0 ? n : this._cms_content;
      Object.keys(i).forEach(function (o) {
        var a = i[o],
          s = document.querySelector(o);
        if (s) try {
          if (typeof a == "function" && (s.innerHTML = a(r)), typeof a == "string") {
            var l = getValueByChainedKey(r, a) || "";
            s.innerHTML = l;
          }
        } catch (_unused16) {
          cms_custom_aegis.report({
            level: LogLevel.JS_ERR,
            msg: "content mismatched, ".concat(o)
          });
        }
      });
    }, t.prototype.injectContent = function () {
      return __awaiter(this, void 0, void 0, function () {
        var n, e, i;
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              if (!this._detail_options.style_isolation) return [3, 6];
              switch (n = this._detail_options.isolation_type, n) {
                case "iframe":
                  return [3, 1];
                case "shadowdom":
                  return [3, 3];
              }
              return [3, 3];
            case 1:
              return [4, createRichTextElement(this.content, {
                target: this._container,
                script: this._detail_options.isolation_extra_script,
                styleText: this._detail_options.isolation_extra_style
              })];
            case 2:
              return e = r.sent().iframe, this._content_container = e, [3, 5];
            case 3:
              return [4, createRichTextShadowDom(this.content, {
                target: this._container,
                styleText: this._detail_options.isolation_extra_style
              })];
            case 4:
              return i = r.sent(), this._content_container = i, [3, 5];
            case 5:
              return [3, 7];
            case 6:
              this._content_container = createElement("div"), this._content_container.innerHTML = this.content, this._container.appendChild(this._content_container), r.label = 7;
            case 7:
              return processWithInteract(this._content_container, {
                is_iframe: this._detail_options.isolation_type === "iframe"
              }), this.manageVideoState(), [2
              /*return*/];
          }
        });
      });
    }, t.prototype.injectVideo = function () {
      var n = this;
      if (this.video_info.has_video) {
        var e = this.video_info,
          i = getRandomId();
        if (e.is_embed) {
          var r = createElement("div", {
            id: i,
            style: this._detail_options.video_style
          });
          this._video_el = r, Embed[e.platform].init({
            element: r,
            videoId: e.vid || ""
          }).then(function (o) {
            n._video_state_controller.addPlayer({
              type: "embed",
              target: o
            });
          });
        } else {
          var r = createElement("video", {
            id: i,
            src: e.vid,
            style: this._detail_options.video_style,
            controls: "controls",
            playsinline: !0,
            poster: e.video_cover
          });
          this._video_el = r, this._video_state_controller.addPlayer({
            type: "native",
            target: r
          });
        }
        this._container.appendChild(this._video_el);
      }
    }, t.prototype.manageVideoState = function () {
      var n = this;
      this._content_container && (traverseDom(this._content_container, "iframe", function (e) {
        isYTIframe(e) && getEmbedPlayerByIframe(e).then(function (i) {
          n._video_state_controller.addPlayer({
            type: "embed",
            target: i
          });
        });
      }), traverseDom(this._content_container, "video", function (e) {
        n._video_state_controller.addPlayer({
          target: e,
          type: "native"
        });
      }));
    }, t;
  }(),
  default_preview_key = "preview",
  CmsContentGetter = /** @class */
  function () {
    function t(n) {
      this._cms_detail_map = /* @__PURE__ */new Map(), this._cms_helper = n, this.setMessager();
    }
    return Object.defineProperty(t.prototype, "is_preview", {
      get: function get() {
        return getQuery(DefaultQueryKey.CmsPreviewEnv) === DefaultParams.PreviewVal;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "use_instant_preview", {
      get: function get() {
        return (window.opener || window.parent) && getQuery(DefaultQueryKey.CmsPreviewVersion) === DefaultParams.InstantPreviewVersion;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.searchFeedList = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        var e, i, r, o, a, s;
        return __generator(this, function (l) {
          switch (l.label) {
            case 0:
              return e = n.use_default_language, i = e === void 0 ? !1 : e, [4, this._cms_helper.post({
                url: CMS_URLS.get_feeds_by_search,
                data: Object.assign({}, {
                  offset: DefaultParams.Offset,
                  ext_info_type_list: DefaultParams.ExtInfo,
                  use_default_language: DefaultParams.UseDefaultLang
                }, n)
              })];
            case 1:
              return r = l.sent(), o = r.data, a = !i && !n.disable_use_default_language && (o == null ? void 0 : o.use_default_language), !(o != null && o.is_finish) && a ? (s = JSON.parse(JSON.stringify(n)), s.use_default_language = o == null ? void 0 : o.use_default_language, [2, this.searchFeedList(s)]) : [2, r];
          }
        });
      });
    }, t.prototype.getFeedsDetail = function (n, e) {
      return __awaiter(this, void 0, void 0, function () {
        var i,
          r,
          o,
          a,
          s,
          l,
          u,
          d,
          h,
          p,
          m,
          R = this;
        return __generator(this, function (T) {
          if (isInPrerenderServe() && window.__CMS_PRE_INJECT_CONTENT_DATA__) try {
            return i = JSON.parse(window.__CMS_PRE_INJECT_CONTENT_DATA__), [2, Promise.resolve(i)];
          } catch (_unused17) {}
          return r = e !== null && e !== void 0 ? e : {}, o = r.ignore_father_id, a = o === void 0 ? !1 : o, s = r.is_father_content, l = s === void 0 ? !1 : s, u = r.father_id_key, d = u === void 0 ? DefaultQueryKey.CmsFatherContentId : u, h = getQuery(d), p = function p(O) {
            var N;
            return _assign(_assign({}, R.getPreviewArgs()), (N = {}, N[O ? "father_content_id" : "content_id"] = O || n, N));
          }, m = a ? p(null) : p(h) || l && p(n), [2, this._cms_helper.post({
            data: m,
            url: CMS_URLS.get_feeds_detail
          })];
        });
      });
    }, t.prototype.getFeedList = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        var e, i, r, o, a, s, l, u;
        return __generator(this, function (d) {
          switch (d.label) {
            case 0:
              return e = n.use_default_language, i = e === void 0 ? DefaultParams.UseDefaultLang : e, [4, this._cms_helper.post({
                url: CMS_URLS.get_feeds_by_cloumn,
                data: Object.assign({}, {
                  language: [this._cms_helper.lang],
                  gameid: this._cms_helper.cms_gameid,
                  offset: DefaultParams.Offset,
                  get_num: DefaultParams.Perpage,
                  ext_info_type_list: DefaultParams.ExtInfo,
                  secondary_label_id: DefaultParams.SecondLabelId
                }, n, this.getPreviewArgs())
              })];
            case 1:
              return r = d.sent(), o = r.data, a = (r == null ? void 0 : r.data).info_content, s = a === void 0 ? [] : a, l = !i && !n.disable_use_default_language && (o == null ? void 0 : o.use_default_language), s.length === 0 && !(o != null && o.is_finish) && l ? (u = JSON.parse(JSON.stringify(n)), u.use_default_language = o == null ? void 0 : o.use_default_language, [2, this.getFeedList(u)]) : [2, r];
          }
        });
      });
    }, t.prototype.getContentDetail = function (n) {
      var e, i, r;
      return __awaiter(this, void 0, void 0, function () {
        var o, a, s, l, u;
        return __generator(this, function (d) {
          switch (d.label) {
            case 0:
              return o = new CmsDetail(n), a = {
                content: "",
                content_id: default_preview_key
              }, (e = n.cms_info) !== null && e !== void 0 ? (l = e, [3, 3]) : [3, 1];
            case 1:
              return [4, this.getFeedDetailV2(n)];
            case 2:
              l = (i = d.sent()) === null || i === void 0 ? void 0 : i.data, d.label = 3;
            case 3:
              return s = l, u = this.use_instant_preview ?
              // 默认先走一次接口，除非全新预览
              s || a : s, o.init(u), o.injectVideo(), o.updateEls(), [4, o.injectContent()];
            case 4:
              return d.sent(), this._cms_detail_map.set((r = u == null ? void 0 : u.content_id) !== null && r !== void 0 ? r : default_preview_key, o), [2, {
                info: u,
                video_el: o.video_el,
                content_el: o.content_container,
                // patch of cmsContentStyleIsolation@deprecate
                iframe: o.content_container,
                shadow: o.content_container,
                resize: function resize() {}
              }];
          }
        });
      });
    }, t.prototype.getFeedDetailV2 = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        var e, i, r, o, a, s, l, u, d;
        return __generator(this, function (h) {
          switch (h.label) {
            case 0:
              if (e = n.content_id, i = n.father_content_id, r = n.content_key, o = r === void 0 ? DefaultQueryKey.CmsContentId : r, a = n.father_content_key, s = a === void 0 ? DefaultQueryKey.CmsFatherContentId : a, l = e || getQuery(o), u = i || getQuery(s), !l && !u) return [2, null];
              h.label = 1;
            case 1:
              return h.trys.push([1, 6,, 7]), d = null, l ? [4, this.getFeedsDetail(l)] : [3, 3];
            case 2:
              d = h.sent(), h.label = 3;
            case 3:
              return u ? [4, this.getFeedsDetail(u, {
                is_father_content: !0
              })] : [3, 5];
            case 4:
              d = h.sent(), h.label = 5;
            case 5:
              return [2, d];
            case 6:
              return h.sent(), [2, null];
            case 7:
              return [2
              /*return*/];
          }
        });
      });
    }, t.prototype.getPreviewArgs = function () {
      return this.is_preview ? {
        with_off: !0,
        sign_info: {
          sign: getQuery(DefaultQueryKey.CmsPreviewSign) || "",
          timestamp: Number(getQuery(DefaultQueryKey.CmsPreviewTs)) || 0,
          app_key: getQuery(DefaultQueryKey.CmsPreviewAppKey) || ""
        }
      } : {};
    }, t.prototype.setMessager = function () {
      var n = this,
        e,
        i,
        r,
        o;
      this.use_instant_preview && (this._cms_system = new PageRPC({
        target: (r = (i = (e = window.opener) !== null && e !== void 0 ? e : window.top) !== null && i !== void 0 ? i : window.parent) !== null && r !== void 0 ? r : window,
        url: GET_CMS_ADMIN_ORIGIN((o = getQuery(DefaultQueryKey.CmsAdminRegion)) !== null && o !== void 0 ? o : "")
      }), this._cms_system.call(PageRpcExportedMethods.Ready), this._cms_system.register(PageRpcRegisteredMethods.ContentUpdate,
      // cms 侧按 Detail格式返回
      function (a) {
        var s = a.content,
          l = a.content_id,
          u = l === void 0 ? default_preview_key : l,
          d = n._cms_detail_map.get(u);
        d && (d.removeContent(), d.content = s, d.injectContent(), d.updateEls(a));
      }));
    }, t;
  }(),
  CmsHelper = /** @class */
  function (t) {
    __extends(n, t);
    function n() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.useJumpMethod = useJumpMethod, e.getLinkByFeedDetail = openDetailLink, e._content_getter = new CmsContentGetter(e), e.getCmsVideoInfo = function (i) {
        return getCmsVideoInfo(i);
      }, e;
    }
    return n.prototype.getNewsManager = function (e) {
      var i, r;
      return __awaiter(this, void 0, void 0, function () {
        var o, a;
        return __generator(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this.getColumnByName(e.column_name)];
            case 1:
              return o = s.sent(), o ? (a = {
                instance: this,
                column: o,
                use_all: (i = e.use_all) !== null && i !== void 0 ? i : !1,
                all_label_name: (r = e.all_label_name) !== null && r !== void 0 ? r : "all"
              }, e.manager_type === "page" ? [2, new NewsPageManager(Object.assign({}, e, a))] : [2, new NewsScrollManager(Object.assign({}, e, a))]) : [2
              /*return*/];
          }
        });
      });
    }, n.prototype.getFeedDetailV2 = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this._content_getter.getFeedDetailV2(e)];
        });
      });
    }, n.prototype.getGroupFeedDetail = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i;
        return __generator(this, function (r) {
          return i = Object.assign({}, {
            offset: DefaultParams.Offset,
            get_num: DefaultParams.Perpage,
            ext_info_type_list: DefaultParams.ExtInfo
          }, e), [2, this.post({
            url: CMS_URLS.get_group_feeds_detail,
            data: i
          })];
        });
      });
    }, n.prototype.getFeedsDetail = function (e, i) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (r) {
          return [2, this._content_getter.getFeedsDetail(e, i)];
        });
      });
    }, n.prototype.getLabelListByGroupdId = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            sign: !0,
            data: e,
            url: CMS_URLS.get_label_list_by_group
          })];
        });
      });
    }, n.prototype.getLabelList = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            sign: !0,
            data: e,
            url: CMS_URLS.get_label_list
          })];
        });
      });
    }, n.prototype.getColumns = function () {
      return __awaiter(this, void 0, void 0, function () {
        var e,
          i = this;
        return __generator(this, function (r) {
          if (isInPrerenderServe() && window.__CMS_PRE_INJECT_COL_DATA__) try {
            return e = JSON.parse(window.__CMS_PRE_INJECT_COL_DATA__), this.columns = e, [2, Promise.resolve(e)];
          } catch (_unused18) {}
          return this.columns ? [2, this.columns] : this._column_init ? [2, this._column_init()] : (this._column_init = throttlePromise(function () {
            return __awaiter(i, void 0, void 0, function () {
              var o;
              return __generator(this, function (a) {
                switch (a.label) {
                  case 0:
                    return [4, this.post({
                      url: CMS_URLS.get_columns
                    })];
                  case 1:
                    return o = a.sent(), this._column_init = void 0, this.columns = o, [2, o];
                }
              });
            });
          }), [2, this._column_init()]);
        });
      });
    }, n.prototype.getFeedsByColumns = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this._content_getter.getFeedList(e)];
        });
      });
    }, n.prototype.getFeedsBySearch = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this._content_getter.searchFeedList(e)];
        });
      });
    }, n.prototype.getBackgroundImg = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            url: CMS_URLS.get_backgrounds,
            data: e
          })];
        });
      });
    }, n.prototype.reportUserAction = function (e) {
      var i;
      return __awaiter(this, void 0, void 0, function () {
        var r;
        return __generator(this, function (o) {
          return r = Object.assign({}, {
            reprot_type: (i = e.reprot_type) !== null && i !== void 0 ? i : e.report_type,
            content_id: getQuery(DefaultQueryKey.CmsContentId)
          }, e), delete r.report_type, [2, this.post({
            data: r,
            sign: !0,
            url: CMS_URLS.report_user_action
          })];
        });
      });
    }, n.prototype.switchLang = function (e) {
      this.lang = e, this.reset();
    }, n.prototype.switchArea = function (e) {
      this.area_id = e, this.reset();
    }, n.prototype.getPreRegUserCount = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (e) {
          return [2, this.post({
            url: CMS_URLS.get_reserve_number,
            data: {
              game_id: this.cms_gameid,
              area_id: this.area_id
            }
          })];
        });
      });
    }, n.prototype.tlogReportByQuery = function (e, i) {
      var r = this,
        o = document.querySelectorAll(e);
      o == null || o.forEach(function (a) {
        a.addEventListener("click", function (s) {
          s.preventDefault();
          var l = a.tagName.toLowerCase();
          r.tlogReport(i)["finally"](function () {
            var u, d;
            switch (l) {
              case "a":
                {
                  var h = a.getAttribute("href");
                  if (!h) return;
                  isiOS() ? window.location.href = h : window.open(h, (u = a.getAttribute("target")) !== null && u !== void 0 ? u : "_blank");
                  break;
                }
              case "submit":
              case "button":
                var p = s.target;
                (p == null ? void 0 : p.type) === "submit" && ((d = p == null ? void 0 : p.closest("form")) === null || d === void 0 || d.submit());
            }
          });
        });
      });
    }, n.prototype.tlogReport = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i;
        return __generator(this, function (r) {
          return i = Object.assign({}, e, {
            ext_content: typeof e.ext_content == "string" ? e.ext_content : JSON.stringify(e.ext_content)
          }), [2, this.post({
            data: i,
            url: CMS_URLS.tlog_report
          })];
        });
      });
    }, n.prototype.getRandomCode = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            url: CMS_URLS.get_random_code,
            data: e
          })];
        });
      });
    }, n.prototype.verifyLogin = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            url: CMS_URLS.verify_login,
            data: Object.assign({}, e, {
              login_type: ChannelIdMap[e.login_type]
            })
          })];
        });
      });
    }, n.prototype.officialApply = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            sign: !0,
            url: CMS_URLS.pa_official_apply,
            data: Object.assign({}, e, {
              game_id: this.cms_gameid,
              apply_data: JSON.stringify(e.apply_data) || "",
              login_type: ChannelIdMap[e.login_type]
            })
          })];
        });
      });
    }, n.prototype.verifyTXCaptcha = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i;
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, useTXCaptcha(e)];
            case 1:
              return i = r.sent(), [2, this.post({
                url: CMS_URLS.pa_tecent_captcha_verify,
                data: i
              })];
          }
        });
      });
    }, n.prototype.officialUnEmail = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            url: CMS_URLS.pa_official_unapply,
            data: {
              game_id: this.cms_gameid,
              type_id: e.type_id,
              email: e.email || ""
            }
          })];
        });
      });
    }, n.prototype.getColumnByName = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i;
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, this.getColumns()];
            case 1:
              return i = r.sent().data, i != null && i.primary_label_list && Array.isArray(i == null ? void 0 : i.primary_label_list) ? [2, i.primary_label_list.find(function (o) {
                var a = o.raw_label_name,
                  s = a === void 0 ? "" : a,
                  l = s.toLowerCase();
                return l.includes(e.toLowerCase());
              })] : [2
              /*return*/];
          }
        });
      });
    }, n.prototype.batchGetLikeInfo = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            url: CMS_URLS.batch_get_like_status,
            data: e
          })];
        });
      });
    }, n.prototype.likeOperation = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            url: CMS_URLS.like_content,
            data: e
          })];
        });
      });
    }, n.prototype.getUploadCosUrl = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i, r, o, a, s, l;
        return __generator(this, function (u) {
          return i = e.login_info, r = e.campaign_id, o = e.uid, a = e.img_file, e.need_login ? s = isInIntlBrowser$1 ? {
            register_id: o,
            type: r,
            intl_token_type: IGetCosUrlTokenType.INGAME,
            intl_token: i == null ? void 0 : i.encodeparam,
            login_type: i == null ? void 0 : i.intl_channel_id,
            // 2023/4/9
            openid: i == null ? void 0 : i.openid
          } : {
            register_id: o,
            type: r,
            openid: i == null ? void 0 : i.openid,
            intl_token_type: IGetCosUrlTokenType.WEB,
            intl_token: i == null ? void 0 : i.token,
            login_type: i == null ? void 0 : i.intl_channel_id
          } : s = {
            register_id: o,
            type: r
          }, l = Object.assign({}, s, {
            game_id: this.cms_gameid,
            name: "".concat(this.cms_gameid, "/").concat(s.type, "/").concat(s.register_id, ".").concat(a.name.split(".").pop())
          }), [2, this.post({
            url: CMS_URLS.get_cos_upload_url,
            data: l
          })];
        });
      });
    }, n.prototype.dynamicShare = function (e) {
      var i;
      return __awaiter(this, void 0, void 0, function () {
        var r,
          o,
          a,
          s,
          l = this;
        return __generator(this, function (u) {
          switch (u.label) {
            case 0:
              return [4, this.post({
                url: CMS_URLS.get_activity_info,
                data: {
                  campaign_id: e.campaign_id
                }
              })];
            case 1:
              return r = u.sent().data, [4, this.getUploadCosUrl(Object.assign({}, e, r))];
            case 2:
              return o = u.sent(), a = function a(d) {
                var h = d,
                  p = {
                    type_id: e.campaign_id,
                    area_id: l.area_id,
                    game_id: l.cms_gameid,
                    uid: e.uid
                  };
                return Object.keys(p).forEach(function (m) {
                  h = h == null ? void 0 : h.replace("{".concat(m, "}"), p[m]);
                }), h;
              }, s = function s() {
                var d,
                  h = e.share_pre_path,
                  p = e.url_querys,
                  m = e.campaign_id,
                  R = e.uid;
                return {
                  fb_appid: r.fb_appid,
                  image_url: (d = a(r.img_cdn_url)) !== null && d !== void 0 ? d : "",
                  share_url: "".concat(h !== null && h !== void 0 ? h : "".concat(location.origin, "/socialshare/share"), "/").concat(l.cms_gameid, "/").concat(l.area_id, "/").concat(m, "/").concat(R).concat(p ? "?".concat(p.toString()) : "")
                };
              }, o.data.result === CmsResCode.CMS_FILE_ALREDY_EXIST ? [2, s()] : o.data.result !== CmsResCode.CMS_RES_SUCCESS ? [3, 4] : [4, putRequest({
                body: e.img_file,
                url: (i = o.data.upload_url) !== null && i !== void 0 ? i : ""
              })];
            case 3:
              return u.sent(), [2, s()];
            case 4:
              throw new Error(o.data.errmsg);
          }
        });
      });
    }, n.prototype.captchaVerify = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            data: e,
            url: CMS_URLS.pa_google_recaptcha
          })];
        });
      });
    }, n.prototype.getGameLibrary = function (e) {
      var i, r;
      return __awaiter(this, void 0, void 0, function () {
        var o;
        return __generator(this, function (a) {
          switch (a.label) {
            case 0:
              return [4, this.post({
                sign: !0,
                data: Object.assign({
                  page_seq: DefaultParams.PageNum,
                  page_size: DefaultParams.Perpage
                }, e),
                url: CMS_URLS.get_game_library
              })];
            case 1:
              return o = a.sent(), !((r = (i = o.data) === null || i === void 0 ? void 0 : i.data_list) === null || r === void 0) && r.length && (o.data.data_list = o.data.data_list.slice().map(function (s) {
                return parseDataJSON(s, ["game_detail"]);
              })), [2, o];
          }
        });
      });
    }, n.prototype.getGameData = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i;
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, this.post({
                url: CMS_URLS.get_game_data,
                sign: !0,
                data: e
              })];
            case 1:
              return i = r.sent(), [2, parseDataJSON(i, ["data.info.game_detail"])];
          }
        });
      });
    }, n.prototype.getGameShopList = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            url: CMS_URLS.get_game_shop_list,
            sign: !0,
            data: Object.assign({
              page_seq: DefaultParams.PageNum,
              page_size: DefaultParams.Perpage
            }, e)
          })];
        });
      });
    }, n.prototype.getGameShopInfo = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.post({
            url: CMS_URLS.get_game_shop_info,
            sign: !0,
            data: e
          })];
        });
      });
    }, n.prototype.getMediaLabel = function (e) {
      var i, r;
      return __awaiter(this, void 0, void 0, function () {
        var o, a;
        return __generator(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this.post({
                sign: !0,
                url: CMS_URLS.get_media_label_list
              })];
            case 1:
              return o = s.sent(), e != null && e.use_all ? (a = ((i = o == null ? void 0 : o.data) === null || i === void 0 ? void 0 : i.labels) || [], a.unshift({
                media_label_id: 0,
                media_label_name: e.all_label_name || "ALL"
              }), [2, a]) : [2, ((r = o == null ? void 0 : o.data) === null || r === void 0 ? void 0 : r.labels) || []];
          }
        });
      });
    }, n.prototype.getMediaData = function (e) {
      var i, r;
      return __awaiter(this, void 0, void 0, function () {
        var o;
        return __generator(this, function (a) {
          switch (a.label) {
            case 0:
              return e != null && e.media_label_id || e == null || delete e.media_label_id, [4, this.post({
                sign: !0,
                data: Object.assign({
                  page_seq: DefaultParams.PageNum,
                  page_size: DefaultParams.Perpage
                }, e),
                url: CMS_URLS.get_media_data
              })];
            case 1:
              return o = a.sent(), !((r = (i = o.data) === null || i === void 0 ? void 0 : i.library_data_list) === null || r === void 0) && r.length && (o.data.library_data_list = o.data.library_data_list.slice().map(function (s) {
                return parseDataJSON(s, ["json_data"]);
              })), [2, o];
          }
        });
      });
    }, n.prototype.initDetailPage = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this._content_getter.getContentDetail(e)];
        });
      });
    }, n.prototype.reset = function () {
      this.columns = void 0, this._column_init = void 0;
    }, n.goDetailLink = openDetailLink, n;
  }(PaBaseHelper),
  IntlEmailSevice = /** @class */
  function () {
    function t(n) {
      this.intl_url = "";
      var e = n.game_id,
        i = n.area_id,
        r = n.typeid,
        o = n.sig;
      this.area_id = i, this.game_id = e, this.typeid = r, this.sig = o, this.setAreaId(i);
    }
    return t.prototype.setAreaId = function (n) {
      this.area_id = n, this.updateRequestUrl();
    }, t.prototype.unsubscribe = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (e) {
          return [2, request({
            url: this.getURL(EMAIL_SVR_URLS.unsubscribe),
            method: "POST",
            data: {
              edata: n !== null && n !== void 0 ? n : getQuery("edata")
            }
          })];
        });
      });
    }, t.prototype.emailApplyV2 = function (n) {
      return request({
        url: this.getURL(EMAIL_SVR_URLS.apply),
        method: "POST",
        data: {
          email: n.email,
          apply_data: JSON.stringify(n.apply_data)
        }
      });
    }, t.prototype.emailApply = function (n, e) {
      return __awaiter(this, void 0, void 0, function () {
        var i, r;
        return __generator(this, function (o) {
          switch (o.label) {
            case 0:
              return deprecatedLog("emailApplyV2"), i = new URLSearchParams({
                typeid: n.typeid,
                sig: n.sig,
                gameid: this.game_id,
                ts: String(Math.floor( /* @__PURE__ */new Date().getTime() / 1e3))
              }), r = "".concat(this.intl_url, "/v1/official/apply?").concat(i.toString()), [4, request({
                url: r,
                method: "POST",
                data: {
                  email: e.email,
                  apply_data: JSON.stringify(e.apply_data)
                }
              })];
            case 1:
              return [2, o.sent()];
          }
        });
      });
    }, t.prototype.getURL = function (n) {
      var e, i;
      if (!this.sig || !this.typeid) return console.warn("Sig or typeid invalid"), "";
      var r = new URLSearchParams({
        typeid: (e = this.typeid) !== null && e !== void 0 ? e : "",
        sig: (i = this.sig) !== null && i !== void 0 ? i : "",
        gameid: this.game_id,
        ts: String(Math.floor( /* @__PURE__ */new Date().getTime() / 1e3))
      });
      return "".concat(this.intl_url).concat(n, "?").concat(r.toString());
    }, t.prototype.updateRequestUrl = function () {
      var n,
        e,
        i = {
          prod: "https://".concat(this.area_id, ".intlgame.com"),
          test: "https://".concat((n = this.area_id) !== null && n !== void 0 ? n : "test-vas", ".intlgame.com"),
          dev: "https://".concat((e = this.area_id) !== null && e !== void 0 ? e : "test-vas", ".intlgame.com")
        };
      this.intl_url = i[ENV$1()];
    }, t;
  }(),
  IntlSevice = /** @class */
  function () {
    function t(n) {
      var e = n.game_id,
        i = n.area_id,
        r = n.extra_config;
      this.game_id = e, this.area_id = i, this.extra_config = r !== null && r !== void 0 ? r : {}, this.status = "pending", this._init();
    }
    return t.prototype.init = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (n) {
          switch (this.status) {
            case "fulfilled":
              return [2, Promise.resolve()];
            case "error":
              {
                this._init();
                break;
              }
            default:
            case "pending":
              return [2, this.throttle_init()];
          }
          return [2
          /*return*/];
        });
      });
    }, t.prototype.queryMyRegion = function () {
      var n, e, i;
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, this.init()];
            case 1:
              return r.sent(), [2, !((n = this.accountApi) === null || n === void 0) && n.queryMyRegion ? (e = this.accountApi) === null || e === void 0 ? void 0 : e.queryMyRegion() : (i = this.accountApi) === null || i === void 0 ? void 0 : i.queryMyCountry()];
          }
        });
      });
    }, t.prototype.share = function (n, e) {
      var i;
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, this.init()];
            case 1:
              return r.sent(), [ExtraWebShareChannel.Whatsapp, ExtraWebShareChannel.Reddit, ExtraWebShareChannel.Line
              // @ts-ignore todo: ask devi
              ].includes(n.third_type) ? [2, this.extraSharing(n, e)] : n.third_type === WebShareChannel.Facebook && !n.app_id ? [2, this.legacySharing(n)] : [2, (i = this.accountApi) === null || i === void 0 ? void 0 : i.share(Object.assign({}, {
                redirect_uri: location.href
              }, n))];
          }
        });
      });
    }, t.prototype.legacySharing = function (n) {
      var e;
      return __awaiter(this, void 0, void 0, function () {
        var i, r;
        return __generator(this, function (o) {
          return i = createUrlSearchParam({
            u: n.href,
            t: n.title
          }), r = "".concat(FB_SHARE_LEGACY_URL, "?").concat(i.toString()), n.only_get_url ? [2, r] : [2, window.open(r, (e = n.windowopen_type) !== null && e !== void 0 ? e : "_blank")];
        });
      });
    }, t.prototype.extraSharing = function (n, e) {
      var i;
      return __awaiter(this, void 0, void 0, function () {
        var r, o, a;
        return __generator(this, function (s) {
          switch (r = n.third_type, r) {
            case ExtraWebShareChannel.Line:
            case ExtraWebShareChannel.Whatsapp:
            case ExtraWebShareChannel.Reddit:
              {
                if (o = createUrlSearchParam(n, ["windowopen_type", "third_type"]), a = "".concat(DeepLinkForShare[r], "?").concat(o.toString()), e != null && e.only_get_url) return [2, a];
                window.open(a, (i = n.windowopen_type) !== null && i !== void 0 ? i : "_blank");
                break;
              }
          }
          return [2, ""];
        });
      });
    }, t.prototype.getAccountApi = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this.init()];
            case 1:
              return n.sent(), [2, this.accountApi];
          }
        });
      });
    }, t.prototype.loginByUrlCode = function () {
      return __awaiter(this, void 0, void 0, function () {
        var n, e, i, r, o, a, s, l;
        return __generator(this, function (u) {
          switch (u.label) {
            case 0:
              return n = getQuery("code"), e = getQuery("msgType") || sessionStorage.getItem(CHANNEL_STORAGE_KEY), [4, this.getAccountApi()];
            case 1:
              if (i = u.sent(), !n || !e) return [2
              /*return*/];

              switch (r = e, r) {
                case "apple":
                  return [3, 2];
                case "google":
                  return [3, 2];
                case "line":
                  return [3, 3];
                case "facebook":
                  return [3, 3];
              }
              return [3, 5];
            case 2:
              return [2, this.intlAuth({
                third_type: e,
                channel_info: {
                  code: n
                }
              })];
            case 3:
              return [4, i == null ? void 0 : i.getThirdAccessToken({
                code: n,
                channel: e,
                gameid: this.game_id
              })];
            case 4:
              return o = u.sent(), a = o.ret, s = o.access_token, l = o.expires_in, a === 0 ? [2, this.intlAuth({
                third_type: e,
                channel_info: {
                  access_token: s,
                  expires_in: l
                }
              })] : [2, Promise.reject("get accesstoken failed")];
            case 5:
              return [2
              /*return*/];

            case 6:
              return [2
              /*return*/];
          }
        });
      });
    }, t.prototype.thirdAuth = function (n) {
      var e;
      return __awaiter(this, void 0, void 0, function () {
        var i, r, o, a;
        return __generator(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this.init()];
            case 1:
              switch (s.sent(), i = n.third_type, r = i, r) {
                case "apple":
                  return [3, 2];
                case "facebook":
                  return [3, 2];
                case "google":
                  return [3, 2];
                case "line":
                  return [3, 2];
                case "twitter":
                  return [3, 2];
              }
              return [3, 4];
            case 2:
              return o = Object.assign({}, n), (shouldUseSinglePageLogin({
                channel: i
              }) || n.callback_url) && (sessionStorage.setItem(CHANNEL_STORAGE_KEY, i), o.windowopen_type = "_self", o.callbackurl = this.getThirdCallbackQuery(n.callback_url)), [4, (e = this.accountApi) === null || e === void 0 ? void 0 : e.thirdAuthorize(o)];
            case 3:
              return a = s.sent(), delete a.ret, delete a.msg, i === "twitter" && (a.oauth_token = a.access_token, a.oauth_secret = a.secret, delete a.access_token, delete a.secret), [2, a];
            case 4:
              return [3, 5];
            case 5:
              return [2
              /*return*/];
          }
        });
      });
    }, t.prototype.intlAuth = function (n) {
      var e;
      return __awaiter(this, void 0, void 0, function () {
        var i, r, o;
        return __generator(this, function (a) {
          switch (a.label) {
            case 0:
              return [4, this.init()];
            case 1:
              return a.sent(), i = n.third_type, r = n.channel_info, [4, (e = this.accountApi) === null || e === void 0 ? void 0 : e.intlAuthorize({
                third_type: i,
                channel_info: r
              })];
            case 2:
              return o = a.sent(), o.ret !== 0 ? [2, Promise.reject(o)] : [2, o];
          }
        });
      });
    }, t.prototype.thirdLogin = function (n) {
      return __awaiter(this, void 0, void 0, function () {
        var e;
        return __generator(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, this.init()];
            case 1:
              return i.sent(), [4, this.thirdAuth(n)];
            case 2:
              return e = i.sent(), e ? [2, this.intlAuth({
                channel_info: e,
                third_type: n.third_type
              })] : [2, Promise.reject("third auth failed")];
          }
        });
      });
    }, t.prototype.getThirdCallbackQuery = function (n) {
      var e = function e(i) {
        var r = new URLSearchParams(i.search);
        return r.append("operate_type", "thirdcallback"), r["delete"]("code"), r["delete"]("msgType"), "".concat(i.origin).concat(i.pathname, "?").concat(r.toString());
      };
      return e(n ? new URL(n) : window.location);
    }, t.prototype._init = function () {
      return __awaiter(this, void 0, void 0, function () {
        var n = this;
        return __generator(this, function (e) {
          return this.throttle_init = throttlePromise(function () {
            return __awaiter(n, void 0, void 0, function () {
              return __generator(this, function (i) {
                switch (i.label) {
                  case 0:
                    return i.trys.push([0, 2,, 3]), [4, appendScript(INTL_CDN_URLS[ENV$1()])];
                  case 1:
                    return i.sent(), window.IntlgameAccountApi ? (this.accountApi = new window.IntlgameAccountApi(_assign({
                      env: this.area_id,
                      gameID: this.game_id
                    }, this.extra_config)), this.status = "fulfilled") : this.status = "error", [3, 3];
                  case 2:
                    return i.sent(), this.status = "error", [3, 3];
                  case 3:
                    return [2
                    /*return*/];
                }
              });
            });
          }), this.throttle_init(), [2
          /*return*/];
        });
      });
    }, t;
  }(),
  bridge$1 = IntlBridge.getInstance();
function validateShareOptions(t) {
  var n = t.channel,
    e = t.type;
  return !((n === InGameChannel.Facebook || n === InGameChannel.FacebookGaming) && ![ShareContentType.REQ_LINK, ShareContentType.REQ_IMAGE, ShareContentType.REQ_VIDEO].includes(e) || (n === InGameChannel.QQ || n === InGameChannel.Whatsapp) && ![ShareContentType.REQ_TEXT, ShareContentType.REQ_LINK, ShareContentType.REQ_IMAGE, ShareContentType.REQ_VIDEO].includes(e) || (n === InGameChannel.Twitter || n === InGameChannel.VK) && ![ShareContentType.REQ_TEXT, ShareContentType.REQ_LINK, ShareContentType.REQ_IMAGE].includes(e) || n === InGameChannel.Discord && ![ShareContentType.REQ_INVITE].includes(e) || n === InGameChannel.Instagram && ![ShareContentType.REQ_IMAGE, ShareContentType.REQ_VIDEO].includes(e) || n === InGameChannel.Garena && ![ShareContentType.REQ_LINK, ShareContentType.REQ_IMAGE].includes(e));
}
function share(t) {
  if (!validateShareOptions(t)) throw new Error("Share option not supported");
  bridge$1.callNative({
    cmd: IntlCMD.SHARE,
    req_data: formatRequest(t)
  });
}
function send(t) {
  if (!validateShareOptions(t)) throw new Error("Send option not supported");
  bridge$1.callNative({
    cmd: IntlCMD.SEND_MSG,
    req_data: formatRequest(t)
  });
}
function removeEmtpyAttr(t) {
  var n = {};
  return Object.keys(t).forEach(function (e) {
    var i = t[e];
    _typeof(i) < "u" && i !== "" && (n[e] = i);
  }), n;
}
function formatRequest(t) {
  var n,
    e,
    i = t.channel,
    r = {
      media_tag_name: "MSG_INVITE"
      // "message_action": "WECHAT_SNS_JUMP_URL",
      // "game_data": "Android Game Data 测试数据",
      // "tail_scene": "MESSAGE_ACTION_SNS_CANVAS#Honor=94",
      // "weapp_id": "wx4a0a73ec028e47d7",
      // "game_tag": "INTLGameTag-Android",
    },
    o = Object.assign({}, t);
  return i === InGameChannel.FacebookGaming && (o.channel = InGameChannel.Facebook, r.mode = 1), i === InGameChannel.Garena && (r.mediaTagName = "33", r.caption = "33", r.fbObjectId = "678764172195159", r.subChannel = (n = t.subChannel) !== null && n !== void 0 ? n : "must-have-it"), isiOS() && (r.isAssetURL = "0"), i === InGameChannel.Discord && (r.secret = "secret", r.partyId = "party97593664", r.partyMax = "6"), o.extraJson = JSON.stringify(r), o.packageName = (e = t.packageName) !== null && e !== void 0 ? e : "com.intlgame.sample", removeEmtpyAttr(o);
}
var share$1 = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  send: send,
  share: share
}, Symbol.toStringTag, {
  value: "Module"
}));
var bridge = IntlBridge.getInstance();
function closeWebView() {
  bridge.callNative({
    cmd: IntlCMD.CLOSE_WEBVIEW
  });
}
function setFullScreen(t) {
  t === void 0 && (t = !0), bridge.callNative({
    cmd: IntlCMD.SET_FULLSCREEN,
    req_data: {
      isFullScreen: t
    }
  });
}
function setScreenOrientation(t) {
  var n = {
    vertical: "1",
    horizonal: isiOS() ? "3" : "0"
    // 坑的一比
  };

  bridge.callNative({
    cmd: IntlCMD.SET_ORIENTATION,
    req_data: {
      screenOrientation: n[t]
    }
  });
}
function openInBrowser(t, n) {
  var e;
  isiOS() ? bridge.callNative({
    cmd: IntlCMD.OPEN_SAFARI,
    req_data: {
      URLInSafari: t
    }
  }) : isAndroid() ? bridge.callNative({
    cmd: IntlCMD.OPEN_BROWSER,
    req_data: {
      ParamKey: {
        url: t
      }
    }
  }) : isIntlWindows() ? bridge.callNative({
    cmd: IntlCMD.OPEN_BROWSER,
    req_data: {
      url: t
    }
  }) : window.open(t, (e = n == null ? void 0 : n.window_opentype) !== null && e !== void 0 ? e : "_blank");
}
function openApp(t, n) {
  t === "custom" ? window.open(n == null ? void 0 : n.custom_scheme, "_self") : window.open(AppURLSchemeMap[t], "_self");
}
var common = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
    __proto__: null,
    closeWebView: closeWebView,
    openApp: openApp,
    openInBrowser: openInBrowser,
    setFullScreen: setFullScreen,
    setScreenOrientation: setScreenOrientation
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  index = _assign(_assign(_assign(_assign({}, detect), share$1), common), constants);
var REGISTER_STATUS;
(function (t) {
  t[t.REGISTED = 1] = "REGISTED", t[t.UNREGIST = 0] = "UNREGIST";
})(REGISTER_STATUS || (REGISTER_STATUS = {}));
var SUBSCRIBE_STATUS;
(function (t) {
  t[t.SUBSCRIBE = 1] = "SUBSCRIBE", t[t.UNSUBSCRIBE = 0] = "UNSUBSCRIBE", t[t.NEW = -1] = "NEW";
})(SUBSCRIBE_STATUS || (SUBSCRIBE_STATUS = {}));
var Activity = /** @class */
  function (t) {
    __extends(n, t);
    function n(e) {
      var i = t.call(this, e) || this;
      return i.host = e.host, i.useSmartlink = e.useSmartlink || !1, i.gameevnet_type_id = e.gameevnet_type_id || "", i.intl_game_id = e.intl_game_id || "", i;
    }
    return n.prototype.getFullUrl = function (e) {
      return "".concat(this.host).concat(e);
    }, n.prototype.getUserInfo = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i,
          r,
          o = this;
        return __generator(this, function (a) {
          switch (a.label) {
            case 0:
              return i = e.authParams, [4, this.commonRequest(i).then(function (s) {
                return __awaiter(o, void 0, void 0, function () {
                  var l, u;
                  return __generator(this, function (d) {
                    switch (d.label) {
                      case 0:
                        return [4, this.sign_request({
                          url: "".concat(this.host).concat(ACTIVITY_URLS.get_user_info),
                          method: "POST",
                          headers: s,
                          data: {
                            type: e.type
                          }
                        })];
                      case 1:
                        return l = d.sent(), [4, this.responseHandle(l)];
                      case 2:
                        return u = d.sent(), [2, Object.assign(u, {
                          authParams: i
                        })];
                    }
                  });
                });
              })["catch"](function (s) {
                return Promise.reject(s);
              })];
            case 1:
              return r = a.sent(), [2, r];
          }
        });
      });
    }, n.prototype.getUserInfoV2 = function (e) {
      var i, r;
      return __awaiter(this, void 0, void 0, function () {
        var o, a, s, l, u;
        return __generator(this, function (d) {
          switch (d.label) {
            case 0:
              return o = !1, [4, this.getUserInfo(e)];
            case 1:
              return a = d.sent(), s = a.data.register_status === REGISTER_STATUS.REGISTED, !s || !this.useSmartlink ? (o = !!(a.data && a.data.info.email), [2, _assign(_assign({}, a.data), {
                is_subscribe: o,
                is_register: s
              })]) : !((r = (i = a.data) === null || i === void 0 ? void 0 : i.info) === null || r === void 0) && r.email ? [4, this.smartlinkUserInfo({
                authParams: e.authParams,
                biz_id: 1,
                type: 2,
                value: a.data.info.email
              })] : [2, _assign(_assign({}, a.data), {
                is_register: s,
                is_subscribe: !1
              })];
            case 2:
              return l = d.sent(), u = l == null ? void 0 : l.subscribe_state, o = Number(u) === SUBSCRIBE_STATUS.SUBSCRIBE, [2, _assign(_assign(_assign({}, a), l), {
                is_register: s,
                is_subscribe: o
              })];
          }
        });
      });
    }, n.prototype.register = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i,
          r = this;
        return __generator(this, function (o) {
          return i = this.commonRequest(e.authParams).then(function (a) {
            return __awaiter(r, void 0, void 0, function () {
              var s, l;
              return __generator(this, function (u) {
                switch (u.label) {
                  case 0:
                    return s = {
                      type: e.type
                    }, e != null && e.info && Object.assign(s, {
                      info: e.info
                    }), e != null && e.opt_type && Object.assign(s, {
                      opt_type: e.opt_type
                    }), [4, this.sign_request({
                      url: "".concat(this.host).concat(ACTIVITY_URLS.register),
                      method: "POST",
                      data: s,
                      headers: a
                    })];
                  case 1:
                    return l = u.sent(), [2, this.responseHandle(l)];
                }
              });
            });
          })["catch"](function (a) {
            return Promise.reject(a);
          }), [2, i];
        });
      });
    }, n.prototype.subscribe = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (i) {
          return [2, this.register(e)];
        });
      });
    }, n.prototype.smartlinkSubscibe = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i,
          r,
          o = this;
        return __generator(this, function (a) {
          return i = e.authParams, r = __rest(e, ["authParams"]), [2, this.commonRequest(i).then(function (s) {
            return __awaiter(o, void 0, void 0, function () {
              var l, u, d, h;
              return __generator(this, function (p) {
                switch (p.label) {
                  case 0:
                    return [4, this.sign_request({
                      url: this.getFullUrl(ACTIVITY_URLS.smartlink_subscribe),
                      method: "POST",
                      data: r,
                      headers: s
                    })];
                  case 1:
                    return l = p.sent(), u = l.code, d = l.msg, h = l.data, u !== 0 || (h == null ? void 0 : h.result) !== 0 ? (console.error("[cmssdk]:", d || (h == null ? void 0 : h.errmsg)), [2, Promise.reject(d || h.errmsg)]) : [2, h];
                }
              });
            });
          })];
        });
      });
    }, n.prototype.smartlinkUserInfo = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i,
          r,
          o = this;
        return __generator(this, function (a) {
          return i = e.authParams, r = __rest(e, ["authParams"]), [2, this.commonRequest(i).then(function (s) {
            return __awaiter(o, void 0, void 0, function () {
              var l, u, d, h, p;
              return __generator(this, function (m) {
                switch (m.label) {
                  case 0:
                    return [4, this.sign_request({
                      url: this.getFullUrl(ACTIVITY_URLS.get_smartlink_info),
                      method: "POST",
                      data: r,
                      headers: s
                    })];
                  case 1:
                    return l = m.sent(), u = l.code, d = l.data, h = l.msg, u !== 0 || (d == null ? void 0 : d.result) !== 0 ? (console.error("[cmssdk]:", h || (d == null ? void 0 : d.errmsg)), [2, Promise.reject(h || (d == null ? void 0 : d.errmsg))]) : [2, ((p = JSON.parse(d.smart_link_rsp)) === null || p === void 0 ? void 0 : p.data) || {}];
                }
              });
            });
          })];
        });
      });
    }, n.prototype.subscribeActive = function (e, i) {
      return __awaiter(this, void 0, void 0, function () {
        var r, o, a, s, l, u, d;
        return __generator(this, function (h) {
          switch (h.label) {
            case 0:
              return r = e.gameevent, o = e.smartlink, a = o === void 0 ? {} : o, s = e.baseInfo, l = e.authParams, [4, this.getUserInfoV2(_assign(_assign({}, s), {
                authParams: l
              }))];
            case 1:
              return u = h.sent(), u.is_register ? [3, 3] : [4, this.register(Object.assign(s, {
                authParams: l
              }))];
            case 2:
              h.sent(), h.label = 3;
            case 3:
              return u.is_subscribe ? [3, 10] : [4, new Promise(function (p, m) {
                i({
                  error: "UNSUBSCRIBE"
                }, p, m);
              })];
            case 4:
              return d = h.sent() || {}, Object.keys(a).length > 0 ? (a.report_info && Object.assign(a.report_info, _assign({}, d)), [4, this.smartlinkSubscibe(_assign(_assign({}, a), {
                authParams: l
              }))]) : [3, 6];
            case 5:
              h.sent(), h.label = 6;
            case 6:
              return this.register(_assign(_assign({}, s), {
                info: {
                  email: d.email,
                  ext_info: JSON.stringify(a.report_info)
                },
                authParams: l
              })), r ? [4, this.officialApply(_assign(_assign({}, r), {
                email: d.email
              }))] : [3, 8];
            case 7:
              h.sent(), h.label = 8;
            case 8:
              return [4, new Promise(function (p, m) {
                i({
                  error: "SUBSCRIBED_SUCCESS"
                }, p, m);
              })];
            case 9:
              return [2, h.sent()];
            case 10:
              return [2, new Promise(function (p, m) {
                return i({
                  error: "HAS_SUBSCRIBED"
                }, p, m);
              })];
          }
        });
      });
    }, n.prototype.smartlinkSyncUserByEmail = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i = this;
        return __generator(this, function (r) {
          return [2, this.commonRequest(e.authParams).then(function (o) {
            return __awaiter(i, void 0, void 0, function () {
              var a;
              return __generator(this, function (s) {
                switch (s.label) {
                  case 0:
                    return a = Object.assign({}, e), a.content && (a.content = JSON.stringify(e.content)), [4, this.sign_request({
                      url: this.getFullUrl(ACTIVITY_URLS.smartlink_sync_user_by_email),
                      method: "POST",
                      data: a,
                      headers: o
                    })];
                  case 1:
                    return [2, s.sent()];
                }
              });
            });
          })];
        });
      });
    }, n.prototype.commonRequest = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i = this;
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return !e || Object.keys(e).length === 0 ? [2, Promise.resolve({})] : this.ticket ? [3, 2] : [4, this.loginByIntlToken(e).then(function () {
                return {
                  "X-Ticket": i.ticket,
                  "X-uid": i.uid
                };
              })];
            case 1:
              return [2, r.sent()];
            case 2:
              return [2, Promise.resolve({
                "X-Ticket": this.ticket,
                "X-uid": this.uid
              })];
          }
        });
      });
    }, n.prototype.responseHandle = function (e) {
      return __awaiter(this, void 0, void 0, function () {
        var i, r, o;
        return __generator(this, function (a) {
          return i = e.code, r = e.data, o = e.msg, i !== 0 && (console.error("[cmssdk]:", {
            error: o,
            errorCode: i,
            response: e
          }), Promise.reject({
            error: o,
            errorCode: i,
            response: e
          })), r.result !== 0 && Promise.reject({
            error: r.errmsg,
            errorCode: r.result,
            response: e
          }), [2, {
            data: r
          }];
        });
      });
    }, n;
  }(PaBaseHelper),
  isLoading = !1,
  callbackFunctions = [];
function getAssesPath(t) {
  var n = "https://common-web.intlgame.com/sdk-cdn/infinite-pass/latest/index.umd.js",
    e = "https://common-web.intlgame.com/sdk-cdn/infinite-pass/latest/index.css",
    i = t === "dev" || t === "test";
  return i && (n = "https://test-common-web.intlgame.com/sdk-cdn/infinite-pass/latest/index.umd.js", e = "https://test-common-web.intlgame.com/sdk-cdn/infinite-pass/latest/index.css"), {
    js: n,
    css: e
  };
}
function loadAssets(t, n) {
  if (window.PassFactory) return n();
  if (callbackFunctions.push(n), !isLoading) {
    isLoading = !0;
    var e = getAssesPath(t),
      i = e.css,
      r = e.js,
      o = document.createElement("script");
    o.src = r;
    var a = document.createElement("link");
    a.href = i, a.rel = "stylesheet";
    var s = document.createElement("style");
    s.type = "text/css";
    var l = document.querySelector("head");
    o.onload = function () {
      for (isLoading = !1; callbackFunctions.length > 0;) {
        var u = callbackFunctions.pop();
        u();
      }
    }, l == null || l.prepend(s), l == null || l.prepend(a), l == null || l.appendChild(o);
  }
}
var IntlLogin = /** @class */
function () {
  function t(n) {
    this.events = [], this.opts = n;
  }
  return t.prototype.setConfig = function (n) {
    Object.assign(this.opts, n);
  }, t.prototype.loadSDK = function () {
    return __awaiter(this, void 0, void 0, function () {
      var n = this;
      return __generator(this, function (e) {
        return [2, new Promise(function (i) {
          loadAssets(n.opts.env, function () {
            var r = new window.PassFactory.Pass(n.opts);
            i({
              sdk: r
            });
          });
        })];
      });
    });
  }, t.prototype.storageUser = function (n) {
    window.localStorage.setItem("lip-user-info", JSON.stringify(n));
  }, t.prototype.login = function (n, e) {
    return __awaiter(this, void 0, void 0, function () {
      var i,
        r = this;
      return __generator(this, function (o) {
        switch (o.label) {
          case 0:
            return e && this.setConfig(e), [4, this.loadSDK()];
          case 1:
            return i = o.sent().sdk, this.intlOriginSdk = i, this.events.forEach(function (a) {
              r.intlOriginSdk.on(a.key, a.callback);
            }), this.events.length = 0, [2, new Promise(function (a, s) {
              setTimeout(function () {
                i.start(n).then(function (l) {
                  a(l), r.storageUser(l), i.unmount();
                })["catch"](s);
              }, 0);
            })];
        }
      });
    });
  }, t.prototype.checkLogin = function () {
    return !!this.getUser();
  }, t.prototype.getUser = function () {
    var n = window.localStorage.getItem("lip-user-info");
    return n ? JSON.parse(n) : null;
  }, t.prototype.logout = function () {
    window.localStorage.removeItem("lip-user-info");
  }, t.prototype.on = function (n, e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (i) {
        return this.intlOriginSdk ? this.intlOriginSdk(n, e) : this.events.push({
          key: n,
          callback: e
        }), [2
        /*return*/];
      });
    });
  }, t;
}();
function initSdks(t) {
  var n = t.common_config,
    e = t.cms_config,
    i = t.intl_account_config,
    r = t.intl_email_config,
    o,
    a,
    s = CmsCustomRum.getInstance(n),
    l = e.cms_areaid,
    u = e.cms_lang,
    d = e.cms_gameid,
    h = e.custom_cms_url,
    p = e.source_type,
    m = p === void 0 ? SourceType.PC_WEB : p,
    R = new CmsHelper({
      lang: u,
      cms_gameid: d,
      source_type: m,
      custom_cms_url: h,
      area_id: l
    }),
    T = i !== null && i !== void 0 ? i : {},
    O = T.intl_gameid,
    N = T.intl_account_area_id,
    y = T.extra_config;
  O && N && (a = new IntlSevice({
    game_id: O,
    area_id: N,
    extra_config: y
  }));
  var f = r !== null && r !== void 0 ? r : {},
    g = f.intl_gameid,
    E = f.intl_email_area_id,
    A = f.email_sig,
    w = A === void 0 ? "" : A,
    k = f.email_typeid,
    P = k === void 0 ? "" : k;
  return g && E && (o = new IntlEmailSevice({
    sig: w,
    typeid: P,
    game_id: g,
    area_id: E
  })), {
    cms_helper: R,
    intl_email_helper: o,
    intl_account_helper: a,
    rum_reporter: s.getAegies()
  };
}
var SiteHelper = /** @class */
  function () {
    function t(n) {
      var e, i, r, o, a, s, l, u, d, h, p, m;
      console.warn("Cmssdk.default will be deprecated."), deprecatedLog("initSdks");
      var R = initSdks({
          cms_config: {
            cms_gameid: n.cms_gameid,
            cms_areaid: n.cms_areaid,
            cms_lang: n.cms_lang,
            source_type: n.source_type,
            custom_cms_url: n.custom_cms_url
          },
          // initsdks 有判断
          intl_account_config: {
            intl_gameid: (e = n.intl_gameid) !== null && e !== void 0 ? e : "",
            intl_account_area_id: (i = n.account_area_id) !== null && i !== void 0 ? i : ""
          },
          // initsdks 有判断
          intl_email_config: {
            email_sig: "",
            email_typeid: "",
            intl_gameid: (r = n.intl_gameid) !== null && r !== void 0 ? r : "",
            intl_email_area_id: (o = n.intl_area_id) !== null && o !== void 0 ? o : ""
          },
          common_config: {
            rum_id: n.rum_id,
            rum_host: n.rum_host
          }
        }),
        T = R.cms_helper,
        O = R.intl_account_helper,
        N = R.intl_email_helper;
      this.cms_helper = T, this.account_helper = O, this.intl_helper = N, this.setHeaders = this.cms_helper.setHeaders.bind(this.cms_helper), this.swtichArea = this.cms_helper.switchArea.bind(this.cms_helper), this.switchLang = this.cms_helper.switchLang.bind(this.cms_helper), this.tlogReport = this.cms_helper.tlogReport.bind(this.cms_helper), this.getFeedDetail = this.cms_helper.getFeedsDetail.bind(this.cms_helper), this.getFeesDetail = this.cms_helper.getFeedsDetail.bind(this.cms_helper), this.goDetailLink = CmsHelper.goDetailLink.bind(this.cms_helper), this.initDetailPage = this.cms_helper.initDetailPage.bind(this.cms_helper), this.getCmsVideoInfo = this.cms_helper.getCmsVideoInfo.bind(this.cms_helper), this.getColumns = this.cms_helper.getColumns.bind(this.cms_helper), this.getFeedsByColumns = this.cms_helper.getFeedsByColumns.bind(this.cms_helper), this.getBackgroundImg = this.cms_helper.getBackgroundImg.bind(this.cms_helper), this.getColumnByName = this.cms_helper.getColumnByName.bind(this.cms_helper), this.getPreRegUserCount = this.cms_helper.getPreRegUserCount.bind(this.cms_helper), this.getRandomCode = this.cms_helper.getRandomCode.bind(this.cms_helper), this.officialApply = this.cms_helper.officialApply.bind(this.cms_helper), this.officialUnEmail = this.cms_helper.officialUnEmail.bind(this.cms_helper), this.captchaVerify = this.cms_helper.captchaVerify.bind(this.cms_helper), this.verifyLogin = this.cms_helper.verifyLogin.bind(this.cms_helper), this.getNewsManager = this.cms_helper.getNewsManager.bind(this.cms_helper), this.verifyTXCaptcha = this.cms_helper.verifyTXCaptcha.bind(this.cms_helper), this.getMediaLabel = this.cms_helper.getMediaLabel.bind(this.cms_helper), this.getMediaData = this.cms_helper.getMediaData.bind(this.cms_helper), this.useJumpMethod = this.cms_helper.useJumpMethod.bind(this.cms_helper), this.useAiHelp = getAiHelper, this.emailApply = (s = (a = this.intl_helper) === null || a === void 0 ? void 0 : a.emailApply) === null || s === void 0 ? void 0 : s.bind(this.intl_helper), this.setIntlGameId = (u = (l = this.intl_helper) === null || l === void 0 ? void 0 : l.setAreaId) === null || u === void 0 ? void 0 : u.bind(this.intl_helper), this.thirdLogin = (h = (d = this.account_helper) === null || d === void 0 ? void 0 : d.thirdLogin) === null || h === void 0 ? void 0 : h.bind(this.account_helper), this.share = (m = (p = this.account_helper) === null || p === void 0 ? void 0 : p.share) === null || m === void 0 ? void 0 : m.bind(this.account_helper);
    }
    return t;
  }(),
  ENV = ENV$1();
try {
  debug(), console.log("[Cms-helper]: Version-".concat(Version, " initialized")), cms_custom_aegis.report({
    level: LogLevel.COMMON,
    msg: location.href
  });
} catch (t) {
  console.error(t);
}
export { IntlSevice as AccountHelper, Aegis, CHANNEL_STORAGE_KEY, CMS_ENV, ChannelIdMap, CmsContentProcessor, CmsHelper, ContentClass, ENV, Embed, EnvController, IGetCosUrlTokenType, IntlSevice as IntlAccountHelper, IntlEmailSevice as IntlEmailService, IntlLogin, IntlEmailSevice as IntlSevice, LikeBiz, LikeOp, LinkType, OrderType, RandomCodeAccountType, Activity as Register, SourceType, UAParser, Version, appendScript, imageOpt as cms_img_utils, createUrlSearchParam, dataURLtoFile, SiteHelper as default, download, getAiHelper, getBrowserName, getFormatDateString, getPlainString, getQuery, getRetErrorMsgByUrl, getSpecialBrowserType, getSys, index as ingame, initSdks, injectElement, injectStyle, isDom, isEmail, isMobile, putRequest, removeElement, replaceTimeStampTag, request, shouldUseSinglePageLogin, supportFile, throttlePromise, useTXCaptcha };
